// source: cacheclient.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var proto = {};

goog.exportSymbol('ECacheResult', null, proto);
goog.exportSymbol('_DeleteRequest', null, proto);
goog.exportSymbol('_DeleteResponse', null, proto);
goog.exportSymbol('_DictionaryDeleteRequest', null, proto);
goog.exportSymbol('_DictionaryDeleteRequest.All', null, proto);
goog.exportSymbol('_DictionaryDeleteRequest.DeleteCase', null, proto);
goog.exportSymbol('_DictionaryDeleteRequest.Some', null, proto);
goog.exportSymbol('_DictionaryDeleteResponse', null, proto);
goog.exportSymbol('_DictionaryFetchRequest', null, proto);
goog.exportSymbol('_DictionaryFetchResponse', null, proto);
goog.exportSymbol('_DictionaryFetchResponse.DictionaryCase', null, proto);
goog.exportSymbol('_DictionaryFetchResponse._Found', null, proto);
goog.exportSymbol('_DictionaryFetchResponse._Missing', null, proto);
goog.exportSymbol('_DictionaryFieldValuePair', null, proto);
goog.exportSymbol('_DictionaryGetRequest', null, proto);
goog.exportSymbol('_DictionaryGetResponse', null, proto);
goog.exportSymbol('_DictionaryGetResponse.DictionaryCase', null, proto);
goog.exportSymbol('_DictionaryGetResponse._DictionaryGetResponsePart', null, proto);
goog.exportSymbol('_DictionaryGetResponse._Found', null, proto);
goog.exportSymbol('_DictionaryGetResponse._Missing', null, proto);
goog.exportSymbol('_DictionaryIncrementRequest', null, proto);
goog.exportSymbol('_DictionaryIncrementResponse', null, proto);
goog.exportSymbol('_DictionaryLengthRequest', null, proto);
goog.exportSymbol('_DictionaryLengthResponse', null, proto);
goog.exportSymbol('_DictionaryLengthResponse.DictionaryCase', null, proto);
goog.exportSymbol('_DictionaryLengthResponse._Found', null, proto);
goog.exportSymbol('_DictionaryLengthResponse._Missing', null, proto);
goog.exportSymbol('_DictionarySetRequest', null, proto);
goog.exportSymbol('_DictionarySetResponse', null, proto);
goog.exportSymbol('_GetRequest', null, proto);
goog.exportSymbol('_GetResponse', null, proto);
goog.exportSymbol('_IncrementRequest', null, proto);
goog.exportSymbol('_IncrementResponse', null, proto);
goog.exportSymbol('_ItemGetTtlRequest', null, proto);
goog.exportSymbol('_ItemGetTtlResponse', null, proto);
goog.exportSymbol('_ItemGetTtlResponse.ResultCase', null, proto);
goog.exportSymbol('_ItemGetTtlResponse._Found', null, proto);
goog.exportSymbol('_ItemGetTtlResponse._Missing', null, proto);
goog.exportSymbol('_ItemGetTypeRequest', null, proto);
goog.exportSymbol('_ItemGetTypeResponse', null, proto);
goog.exportSymbol('_ItemGetTypeResponse.ItemType', null, proto);
goog.exportSymbol('_ItemGetTypeResponse.ResultCase', null, proto);
goog.exportSymbol('_ItemGetTypeResponse._Found', null, proto);
goog.exportSymbol('_ItemGetTypeResponse._Missing', null, proto);
goog.exportSymbol('_KeysExistRequest', null, proto);
goog.exportSymbol('_KeysExistResponse', null, proto);
goog.exportSymbol('_ListConcatenateBackRequest', null, proto);
goog.exportSymbol('_ListConcatenateBackResponse', null, proto);
goog.exportSymbol('_ListConcatenateFrontRequest', null, proto);
goog.exportSymbol('_ListConcatenateFrontResponse', null, proto);
goog.exportSymbol('_ListEraseRequest', null, proto);
goog.exportSymbol('_ListEraseRequest.EraseCase', null, proto);
goog.exportSymbol('_ListEraseRequest._All', null, proto);
goog.exportSymbol('_ListEraseRequest._ListRanges', null, proto);
goog.exportSymbol('_ListEraseResponse', null, proto);
goog.exportSymbol('_ListEraseResponse.ListCase', null, proto);
goog.exportSymbol('_ListEraseResponse._Found', null, proto);
goog.exportSymbol('_ListEraseResponse._Missing', null, proto);
goog.exportSymbol('_ListFetchRequest', null, proto);
goog.exportSymbol('_ListFetchRequest.EndIndexCase', null, proto);
goog.exportSymbol('_ListFetchRequest.StartIndexCase', null, proto);
goog.exportSymbol('_ListFetchResponse', null, proto);
goog.exportSymbol('_ListFetchResponse.ListCase', null, proto);
goog.exportSymbol('_ListFetchResponse._Found', null, proto);
goog.exportSymbol('_ListFetchResponse._Missing', null, proto);
goog.exportSymbol('_ListLengthRequest', null, proto);
goog.exportSymbol('_ListLengthResponse', null, proto);
goog.exportSymbol('_ListLengthResponse.ListCase', null, proto);
goog.exportSymbol('_ListLengthResponse._Found', null, proto);
goog.exportSymbol('_ListLengthResponse._Missing', null, proto);
goog.exportSymbol('_ListPopBackRequest', null, proto);
goog.exportSymbol('_ListPopBackResponse', null, proto);
goog.exportSymbol('_ListPopBackResponse.ListCase', null, proto);
goog.exportSymbol('_ListPopBackResponse._Found', null, proto);
goog.exportSymbol('_ListPopBackResponse._Missing', null, proto);
goog.exportSymbol('_ListPopFrontRequest', null, proto);
goog.exportSymbol('_ListPopFrontResponse', null, proto);
goog.exportSymbol('_ListPopFrontResponse.ListCase', null, proto);
goog.exportSymbol('_ListPopFrontResponse._Found', null, proto);
goog.exportSymbol('_ListPopFrontResponse._Missing', null, proto);
goog.exportSymbol('_ListPushBackRequest', null, proto);
goog.exportSymbol('_ListPushBackResponse', null, proto);
goog.exportSymbol('_ListPushFrontRequest', null, proto);
goog.exportSymbol('_ListPushFrontResponse', null, proto);
goog.exportSymbol('_ListRange', null, proto);
goog.exportSymbol('_ListRemoveRequest', null, proto);
goog.exportSymbol('_ListRemoveRequest.RemoveCase', null, proto);
goog.exportSymbol('_ListRemoveResponse', null, proto);
goog.exportSymbol('_ListRemoveResponse.ListCase', null, proto);
goog.exportSymbol('_ListRemoveResponse._Found', null, proto);
goog.exportSymbol('_ListRemoveResponse._Missing', null, proto);
goog.exportSymbol('_ListRetainRequest', null, proto);
goog.exportSymbol('_ListRetainRequest.EndIndexCase', null, proto);
goog.exportSymbol('_ListRetainRequest.StartIndexCase', null, proto);
goog.exportSymbol('_ListRetainResponse', null, proto);
goog.exportSymbol('_ListRetainResponse.ListCase', null, proto);
goog.exportSymbol('_ListRetainResponse._Found', null, proto);
goog.exportSymbol('_ListRetainResponse._Missing', null, proto);
goog.exportSymbol('_SetContainsRequest', null, proto);
goog.exportSymbol('_SetContainsResponse', null, proto);
goog.exportSymbol('_SetContainsResponse.SetCase', null, proto);
goog.exportSymbol('_SetContainsResponse._Found', null, proto);
goog.exportSymbol('_SetContainsResponse._Missing', null, proto);
goog.exportSymbol('_SetDifferenceRequest', null, proto);
goog.exportSymbol('_SetDifferenceRequest.DifferenceCase', null, proto);
goog.exportSymbol('_SetDifferenceRequest._Minuend', null, proto);
goog.exportSymbol('_SetDifferenceRequest._Subtrahend', null, proto);
goog.exportSymbol('_SetDifferenceRequest._Subtrahend.SubtrahendSetCase', null, proto);
goog.exportSymbol('_SetDifferenceRequest._Subtrahend._Identity', null, proto);
goog.exportSymbol('_SetDifferenceRequest._Subtrahend._Set', null, proto);
goog.exportSymbol('_SetDifferenceResponse', null, proto);
goog.exportSymbol('_SetDifferenceResponse.SetCase', null, proto);
goog.exportSymbol('_SetDifferenceResponse._Found', null, proto);
goog.exportSymbol('_SetDifferenceResponse._Missing', null, proto);
goog.exportSymbol('_SetFetchRequest', null, proto);
goog.exportSymbol('_SetFetchResponse', null, proto);
goog.exportSymbol('_SetFetchResponse.SetCase', null, proto);
goog.exportSymbol('_SetFetchResponse._Found', null, proto);
goog.exportSymbol('_SetFetchResponse._Missing', null, proto);
goog.exportSymbol('_SetIfNotExistsRequest', null, proto);
goog.exportSymbol('_SetIfNotExistsResponse', null, proto);
goog.exportSymbol('_SetIfNotExistsResponse.ResultCase', null, proto);
goog.exportSymbol('_SetIfNotExistsResponse._NotStored', null, proto);
goog.exportSymbol('_SetIfNotExistsResponse._Stored', null, proto);
goog.exportSymbol('_SetLengthRequest', null, proto);
goog.exportSymbol('_SetLengthResponse', null, proto);
goog.exportSymbol('_SetLengthResponse.SetCase', null, proto);
goog.exportSymbol('_SetLengthResponse._Found', null, proto);
goog.exportSymbol('_SetLengthResponse._Missing', null, proto);
goog.exportSymbol('_SetPopRequest', null, proto);
goog.exportSymbol('_SetPopResponse', null, proto);
goog.exportSymbol('_SetPopResponse.SetCase', null, proto);
goog.exportSymbol('_SetPopResponse._Found', null, proto);
goog.exportSymbol('_SetPopResponse._Missing', null, proto);
goog.exportSymbol('_SetRequest', null, proto);
goog.exportSymbol('_SetResponse', null, proto);
goog.exportSymbol('_SetUnionRequest', null, proto);
goog.exportSymbol('_SetUnionResponse', null, proto);
goog.exportSymbol('_SortedSetElement', null, proto);
goog.exportSymbol('_SortedSetFetchRequest', null, proto);
goog.exportSymbol('_SortedSetFetchRequest.Order', null, proto);
goog.exportSymbol('_SortedSetFetchRequest.RangeCase', null, proto);
goog.exportSymbol('_SortedSetFetchRequest._ByIndex', null, proto);
goog.exportSymbol('_SortedSetFetchRequest._ByIndex.EndCase', null, proto);
goog.exportSymbol('_SortedSetFetchRequest._ByIndex.StartCase', null, proto);
goog.exportSymbol('_SortedSetFetchRequest._ByScore', null, proto);
goog.exportSymbol('_SortedSetFetchRequest._ByScore.MaxCase', null, proto);
goog.exportSymbol('_SortedSetFetchRequest._ByScore.MinCase', null, proto);
goog.exportSymbol('_SortedSetFetchRequest._ByScore._Score', null, proto);
goog.exportSymbol('_SortedSetFetchResponse', null, proto);
goog.exportSymbol('_SortedSetFetchResponse.SortedSetCase', null, proto);
goog.exportSymbol('_SortedSetFetchResponse._Found', null, proto);
goog.exportSymbol('_SortedSetFetchResponse._Found.ElementsCase', null, proto);
goog.exportSymbol('_SortedSetFetchResponse._Found._Values', null, proto);
goog.exportSymbol('_SortedSetFetchResponse._Found._ValuesWithScores', null, proto);
goog.exportSymbol('_SortedSetFetchResponse._Missing', null, proto);
goog.exportSymbol('_SortedSetGetRankRequest', null, proto);
goog.exportSymbol('_SortedSetGetRankRequest.Order', null, proto);
goog.exportSymbol('_SortedSetGetRankResponse', null, proto);
goog.exportSymbol('_SortedSetGetRankResponse.RankCase', null, proto);
goog.exportSymbol('_SortedSetGetRankResponse._RankResponsePart', null, proto);
goog.exportSymbol('_SortedSetGetRankResponse._SortedSetMissing', null, proto);
goog.exportSymbol('_SortedSetGetScoreRequest', null, proto);
goog.exportSymbol('_SortedSetGetScoreResponse', null, proto);
goog.exportSymbol('_SortedSetGetScoreResponse.SortedSetCase', null, proto);
goog.exportSymbol('_SortedSetGetScoreResponse._SortedSetFound', null, proto);
goog.exportSymbol('_SortedSetGetScoreResponse._SortedSetGetScoreResponsePart', null, proto);
goog.exportSymbol('_SortedSetGetScoreResponse._SortedSetMissing', null, proto);
goog.exportSymbol('_SortedSetIncrementRequest', null, proto);
goog.exportSymbol('_SortedSetIncrementResponse', null, proto);
goog.exportSymbol('_SortedSetLengthByScoreRequest', null, proto);
goog.exportSymbol('_SortedSetLengthByScoreRequest.MaxCase', null, proto);
goog.exportSymbol('_SortedSetLengthByScoreRequest.MinCase', null, proto);
goog.exportSymbol('_SortedSetLengthByScoreResponse', null, proto);
goog.exportSymbol('_SortedSetLengthByScoreResponse.SortedSetCase', null, proto);
goog.exportSymbol('_SortedSetLengthByScoreResponse._Found', null, proto);
goog.exportSymbol('_SortedSetLengthByScoreResponse._Missing', null, proto);
goog.exportSymbol('_SortedSetLengthRequest', null, proto);
goog.exportSymbol('_SortedSetLengthResponse', null, proto);
goog.exportSymbol('_SortedSetLengthResponse.SortedSetCase', null, proto);
goog.exportSymbol('_SortedSetLengthResponse._Found', null, proto);
goog.exportSymbol('_SortedSetLengthResponse._Missing', null, proto);
goog.exportSymbol('_SortedSetPutRequest', null, proto);
goog.exportSymbol('_SortedSetPutResponse', null, proto);
goog.exportSymbol('_SortedSetRemoveRequest', null, proto);
goog.exportSymbol('_SortedSetRemoveRequest.RemoveElementsCase', null, proto);
goog.exportSymbol('_SortedSetRemoveRequest._All', null, proto);
goog.exportSymbol('_SortedSetRemoveRequest._Some', null, proto);
goog.exportSymbol('_SortedSetRemoveResponse', null, proto);
goog.exportSymbol('_Unbounded', null, proto);
goog.exportSymbol('_UpdateTtlRequest', null, proto);
goog.exportSymbol('_UpdateTtlRequest.UpdateTtlCase', null, proto);
goog.exportSymbol('_UpdateTtlResponse', null, proto);
goog.exportSymbol('_UpdateTtlResponse.ResultCase', null, proto);
goog.exportSymbol('_UpdateTtlResponse._Missing', null, proto);
goog.exportSymbol('_UpdateTtlResponse._NotSet', null, proto);
goog.exportSymbol('_UpdateTtlResponse._Set', null, proto);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._GetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._GetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._GetRequest.displayName = 'proto._GetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._GetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._GetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._GetResponse.displayName = 'proto._GetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DeleteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DeleteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DeleteRequest.displayName = 'proto._DeleteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DeleteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DeleteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DeleteResponse.displayName = 'proto._DeleteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetRequest.displayName = 'proto._SetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetResponse.displayName = 'proto._SetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetIfNotExistsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetIfNotExistsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetIfNotExistsRequest.displayName = 'proto._SetIfNotExistsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetIfNotExistsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SetIfNotExistsResponse.oneofGroups_);
};
goog.inherits(proto._SetIfNotExistsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetIfNotExistsResponse.displayName = 'proto._SetIfNotExistsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetIfNotExistsResponse._Stored = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetIfNotExistsResponse._Stored, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetIfNotExistsResponse._Stored.displayName = 'proto._SetIfNotExistsResponse._Stored';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetIfNotExistsResponse._NotStored = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetIfNotExistsResponse._NotStored, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetIfNotExistsResponse._NotStored.displayName = 'proto._SetIfNotExistsResponse._NotStored';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._KeysExistRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._KeysExistRequest.repeatedFields_, null);
};
goog.inherits(proto._KeysExistRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._KeysExistRequest.displayName = 'proto._KeysExistRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._KeysExistResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._KeysExistResponse.repeatedFields_, null);
};
goog.inherits(proto._KeysExistResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._KeysExistResponse.displayName = 'proto._KeysExistResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._IncrementRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._IncrementRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._IncrementRequest.displayName = 'proto._IncrementRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._IncrementResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._IncrementResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._IncrementResponse.displayName = 'proto._IncrementResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._UpdateTtlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._UpdateTtlRequest.oneofGroups_);
};
goog.inherits(proto._UpdateTtlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._UpdateTtlRequest.displayName = 'proto._UpdateTtlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._UpdateTtlResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._UpdateTtlResponse.oneofGroups_);
};
goog.inherits(proto._UpdateTtlResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._UpdateTtlResponse.displayName = 'proto._UpdateTtlResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._UpdateTtlResponse._Set = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._UpdateTtlResponse._Set, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._UpdateTtlResponse._Set.displayName = 'proto._UpdateTtlResponse._Set';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._UpdateTtlResponse._NotSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._UpdateTtlResponse._NotSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._UpdateTtlResponse._NotSet.displayName = 'proto._UpdateTtlResponse._NotSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._UpdateTtlResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._UpdateTtlResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._UpdateTtlResponse._Missing.displayName = 'proto._UpdateTtlResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ItemGetTtlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ItemGetTtlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ItemGetTtlRequest.displayName = 'proto._ItemGetTtlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ItemGetTtlResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ItemGetTtlResponse.oneofGroups_);
};
goog.inherits(proto._ItemGetTtlResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ItemGetTtlResponse.displayName = 'proto._ItemGetTtlResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ItemGetTtlResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ItemGetTtlResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ItemGetTtlResponse._Found.displayName = 'proto._ItemGetTtlResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ItemGetTtlResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ItemGetTtlResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ItemGetTtlResponse._Missing.displayName = 'proto._ItemGetTtlResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ItemGetTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ItemGetTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ItemGetTypeRequest.displayName = 'proto._ItemGetTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ItemGetTypeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ItemGetTypeResponse.oneofGroups_);
};
goog.inherits(proto._ItemGetTypeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ItemGetTypeResponse.displayName = 'proto._ItemGetTypeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ItemGetTypeResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ItemGetTypeResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ItemGetTypeResponse._Found.displayName = 'proto._ItemGetTypeResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ItemGetTypeResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ItemGetTypeResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ItemGetTypeResponse._Missing.displayName = 'proto._ItemGetTypeResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryGetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._DictionaryGetRequest.repeatedFields_, null);
};
goog.inherits(proto._DictionaryGetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryGetRequest.displayName = 'proto._DictionaryGetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryGetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._DictionaryGetResponse.oneofGroups_);
};
goog.inherits(proto._DictionaryGetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryGetResponse.displayName = 'proto._DictionaryGetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryGetResponse._DictionaryGetResponsePart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryGetResponse._DictionaryGetResponsePart.displayName = 'proto._DictionaryGetResponse._DictionaryGetResponsePart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryGetResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._DictionaryGetResponse._Found.repeatedFields_, null);
};
goog.inherits(proto._DictionaryGetResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryGetResponse._Found.displayName = 'proto._DictionaryGetResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryGetResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryGetResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryGetResponse._Missing.displayName = 'proto._DictionaryGetResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryFetchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryFetchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryFetchRequest.displayName = 'proto._DictionaryFetchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryFieldValuePair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryFieldValuePair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryFieldValuePair.displayName = 'proto._DictionaryFieldValuePair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryFetchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._DictionaryFetchResponse.oneofGroups_);
};
goog.inherits(proto._DictionaryFetchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryFetchResponse.displayName = 'proto._DictionaryFetchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryFetchResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._DictionaryFetchResponse._Found.repeatedFields_, null);
};
goog.inherits(proto._DictionaryFetchResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryFetchResponse._Found.displayName = 'proto._DictionaryFetchResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryFetchResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryFetchResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryFetchResponse._Missing.displayName = 'proto._DictionaryFetchResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionarySetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._DictionarySetRequest.repeatedFields_, null);
};
goog.inherits(proto._DictionarySetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionarySetRequest.displayName = 'proto._DictionarySetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionarySetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionarySetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionarySetResponse.displayName = 'proto._DictionarySetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryIncrementRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryIncrementRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryIncrementRequest.displayName = 'proto._DictionaryIncrementRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryIncrementResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryIncrementResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryIncrementResponse.displayName = 'proto._DictionaryIncrementResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryDeleteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._DictionaryDeleteRequest.oneofGroups_);
};
goog.inherits(proto._DictionaryDeleteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryDeleteRequest.displayName = 'proto._DictionaryDeleteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryDeleteRequest.Some = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._DictionaryDeleteRequest.Some.repeatedFields_, null);
};
goog.inherits(proto._DictionaryDeleteRequest.Some, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryDeleteRequest.Some.displayName = 'proto._DictionaryDeleteRequest.Some';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryDeleteRequest.All = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryDeleteRequest.All, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryDeleteRequest.All.displayName = 'proto._DictionaryDeleteRequest.All';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryDeleteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryDeleteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryDeleteResponse.displayName = 'proto._DictionaryDeleteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryLengthRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryLengthRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryLengthRequest.displayName = 'proto._DictionaryLengthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryLengthResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._DictionaryLengthResponse.oneofGroups_);
};
goog.inherits(proto._DictionaryLengthResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryLengthResponse.displayName = 'proto._DictionaryLengthResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryLengthResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryLengthResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryLengthResponse._Found.displayName = 'proto._DictionaryLengthResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._DictionaryLengthResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._DictionaryLengthResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._DictionaryLengthResponse._Missing.displayName = 'proto._DictionaryLengthResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetFetchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetFetchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetFetchRequest.displayName = 'proto._SetFetchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetFetchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SetFetchResponse.oneofGroups_);
};
goog.inherits(proto._SetFetchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetFetchResponse.displayName = 'proto._SetFetchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetFetchResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SetFetchResponse._Found.repeatedFields_, null);
};
goog.inherits(proto._SetFetchResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetFetchResponse._Found.displayName = 'proto._SetFetchResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetFetchResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetFetchResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetFetchResponse._Missing.displayName = 'proto._SetFetchResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetUnionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SetUnionRequest.repeatedFields_, null);
};
goog.inherits(proto._SetUnionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetUnionRequest.displayName = 'proto._SetUnionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetUnionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetUnionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetUnionResponse.displayName = 'proto._SetUnionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetDifferenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SetDifferenceRequest.oneofGroups_);
};
goog.inherits(proto._SetDifferenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetDifferenceRequest.displayName = 'proto._SetDifferenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetDifferenceRequest._Minuend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SetDifferenceRequest._Minuend.repeatedFields_, null);
};
goog.inherits(proto._SetDifferenceRequest._Minuend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetDifferenceRequest._Minuend.displayName = 'proto._SetDifferenceRequest._Minuend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetDifferenceRequest._Subtrahend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SetDifferenceRequest._Subtrahend.oneofGroups_);
};
goog.inherits(proto._SetDifferenceRequest._Subtrahend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetDifferenceRequest._Subtrahend.displayName = 'proto._SetDifferenceRequest._Subtrahend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetDifferenceRequest._Subtrahend._Set = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SetDifferenceRequest._Subtrahend._Set.repeatedFields_, null);
};
goog.inherits(proto._SetDifferenceRequest._Subtrahend._Set, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetDifferenceRequest._Subtrahend._Set.displayName = 'proto._SetDifferenceRequest._Subtrahend._Set';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetDifferenceRequest._Subtrahend._Identity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetDifferenceRequest._Subtrahend._Identity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetDifferenceRequest._Subtrahend._Identity.displayName = 'proto._SetDifferenceRequest._Subtrahend._Identity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetDifferenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SetDifferenceResponse.oneofGroups_);
};
goog.inherits(proto._SetDifferenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetDifferenceResponse.displayName = 'proto._SetDifferenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetDifferenceResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetDifferenceResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetDifferenceResponse._Found.displayName = 'proto._SetDifferenceResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetDifferenceResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetDifferenceResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetDifferenceResponse._Missing.displayName = 'proto._SetDifferenceResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetContainsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SetContainsRequest.repeatedFields_, null);
};
goog.inherits(proto._SetContainsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetContainsRequest.displayName = 'proto._SetContainsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetContainsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SetContainsResponse.oneofGroups_);
};
goog.inherits(proto._SetContainsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetContainsResponse.displayName = 'proto._SetContainsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetContainsResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SetContainsResponse._Found.repeatedFields_, null);
};
goog.inherits(proto._SetContainsResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetContainsResponse._Found.displayName = 'proto._SetContainsResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetContainsResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetContainsResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetContainsResponse._Missing.displayName = 'proto._SetContainsResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetLengthRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetLengthRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetLengthRequest.displayName = 'proto._SetLengthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetLengthResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SetLengthResponse.oneofGroups_);
};
goog.inherits(proto._SetLengthResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetLengthResponse.displayName = 'proto._SetLengthResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetLengthResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetLengthResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetLengthResponse._Found.displayName = 'proto._SetLengthResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetLengthResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetLengthResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetLengthResponse._Missing.displayName = 'proto._SetLengthResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetPopRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetPopRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetPopRequest.displayName = 'proto._SetPopRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetPopResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SetPopResponse.oneofGroups_);
};
goog.inherits(proto._SetPopResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetPopResponse.displayName = 'proto._SetPopResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetPopResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SetPopResponse._Found.repeatedFields_, null);
};
goog.inherits(proto._SetPopResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetPopResponse._Found.displayName = 'proto._SetPopResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SetPopResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SetPopResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SetPopResponse._Missing.displayName = 'proto._SetPopResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListConcatenateFrontRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._ListConcatenateFrontRequest.repeatedFields_, null);
};
goog.inherits(proto._ListConcatenateFrontRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListConcatenateFrontRequest.displayName = 'proto._ListConcatenateFrontRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListConcatenateFrontResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListConcatenateFrontResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListConcatenateFrontResponse.displayName = 'proto._ListConcatenateFrontResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListConcatenateBackRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._ListConcatenateBackRequest.repeatedFields_, null);
};
goog.inherits(proto._ListConcatenateBackRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListConcatenateBackRequest.displayName = 'proto._ListConcatenateBackRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListConcatenateBackResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListConcatenateBackResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListConcatenateBackResponse.displayName = 'proto._ListConcatenateBackResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPushFrontRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPushFrontRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPushFrontRequest.displayName = 'proto._ListPushFrontRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPushFrontResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPushFrontResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPushFrontResponse.displayName = 'proto._ListPushFrontResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPushBackRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPushBackRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPushBackRequest.displayName = 'proto._ListPushBackRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPushBackResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPushBackResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPushBackResponse.displayName = 'proto._ListPushBackResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPopFrontRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPopFrontRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPopFrontRequest.displayName = 'proto._ListPopFrontRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPopFrontResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListPopFrontResponse.oneofGroups_);
};
goog.inherits(proto._ListPopFrontResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPopFrontResponse.displayName = 'proto._ListPopFrontResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPopFrontResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPopFrontResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPopFrontResponse._Found.displayName = 'proto._ListPopFrontResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPopFrontResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPopFrontResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPopFrontResponse._Missing.displayName = 'proto._ListPopFrontResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPopBackRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPopBackRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPopBackRequest.displayName = 'proto._ListPopBackRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPopBackResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListPopBackResponse.oneofGroups_);
};
goog.inherits(proto._ListPopBackResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPopBackResponse.displayName = 'proto._ListPopBackResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPopBackResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPopBackResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPopBackResponse._Found.displayName = 'proto._ListPopBackResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListPopBackResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListPopBackResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListPopBackResponse._Missing.displayName = 'proto._ListPopBackResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRange.displayName = 'proto._ListRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListEraseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListEraseRequest.oneofGroups_);
};
goog.inherits(proto._ListEraseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListEraseRequest.displayName = 'proto._ListEraseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListEraseRequest._All = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListEraseRequest._All, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListEraseRequest._All.displayName = 'proto._ListEraseRequest._All';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListEraseRequest._ListRanges = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._ListEraseRequest._ListRanges.repeatedFields_, null);
};
goog.inherits(proto._ListEraseRequest._ListRanges, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListEraseRequest._ListRanges.displayName = 'proto._ListEraseRequest._ListRanges';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListEraseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListEraseResponse.oneofGroups_);
};
goog.inherits(proto._ListEraseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListEraseResponse.displayName = 'proto._ListEraseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListEraseResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListEraseResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListEraseResponse._Found.displayName = 'proto._ListEraseResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListEraseResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListEraseResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListEraseResponse._Missing.displayName = 'proto._ListEraseResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRemoveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListRemoveRequest.oneofGroups_);
};
goog.inherits(proto._ListRemoveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRemoveRequest.displayName = 'proto._ListRemoveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRemoveResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListRemoveResponse.oneofGroups_);
};
goog.inherits(proto._ListRemoveResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRemoveResponse.displayName = 'proto._ListRemoveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRemoveResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListRemoveResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRemoveResponse._Found.displayName = 'proto._ListRemoveResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRemoveResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListRemoveResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRemoveResponse._Missing.displayName = 'proto._ListRemoveResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._Unbounded = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._Unbounded, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._Unbounded.displayName = 'proto._Unbounded';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListFetchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListFetchRequest.oneofGroups_);
};
goog.inherits(proto._ListFetchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListFetchRequest.displayName = 'proto._ListFetchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRetainRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListRetainRequest.oneofGroups_);
};
goog.inherits(proto._ListRetainRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRetainRequest.displayName = 'proto._ListRetainRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRetainResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListRetainResponse.oneofGroups_);
};
goog.inherits(proto._ListRetainResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRetainResponse.displayName = 'proto._ListRetainResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRetainResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListRetainResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRetainResponse._Found.displayName = 'proto._ListRetainResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListRetainResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListRetainResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListRetainResponse._Missing.displayName = 'proto._ListRetainResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListFetchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListFetchResponse.oneofGroups_);
};
goog.inherits(proto._ListFetchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListFetchResponse.displayName = 'proto._ListFetchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListFetchResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._ListFetchResponse._Found.repeatedFields_, null);
};
goog.inherits(proto._ListFetchResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListFetchResponse._Found.displayName = 'proto._ListFetchResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListFetchResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListFetchResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListFetchResponse._Missing.displayName = 'proto._ListFetchResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListLengthRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListLengthRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListLengthRequest.displayName = 'proto._ListLengthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListLengthResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._ListLengthResponse.oneofGroups_);
};
goog.inherits(proto._ListLengthResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListLengthResponse.displayName = 'proto._ListLengthResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListLengthResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListLengthResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListLengthResponse._Found.displayName = 'proto._ListLengthResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._ListLengthResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._ListLengthResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._ListLengthResponse._Missing.displayName = 'proto._ListLengthResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetElement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetElement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetElement.displayName = 'proto._SortedSetElement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetPutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SortedSetPutRequest.repeatedFields_, null);
};
goog.inherits(proto._SortedSetPutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetPutRequest.displayName = 'proto._SortedSetPutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetPutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetPutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetPutResponse.displayName = 'proto._SortedSetPutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetFetchRequest.oneofGroups_);
};
goog.inherits(proto._SortedSetFetchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchRequest.displayName = 'proto._SortedSetFetchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchRequest._ByIndex = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetFetchRequest._ByIndex.oneofGroups_);
};
goog.inherits(proto._SortedSetFetchRequest._ByIndex, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchRequest._ByIndex.displayName = 'proto._SortedSetFetchRequest._ByIndex';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchRequest._ByScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetFetchRequest._ByScore.oneofGroups_);
};
goog.inherits(proto._SortedSetFetchRequest._ByScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchRequest._ByScore.displayName = 'proto._SortedSetFetchRequest._ByScore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchRequest._ByScore._Score = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetFetchRequest._ByScore._Score, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchRequest._ByScore._Score.displayName = 'proto._SortedSetFetchRequest._ByScore._Score';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetFetchResponse.oneofGroups_);
};
goog.inherits(proto._SortedSetFetchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchResponse.displayName = 'proto._SortedSetFetchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetFetchResponse._Found.oneofGroups_);
};
goog.inherits(proto._SortedSetFetchResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchResponse._Found.displayName = 'proto._SortedSetFetchResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SortedSetFetchResponse._Found._ValuesWithScores.repeatedFields_, null);
};
goog.inherits(proto._SortedSetFetchResponse._Found._ValuesWithScores, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchResponse._Found._ValuesWithScores.displayName = 'proto._SortedSetFetchResponse._Found._ValuesWithScores';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchResponse._Found._Values = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SortedSetFetchResponse._Found._Values.repeatedFields_, null);
};
goog.inherits(proto._SortedSetFetchResponse._Found._Values, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchResponse._Found._Values.displayName = 'proto._SortedSetFetchResponse._Found._Values';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetFetchResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetFetchResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetFetchResponse._Missing.displayName = 'proto._SortedSetFetchResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetScoreRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SortedSetGetScoreRequest.repeatedFields_, null);
};
goog.inherits(proto._SortedSetGetScoreRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetScoreRequest.displayName = 'proto._SortedSetGetScoreRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetScoreResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetGetScoreResponse.oneofGroups_);
};
goog.inherits(proto._SortedSetGetScoreResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetScoreResponse.displayName = 'proto._SortedSetGetScoreResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.displayName = 'proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetScoreResponse._SortedSetFound = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SortedSetGetScoreResponse._SortedSetFound.repeatedFields_, null);
};
goog.inherits(proto._SortedSetGetScoreResponse._SortedSetFound, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetScoreResponse._SortedSetFound.displayName = 'proto._SortedSetGetScoreResponse._SortedSetFound';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetScoreResponse._SortedSetMissing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetGetScoreResponse._SortedSetMissing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetScoreResponse._SortedSetMissing.displayName = 'proto._SortedSetGetScoreResponse._SortedSetMissing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetRemoveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetRemoveRequest.oneofGroups_);
};
goog.inherits(proto._SortedSetRemoveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetRemoveRequest.displayName = 'proto._SortedSetRemoveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetRemoveRequest._All = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetRemoveRequest._All, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetRemoveRequest._All.displayName = 'proto._SortedSetRemoveRequest._All';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetRemoveRequest._Some = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto._SortedSetRemoveRequest._Some.repeatedFields_, null);
};
goog.inherits(proto._SortedSetRemoveRequest._Some, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetRemoveRequest._Some.displayName = 'proto._SortedSetRemoveRequest._Some';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetRemoveResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetRemoveResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetRemoveResponse.displayName = 'proto._SortedSetRemoveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetIncrementRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetIncrementRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetIncrementRequest.displayName = 'proto._SortedSetIncrementRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetIncrementResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetIncrementResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetIncrementResponse.displayName = 'proto._SortedSetIncrementResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetRankRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetGetRankRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetRankRequest.displayName = 'proto._SortedSetGetRankRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetRankResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetGetRankResponse.oneofGroups_);
};
goog.inherits(proto._SortedSetGetRankResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetRankResponse.displayName = 'proto._SortedSetGetRankResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetRankResponse._RankResponsePart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetGetRankResponse._RankResponsePart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetRankResponse._RankResponsePart.displayName = 'proto._SortedSetGetRankResponse._RankResponsePart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetGetRankResponse._SortedSetMissing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetGetRankResponse._SortedSetMissing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetGetRankResponse._SortedSetMissing.displayName = 'proto._SortedSetGetRankResponse._SortedSetMissing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetLengthRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetLengthRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetLengthRequest.displayName = 'proto._SortedSetLengthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetLengthResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetLengthResponse.oneofGroups_);
};
goog.inherits(proto._SortedSetLengthResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetLengthResponse.displayName = 'proto._SortedSetLengthResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetLengthResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetLengthResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetLengthResponse._Found.displayName = 'proto._SortedSetLengthResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetLengthResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetLengthResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetLengthResponse._Missing.displayName = 'proto._SortedSetLengthResponse._Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetLengthByScoreRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetLengthByScoreRequest.oneofGroups_);
};
goog.inherits(proto._SortedSetLengthByScoreRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetLengthByScoreRequest.displayName = 'proto._SortedSetLengthByScoreRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetLengthByScoreResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto._SortedSetLengthByScoreResponse.oneofGroups_);
};
goog.inherits(proto._SortedSetLengthByScoreResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetLengthByScoreResponse.displayName = 'proto._SortedSetLengthByScoreResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetLengthByScoreResponse._Found = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetLengthByScoreResponse._Found, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetLengthByScoreResponse._Found.displayName = 'proto._SortedSetLengthByScoreResponse._Found';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto._SortedSetLengthByScoreResponse._Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto._SortedSetLengthByScoreResponse._Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto._SortedSetLengthByScoreResponse._Missing.displayName = 'proto._SortedSetLengthByScoreResponse._Missing';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._GetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._GetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._GetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._GetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKey: msg.getCacheKey_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._GetRequest}
 */
proto._GetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._GetRequest;
  return proto._GetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._GetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._GetRequest}
 */
proto._GetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._GetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._GetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._GetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._GetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes cache_key = 1;
 * @return {string}
 */
proto._GetRequest.prototype.getCacheKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cache_key = 1;
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {string}
 */
proto._GetRequest.prototype.getCacheKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheKey()));
};


/**
 * optional bytes cache_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {!Uint8Array}
 */
proto._GetRequest.prototype.getCacheKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._GetRequest} returns this
 */
proto._GetRequest.prototype.setCacheKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._GetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._GetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._GetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._GetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cacheBody: msg.getCacheBody_asB64(),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._GetResponse}
 */
proto._GetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._GetResponse;
  return proto._GetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._GetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._GetResponse}
 */
proto._GetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ECacheResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheBody(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._GetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._GetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._GetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._GetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCacheBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional ECacheResult result = 1;
 * @return {!proto.ECacheResult}
 */
proto._GetResponse.prototype.getResult = function() {
  return /** @type {!proto.ECacheResult} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ECacheResult} value
 * @return {!proto._GetResponse} returns this
 */
proto._GetResponse.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bytes cache_body = 2;
 * @return {string}
 */
proto._GetResponse.prototype.getCacheBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes cache_body = 2;
 * This is a type-conversion wrapper around `getCacheBody()`
 * @return {string}
 */
proto._GetResponse.prototype.getCacheBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheBody()));
};


/**
 * optional bytes cache_body = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheBody()`
 * @return {!Uint8Array}
 */
proto._GetResponse.prototype.getCacheBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._GetResponse} returns this
 */
proto._GetResponse.prototype.setCacheBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto._GetResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto._GetResponse} returns this
 */
proto._GetResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DeleteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._DeleteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DeleteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DeleteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKey: msg.getCacheKey_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DeleteRequest}
 */
proto._DeleteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DeleteRequest;
  return proto._DeleteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DeleteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DeleteRequest}
 */
proto._DeleteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DeleteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DeleteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DeleteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DeleteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes cache_key = 1;
 * @return {string}
 */
proto._DeleteRequest.prototype.getCacheKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cache_key = 1;
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {string}
 */
proto._DeleteRequest.prototype.getCacheKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheKey()));
};


/**
 * optional bytes cache_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {!Uint8Array}
 */
proto._DeleteRequest.prototype.getCacheKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DeleteRequest} returns this
 */
proto._DeleteRequest.prototype.setCacheKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DeleteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._DeleteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DeleteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DeleteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DeleteResponse}
 */
proto._DeleteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DeleteResponse;
  return proto._DeleteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DeleteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DeleteResponse}
 */
proto._DeleteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DeleteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DeleteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DeleteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DeleteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKey: msg.getCacheKey_asB64(),
    cacheBody: msg.getCacheBody_asB64(),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetRequest}
 */
proto._SetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetRequest;
  return proto._SetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetRequest}
 */
proto._SetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheKey(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheBody(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getCacheBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional bytes cache_key = 1;
 * @return {string}
 */
proto._SetRequest.prototype.getCacheKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cache_key = 1;
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {string}
 */
proto._SetRequest.prototype.getCacheKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheKey()));
};


/**
 * optional bytes cache_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {!Uint8Array}
 */
proto._SetRequest.prototype.getCacheKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetRequest} returns this
 */
proto._SetRequest.prototype.setCacheKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes cache_body = 2;
 * @return {string}
 */
proto._SetRequest.prototype.getCacheBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes cache_body = 2;
 * This is a type-conversion wrapper around `getCacheBody()`
 * @return {string}
 */
proto._SetRequest.prototype.getCacheBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheBody()));
};


/**
 * optional bytes cache_body = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheBody()`
 * @return {!Uint8Array}
 */
proto._SetRequest.prototype.getCacheBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetRequest} returns this
 */
proto._SetRequest.prototype.setCacheBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._SetRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._SetRequest} returns this
 */
proto._SetRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetResponse}
 */
proto._SetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetResponse;
  return proto._SetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetResponse}
 */
proto._SetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ECacheResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ECacheResult result = 1;
 * @return {!proto.ECacheResult}
 */
proto._SetResponse.prototype.getResult = function() {
  return /** @type {!proto.ECacheResult} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ECacheResult} value
 * @return {!proto._SetResponse} returns this
 */
proto._SetResponse.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto._SetResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto._SetResponse} returns this
 */
proto._SetResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetIfNotExistsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SetIfNotExistsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetIfNotExistsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetIfNotExistsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKey: msg.getCacheKey_asB64(),
    cacheBody: msg.getCacheBody_asB64(),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetIfNotExistsRequest}
 */
proto._SetIfNotExistsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetIfNotExistsRequest;
  return proto._SetIfNotExistsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetIfNotExistsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetIfNotExistsRequest}
 */
proto._SetIfNotExistsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheKey(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheBody(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetIfNotExistsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetIfNotExistsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetIfNotExistsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetIfNotExistsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getCacheBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional bytes cache_key = 1;
 * @return {string}
 */
proto._SetIfNotExistsRequest.prototype.getCacheKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cache_key = 1;
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {string}
 */
proto._SetIfNotExistsRequest.prototype.getCacheKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheKey()));
};


/**
 * optional bytes cache_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {!Uint8Array}
 */
proto._SetIfNotExistsRequest.prototype.getCacheKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetIfNotExistsRequest} returns this
 */
proto._SetIfNotExistsRequest.prototype.setCacheKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes cache_body = 2;
 * @return {string}
 */
proto._SetIfNotExistsRequest.prototype.getCacheBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes cache_body = 2;
 * This is a type-conversion wrapper around `getCacheBody()`
 * @return {string}
 */
proto._SetIfNotExistsRequest.prototype.getCacheBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheBody()));
};


/**
 * optional bytes cache_body = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheBody()`
 * @return {!Uint8Array}
 */
proto._SetIfNotExistsRequest.prototype.getCacheBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetIfNotExistsRequest} returns this
 */
proto._SetIfNotExistsRequest.prototype.setCacheBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._SetIfNotExistsRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._SetIfNotExistsRequest} returns this
 */
proto._SetIfNotExistsRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SetIfNotExistsResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SetIfNotExistsResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  STORED: 1,
  NOT_STORED: 2
};

/**
 * @return {proto._SetIfNotExistsResponse.ResultCase}
 */
proto._SetIfNotExistsResponse.prototype.getResultCase = function() {
  return /** @type {proto._SetIfNotExistsResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto._SetIfNotExistsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetIfNotExistsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SetIfNotExistsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetIfNotExistsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetIfNotExistsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    stored: (f = msg.getStored()) && proto._SetIfNotExistsResponse._Stored.toObject(includeInstance, f),
    notStored: (f = msg.getNotStored()) && proto._SetIfNotExistsResponse._NotStored.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetIfNotExistsResponse}
 */
proto._SetIfNotExistsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetIfNotExistsResponse;
  return proto._SetIfNotExistsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetIfNotExistsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetIfNotExistsResponse}
 */
proto._SetIfNotExistsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SetIfNotExistsResponse._Stored;
      reader.readMessage(value,proto._SetIfNotExistsResponse._Stored.deserializeBinaryFromReader);
      msg.setStored(value);
      break;
    case 2:
      var value = new proto._SetIfNotExistsResponse._NotStored;
      reader.readMessage(value,proto._SetIfNotExistsResponse._NotStored.deserializeBinaryFromReader);
      msg.setNotStored(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetIfNotExistsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetIfNotExistsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetIfNotExistsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetIfNotExistsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStored();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SetIfNotExistsResponse._Stored.serializeBinaryToWriter
    );
  }
  f = message.getNotStored();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SetIfNotExistsResponse._NotStored.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetIfNotExistsResponse._Stored.prototype.toObject = function(opt_includeInstance) {
  return proto._SetIfNotExistsResponse._Stored.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetIfNotExistsResponse._Stored} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetIfNotExistsResponse._Stored.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetIfNotExistsResponse._Stored}
 */
proto._SetIfNotExistsResponse._Stored.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetIfNotExistsResponse._Stored;
  return proto._SetIfNotExistsResponse._Stored.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetIfNotExistsResponse._Stored} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetIfNotExistsResponse._Stored}
 */
proto._SetIfNotExistsResponse._Stored.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetIfNotExistsResponse._Stored.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetIfNotExistsResponse._Stored.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetIfNotExistsResponse._Stored} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetIfNotExistsResponse._Stored.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetIfNotExistsResponse._NotStored.prototype.toObject = function(opt_includeInstance) {
  return proto._SetIfNotExistsResponse._NotStored.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetIfNotExistsResponse._NotStored} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetIfNotExistsResponse._NotStored.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetIfNotExistsResponse._NotStored}
 */
proto._SetIfNotExistsResponse._NotStored.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetIfNotExistsResponse._NotStored;
  return proto._SetIfNotExistsResponse._NotStored.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetIfNotExistsResponse._NotStored} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetIfNotExistsResponse._NotStored}
 */
proto._SetIfNotExistsResponse._NotStored.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetIfNotExistsResponse._NotStored.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetIfNotExistsResponse._NotStored.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetIfNotExistsResponse._NotStored} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetIfNotExistsResponse._NotStored.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Stored stored = 1;
 * @return {?proto._SetIfNotExistsResponse._Stored}
 */
proto._SetIfNotExistsResponse.prototype.getStored = function() {
  return /** @type{?proto._SetIfNotExistsResponse._Stored} */ (
    jspb.Message.getWrapperField(this, proto._SetIfNotExistsResponse._Stored, 1));
};


/**
 * @param {?proto._SetIfNotExistsResponse._Stored|undefined} value
 * @return {!proto._SetIfNotExistsResponse} returns this
*/
proto._SetIfNotExistsResponse.prototype.setStored = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SetIfNotExistsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetIfNotExistsResponse} returns this
 */
proto._SetIfNotExistsResponse.prototype.clearStored = function() {
  return this.setStored(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetIfNotExistsResponse.prototype.hasStored = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _NotStored not_stored = 2;
 * @return {?proto._SetIfNotExistsResponse._NotStored}
 */
proto._SetIfNotExistsResponse.prototype.getNotStored = function() {
  return /** @type{?proto._SetIfNotExistsResponse._NotStored} */ (
    jspb.Message.getWrapperField(this, proto._SetIfNotExistsResponse._NotStored, 2));
};


/**
 * @param {?proto._SetIfNotExistsResponse._NotStored|undefined} value
 * @return {!proto._SetIfNotExistsResponse} returns this
*/
proto._SetIfNotExistsResponse.prototype.setNotStored = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SetIfNotExistsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetIfNotExistsResponse} returns this
 */
proto._SetIfNotExistsResponse.prototype.clearNotStored = function() {
  return this.setNotStored(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetIfNotExistsResponse.prototype.hasNotStored = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._KeysExistRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._KeysExistRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._KeysExistRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._KeysExistRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._KeysExistRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKeysList: msg.getCacheKeysList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._KeysExistRequest}
 */
proto._KeysExistRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._KeysExistRequest;
  return proto._KeysExistRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._KeysExistRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._KeysExistRequest}
 */
proto._KeysExistRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addCacheKeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._KeysExistRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._KeysExistRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._KeysExistRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._KeysExistRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKeysList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes cache_keys = 1;
 * @return {!Array<string>}
 */
proto._KeysExistRequest.prototype.getCacheKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes cache_keys = 1;
 * This is a type-conversion wrapper around `getCacheKeysList()`
 * @return {!Array<string>}
 */
proto._KeysExistRequest.prototype.getCacheKeysList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getCacheKeysList()));
};


/**
 * repeated bytes cache_keys = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKeysList()`
 * @return {!Array<!Uint8Array>}
 */
proto._KeysExistRequest.prototype.getCacheKeysList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getCacheKeysList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._KeysExistRequest} returns this
 */
proto._KeysExistRequest.prototype.setCacheKeysList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._KeysExistRequest} returns this
 */
proto._KeysExistRequest.prototype.addCacheKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._KeysExistRequest} returns this
 */
proto._KeysExistRequest.prototype.clearCacheKeysList = function() {
  return this.setCacheKeysList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._KeysExistResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._KeysExistResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._KeysExistResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._KeysExistResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._KeysExistResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    existsList: (f = jspb.Message.getRepeatedBooleanField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._KeysExistResponse}
 */
proto._KeysExistResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._KeysExistResponse;
  return proto._KeysExistResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._KeysExistResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._KeysExistResponse}
 */
proto._KeysExistResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<boolean>} */ (reader.isDelimited() ? reader.readPackedBool() : [reader.readBool()]);
      for (var i = 0; i < values.length; i++) {
        msg.addExists(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._KeysExistResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._KeysExistResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._KeysExistResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._KeysExistResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExistsList();
  if (f.length > 0) {
    writer.writePackedBool(
      1,
      f
    );
  }
};


/**
 * repeated bool exists = 1;
 * @return {!Array<boolean>}
 */
proto._KeysExistResponse.prototype.getExistsList = function() {
  return /** @type {!Array<boolean>} */ (jspb.Message.getRepeatedBooleanField(this, 1));
};


/**
 * @param {!Array<boolean>} value
 * @return {!proto._KeysExistResponse} returns this
 */
proto._KeysExistResponse.prototype.setExistsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {boolean} value
 * @param {number=} opt_index
 * @return {!proto._KeysExistResponse} returns this
 */
proto._KeysExistResponse.prototype.addExists = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._KeysExistResponse} returns this
 */
proto._KeysExistResponse.prototype.clearExistsList = function() {
  return this.setExistsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._IncrementRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._IncrementRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._IncrementRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._IncrementRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKey: msg.getCacheKey_asB64(),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._IncrementRequest}
 */
proto._IncrementRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._IncrementRequest;
  return proto._IncrementRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._IncrementRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._IncrementRequest}
 */
proto._IncrementRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._IncrementRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._IncrementRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._IncrementRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._IncrementRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional bytes cache_key = 1;
 * @return {string}
 */
proto._IncrementRequest.prototype.getCacheKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cache_key = 1;
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {string}
 */
proto._IncrementRequest.prototype.getCacheKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheKey()));
};


/**
 * optional bytes cache_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {!Uint8Array}
 */
proto._IncrementRequest.prototype.getCacheKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._IncrementRequest} returns this
 */
proto._IncrementRequest.prototype.setCacheKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto._IncrementRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto._IncrementRequest} returns this
 */
proto._IncrementRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._IncrementRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._IncrementRequest} returns this
 */
proto._IncrementRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._IncrementResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._IncrementResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._IncrementResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._IncrementResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._IncrementResponse}
 */
proto._IncrementResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._IncrementResponse;
  return proto._IncrementResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._IncrementResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._IncrementResponse}
 */
proto._IncrementResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._IncrementResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._IncrementResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._IncrementResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._IncrementResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto._IncrementResponse.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._IncrementResponse} returns this
 */
proto._IncrementResponse.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._UpdateTtlRequest.oneofGroups_ = [[2,3,4]];

/**
 * @enum {number}
 */
proto._UpdateTtlRequest.UpdateTtlCase = {
  UPDATE_TTL_NOT_SET: 0,
  INCREASE_TO_MILLISECONDS: 2,
  DECREASE_TO_MILLISECONDS: 3,
  OVERWRITE_TO_MILLISECONDS: 4
};

/**
 * @return {proto._UpdateTtlRequest.UpdateTtlCase}
 */
proto._UpdateTtlRequest.prototype.getUpdateTtlCase = function() {
  return /** @type {proto._UpdateTtlRequest.UpdateTtlCase} */(jspb.Message.computeOneofCase(this, proto._UpdateTtlRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._UpdateTtlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._UpdateTtlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._UpdateTtlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKey: msg.getCacheKey_asB64(),
    increaseToMilliseconds: jspb.Message.getFieldWithDefault(msg, 2, 0),
    decreaseToMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    overwriteToMilliseconds: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._UpdateTtlRequest}
 */
proto._UpdateTtlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._UpdateTtlRequest;
  return proto._UpdateTtlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._UpdateTtlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._UpdateTtlRequest}
 */
proto._UpdateTtlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIncreaseToMilliseconds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDecreaseToMilliseconds(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOverwriteToMilliseconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._UpdateTtlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._UpdateTtlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._UpdateTtlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional bytes cache_key = 1;
 * @return {string}
 */
proto._UpdateTtlRequest.prototype.getCacheKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cache_key = 1;
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {string}
 */
proto._UpdateTtlRequest.prototype.getCacheKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheKey()));
};


/**
 * optional bytes cache_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {!Uint8Array}
 */
proto._UpdateTtlRequest.prototype.getCacheKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._UpdateTtlRequest} returns this
 */
proto._UpdateTtlRequest.prototype.setCacheKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional uint64 increase_to_milliseconds = 2;
 * @return {number}
 */
proto._UpdateTtlRequest.prototype.getIncreaseToMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto._UpdateTtlRequest} returns this
 */
proto._UpdateTtlRequest.prototype.setIncreaseToMilliseconds = function(value) {
  return jspb.Message.setOneofField(this, 2, proto._UpdateTtlRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._UpdateTtlRequest} returns this
 */
proto._UpdateTtlRequest.prototype.clearIncreaseToMilliseconds = function() {
  return jspb.Message.setOneofField(this, 2, proto._UpdateTtlRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._UpdateTtlRequest.prototype.hasIncreaseToMilliseconds = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint64 decrease_to_milliseconds = 3;
 * @return {number}
 */
proto._UpdateTtlRequest.prototype.getDecreaseToMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._UpdateTtlRequest} returns this
 */
proto._UpdateTtlRequest.prototype.setDecreaseToMilliseconds = function(value) {
  return jspb.Message.setOneofField(this, 3, proto._UpdateTtlRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._UpdateTtlRequest} returns this
 */
proto._UpdateTtlRequest.prototype.clearDecreaseToMilliseconds = function() {
  return jspb.Message.setOneofField(this, 3, proto._UpdateTtlRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._UpdateTtlRequest.prototype.hasDecreaseToMilliseconds = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 overwrite_to_milliseconds = 4;
 * @return {number}
 */
proto._UpdateTtlRequest.prototype.getOverwriteToMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto._UpdateTtlRequest} returns this
 */
proto._UpdateTtlRequest.prototype.setOverwriteToMilliseconds = function(value) {
  return jspb.Message.setOneofField(this, 4, proto._UpdateTtlRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._UpdateTtlRequest} returns this
 */
proto._UpdateTtlRequest.prototype.clearOverwriteToMilliseconds = function() {
  return jspb.Message.setOneofField(this, 4, proto._UpdateTtlRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._UpdateTtlRequest.prototype.hasOverwriteToMilliseconds = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._UpdateTtlResponse.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto._UpdateTtlResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SET: 1,
  NOT_SET: 2,
  MISSING: 3
};

/**
 * @return {proto._UpdateTtlResponse.ResultCase}
 */
proto._UpdateTtlResponse.prototype.getResultCase = function() {
  return /** @type {proto._UpdateTtlResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto._UpdateTtlResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._UpdateTtlResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._UpdateTtlResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._UpdateTtlResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    set: (f = msg.getSet()) && proto._UpdateTtlResponse._Set.toObject(includeInstance, f),
    notSet: (f = msg.getNotSet()) && proto._UpdateTtlResponse._NotSet.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._UpdateTtlResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._UpdateTtlResponse}
 */
proto._UpdateTtlResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._UpdateTtlResponse;
  return proto._UpdateTtlResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._UpdateTtlResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._UpdateTtlResponse}
 */
proto._UpdateTtlResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._UpdateTtlResponse._Set;
      reader.readMessage(value,proto._UpdateTtlResponse._Set.deserializeBinaryFromReader);
      msg.setSet(value);
      break;
    case 2:
      var value = new proto._UpdateTtlResponse._NotSet;
      reader.readMessage(value,proto._UpdateTtlResponse._NotSet.deserializeBinaryFromReader);
      msg.setNotSet(value);
      break;
    case 3:
      var value = new proto._UpdateTtlResponse._Missing;
      reader.readMessage(value,proto._UpdateTtlResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._UpdateTtlResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._UpdateTtlResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._UpdateTtlResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSet();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._UpdateTtlResponse._Set.serializeBinaryToWriter
    );
  }
  f = message.getNotSet();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._UpdateTtlResponse._NotSet.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto._UpdateTtlResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._UpdateTtlResponse._Set.prototype.toObject = function(opt_includeInstance) {
  return proto._UpdateTtlResponse._Set.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._UpdateTtlResponse._Set} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlResponse._Set.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._UpdateTtlResponse._Set}
 */
proto._UpdateTtlResponse._Set.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._UpdateTtlResponse._Set;
  return proto._UpdateTtlResponse._Set.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._UpdateTtlResponse._Set} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._UpdateTtlResponse._Set}
 */
proto._UpdateTtlResponse._Set.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._UpdateTtlResponse._Set.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._UpdateTtlResponse._Set.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._UpdateTtlResponse._Set} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlResponse._Set.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._UpdateTtlResponse._NotSet.prototype.toObject = function(opt_includeInstance) {
  return proto._UpdateTtlResponse._NotSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._UpdateTtlResponse._NotSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlResponse._NotSet.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._UpdateTtlResponse._NotSet}
 */
proto._UpdateTtlResponse._NotSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._UpdateTtlResponse._NotSet;
  return proto._UpdateTtlResponse._NotSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._UpdateTtlResponse._NotSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._UpdateTtlResponse._NotSet}
 */
proto._UpdateTtlResponse._NotSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._UpdateTtlResponse._NotSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._UpdateTtlResponse._NotSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._UpdateTtlResponse._NotSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlResponse._NotSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._UpdateTtlResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._UpdateTtlResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._UpdateTtlResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._UpdateTtlResponse._Missing}
 */
proto._UpdateTtlResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._UpdateTtlResponse._Missing;
  return proto._UpdateTtlResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._UpdateTtlResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._UpdateTtlResponse._Missing}
 */
proto._UpdateTtlResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._UpdateTtlResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._UpdateTtlResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._UpdateTtlResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._UpdateTtlResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Set set = 1;
 * @return {?proto._UpdateTtlResponse._Set}
 */
proto._UpdateTtlResponse.prototype.getSet = function() {
  return /** @type{?proto._UpdateTtlResponse._Set} */ (
    jspb.Message.getWrapperField(this, proto._UpdateTtlResponse._Set, 1));
};


/**
 * @param {?proto._UpdateTtlResponse._Set|undefined} value
 * @return {!proto._UpdateTtlResponse} returns this
*/
proto._UpdateTtlResponse.prototype.setSet = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._UpdateTtlResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._UpdateTtlResponse} returns this
 */
proto._UpdateTtlResponse.prototype.clearSet = function() {
  return this.setSet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._UpdateTtlResponse.prototype.hasSet = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _NotSet not_set = 2;
 * @return {?proto._UpdateTtlResponse._NotSet}
 */
proto._UpdateTtlResponse.prototype.getNotSet = function() {
  return /** @type{?proto._UpdateTtlResponse._NotSet} */ (
    jspb.Message.getWrapperField(this, proto._UpdateTtlResponse._NotSet, 2));
};


/**
 * @param {?proto._UpdateTtlResponse._NotSet|undefined} value
 * @return {!proto._UpdateTtlResponse} returns this
*/
proto._UpdateTtlResponse.prototype.setNotSet = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._UpdateTtlResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._UpdateTtlResponse} returns this
 */
proto._UpdateTtlResponse.prototype.clearNotSet = function() {
  return this.setNotSet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._UpdateTtlResponse.prototype.hasNotSet = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional _Missing missing = 3;
 * @return {?proto._UpdateTtlResponse._Missing}
 */
proto._UpdateTtlResponse.prototype.getMissing = function() {
  return /** @type{?proto._UpdateTtlResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._UpdateTtlResponse._Missing, 3));
};


/**
 * @param {?proto._UpdateTtlResponse._Missing|undefined} value
 * @return {!proto._UpdateTtlResponse} returns this
*/
proto._UpdateTtlResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto._UpdateTtlResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._UpdateTtlResponse} returns this
 */
proto._UpdateTtlResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._UpdateTtlResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ItemGetTtlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ItemGetTtlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ItemGetTtlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTtlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKey: msg.getCacheKey_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ItemGetTtlRequest}
 */
proto._ItemGetTtlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ItemGetTtlRequest;
  return proto._ItemGetTtlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ItemGetTtlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ItemGetTtlRequest}
 */
proto._ItemGetTtlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ItemGetTtlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ItemGetTtlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ItemGetTtlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTtlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes cache_key = 1;
 * @return {string}
 */
proto._ItemGetTtlRequest.prototype.getCacheKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cache_key = 1;
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {string}
 */
proto._ItemGetTtlRequest.prototype.getCacheKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheKey()));
};


/**
 * optional bytes cache_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {!Uint8Array}
 */
proto._ItemGetTtlRequest.prototype.getCacheKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ItemGetTtlRequest} returns this
 */
proto._ItemGetTtlRequest.prototype.setCacheKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ItemGetTtlResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ItemGetTtlResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ItemGetTtlResponse.ResultCase}
 */
proto._ItemGetTtlResponse.prototype.getResultCase = function() {
  return /** @type {proto._ItemGetTtlResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto._ItemGetTtlResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ItemGetTtlResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ItemGetTtlResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ItemGetTtlResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTtlResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ItemGetTtlResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ItemGetTtlResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ItemGetTtlResponse}
 */
proto._ItemGetTtlResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ItemGetTtlResponse;
  return proto._ItemGetTtlResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ItemGetTtlResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ItemGetTtlResponse}
 */
proto._ItemGetTtlResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ItemGetTtlResponse._Found;
      reader.readMessage(value,proto._ItemGetTtlResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ItemGetTtlResponse._Missing;
      reader.readMessage(value,proto._ItemGetTtlResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ItemGetTtlResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ItemGetTtlResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ItemGetTtlResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTtlResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ItemGetTtlResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ItemGetTtlResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ItemGetTtlResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ItemGetTtlResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ItemGetTtlResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTtlResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    remainingTtlMillis: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ItemGetTtlResponse._Found}
 */
proto._ItemGetTtlResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ItemGetTtlResponse._Found;
  return proto._ItemGetTtlResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ItemGetTtlResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ItemGetTtlResponse._Found}
 */
proto._ItemGetTtlResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRemainingTtlMillis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ItemGetTtlResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ItemGetTtlResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ItemGetTtlResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTtlResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRemainingTtlMillis();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 remaining_ttl_millis = 1;
 * @return {number}
 */
proto._ItemGetTtlResponse._Found.prototype.getRemainingTtlMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ItemGetTtlResponse._Found} returns this
 */
proto._ItemGetTtlResponse._Found.prototype.setRemainingTtlMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ItemGetTtlResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ItemGetTtlResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ItemGetTtlResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTtlResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ItemGetTtlResponse._Missing}
 */
proto._ItemGetTtlResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ItemGetTtlResponse._Missing;
  return proto._ItemGetTtlResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ItemGetTtlResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ItemGetTtlResponse._Missing}
 */
proto._ItemGetTtlResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ItemGetTtlResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ItemGetTtlResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ItemGetTtlResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTtlResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ItemGetTtlResponse._Found}
 */
proto._ItemGetTtlResponse.prototype.getFound = function() {
  return /** @type{?proto._ItemGetTtlResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ItemGetTtlResponse._Found, 1));
};


/**
 * @param {?proto._ItemGetTtlResponse._Found|undefined} value
 * @return {!proto._ItemGetTtlResponse} returns this
*/
proto._ItemGetTtlResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ItemGetTtlResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ItemGetTtlResponse} returns this
 */
proto._ItemGetTtlResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ItemGetTtlResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ItemGetTtlResponse._Missing}
 */
proto._ItemGetTtlResponse.prototype.getMissing = function() {
  return /** @type{?proto._ItemGetTtlResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ItemGetTtlResponse._Missing, 2));
};


/**
 * @param {?proto._ItemGetTtlResponse._Missing|undefined} value
 * @return {!proto._ItemGetTtlResponse} returns this
*/
proto._ItemGetTtlResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ItemGetTtlResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ItemGetTtlResponse} returns this
 */
proto._ItemGetTtlResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ItemGetTtlResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ItemGetTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ItemGetTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ItemGetTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheKey: msg.getCacheKey_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ItemGetTypeRequest}
 */
proto._ItemGetTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ItemGetTypeRequest;
  return proto._ItemGetTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ItemGetTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ItemGetTypeRequest}
 */
proto._ItemGetTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ItemGetTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ItemGetTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ItemGetTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes cache_key = 1;
 * @return {string}
 */
proto._ItemGetTypeRequest.prototype.getCacheKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cache_key = 1;
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {string}
 */
proto._ItemGetTypeRequest.prototype.getCacheKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheKey()));
};


/**
 * optional bytes cache_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheKey()`
 * @return {!Uint8Array}
 */
proto._ItemGetTypeRequest.prototype.getCacheKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ItemGetTypeRequest} returns this
 */
proto._ItemGetTypeRequest.prototype.setCacheKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ItemGetTypeResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ItemGetTypeResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ItemGetTypeResponse.ResultCase}
 */
proto._ItemGetTypeResponse.prototype.getResultCase = function() {
  return /** @type {proto._ItemGetTypeResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto._ItemGetTypeResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ItemGetTypeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ItemGetTypeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ItemGetTypeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTypeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ItemGetTypeResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ItemGetTypeResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ItemGetTypeResponse}
 */
proto._ItemGetTypeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ItemGetTypeResponse;
  return proto._ItemGetTypeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ItemGetTypeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ItemGetTypeResponse}
 */
proto._ItemGetTypeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ItemGetTypeResponse._Found;
      reader.readMessage(value,proto._ItemGetTypeResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ItemGetTypeResponse._Missing;
      reader.readMessage(value,proto._ItemGetTypeResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ItemGetTypeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ItemGetTypeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ItemGetTypeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTypeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ItemGetTypeResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ItemGetTypeResponse._Missing.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto._ItemGetTypeResponse.ItemType = {
  SCALAR: 0,
  DICTIONARY: 1,
  SET: 2,
  LIST: 3,
  SORTED_SET: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ItemGetTypeResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ItemGetTypeResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ItemGetTypeResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTypeResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ItemGetTypeResponse._Found}
 */
proto._ItemGetTypeResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ItemGetTypeResponse._Found;
  return proto._ItemGetTypeResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ItemGetTypeResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ItemGetTypeResponse._Found}
 */
proto._ItemGetTypeResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto._ItemGetTypeResponse.ItemType} */ (reader.readEnum());
      msg.setItemType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ItemGetTypeResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ItemGetTypeResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ItemGetTypeResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTypeResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ItemType item_type = 1;
 * @return {!proto._ItemGetTypeResponse.ItemType}
 */
proto._ItemGetTypeResponse._Found.prototype.getItemType = function() {
  return /** @type {!proto._ItemGetTypeResponse.ItemType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto._ItemGetTypeResponse.ItemType} value
 * @return {!proto._ItemGetTypeResponse._Found} returns this
 */
proto._ItemGetTypeResponse._Found.prototype.setItemType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ItemGetTypeResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ItemGetTypeResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ItemGetTypeResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTypeResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ItemGetTypeResponse._Missing}
 */
proto._ItemGetTypeResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ItemGetTypeResponse._Missing;
  return proto._ItemGetTypeResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ItemGetTypeResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ItemGetTypeResponse._Missing}
 */
proto._ItemGetTypeResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ItemGetTypeResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ItemGetTypeResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ItemGetTypeResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ItemGetTypeResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ItemGetTypeResponse._Found}
 */
proto._ItemGetTypeResponse.prototype.getFound = function() {
  return /** @type{?proto._ItemGetTypeResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ItemGetTypeResponse._Found, 1));
};


/**
 * @param {?proto._ItemGetTypeResponse._Found|undefined} value
 * @return {!proto._ItemGetTypeResponse} returns this
*/
proto._ItemGetTypeResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ItemGetTypeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ItemGetTypeResponse} returns this
 */
proto._ItemGetTypeResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ItemGetTypeResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ItemGetTypeResponse._Missing}
 */
proto._ItemGetTypeResponse.prototype.getMissing = function() {
  return /** @type{?proto._ItemGetTypeResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ItemGetTypeResponse._Missing, 2));
};


/**
 * @param {?proto._ItemGetTypeResponse._Missing|undefined} value
 * @return {!proto._ItemGetTypeResponse} returns this
*/
proto._ItemGetTypeResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ItemGetTypeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ItemGetTypeResponse} returns this
 */
proto._ItemGetTypeResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ItemGetTypeResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._DictionaryGetRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryGetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryGetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryGetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dictionaryName: msg.getDictionaryName_asB64(),
    fieldsList: msg.getFieldsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryGetRequest}
 */
proto._DictionaryGetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryGetRequest;
  return proto._DictionaryGetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryGetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryGetRequest}
 */
proto._DictionaryGetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDictionaryName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryGetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryGetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryGetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDictionaryName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFieldsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      2,
      f
    );
  }
};


/**
 * optional bytes dictionary_name = 1;
 * @return {string}
 */
proto._DictionaryGetRequest.prototype.getDictionaryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes dictionary_name = 1;
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {string}
 */
proto._DictionaryGetRequest.prototype.getDictionaryName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDictionaryName()));
};


/**
 * optional bytes dictionary_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {!Uint8Array}
 */
proto._DictionaryGetRequest.prototype.getDictionaryName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDictionaryName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryGetRequest} returns this
 */
proto._DictionaryGetRequest.prototype.setDictionaryName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * repeated bytes fields = 2;
 * @return {!Array<string>}
 */
proto._DictionaryGetRequest.prototype.getFieldsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * repeated bytes fields = 2;
 * This is a type-conversion wrapper around `getFieldsList()`
 * @return {!Array<string>}
 */
proto._DictionaryGetRequest.prototype.getFieldsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getFieldsList()));
};


/**
 * repeated bytes fields = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFieldsList()`
 * @return {!Array<!Uint8Array>}
 */
proto._DictionaryGetRequest.prototype.getFieldsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getFieldsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._DictionaryGetRequest} returns this
 */
proto._DictionaryGetRequest.prototype.setFieldsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._DictionaryGetRequest} returns this
 */
proto._DictionaryGetRequest.prototype.addFields = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._DictionaryGetRequest} returns this
 */
proto._DictionaryGetRequest.prototype.clearFieldsList = function() {
  return this.setFieldsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._DictionaryGetResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._DictionaryGetResponse.DictionaryCase = {
  DICTIONARY_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._DictionaryGetResponse.DictionaryCase}
 */
proto._DictionaryGetResponse.prototype.getDictionaryCase = function() {
  return /** @type {proto._DictionaryGetResponse.DictionaryCase} */(jspb.Message.computeOneofCase(this, proto._DictionaryGetResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryGetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryGetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryGetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._DictionaryGetResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._DictionaryGetResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryGetResponse}
 */
proto._DictionaryGetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryGetResponse;
  return proto._DictionaryGetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryGetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryGetResponse}
 */
proto._DictionaryGetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._DictionaryGetResponse._Found;
      reader.readMessage(value,proto._DictionaryGetResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._DictionaryGetResponse._Missing;
      reader.readMessage(value,proto._DictionaryGetResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryGetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryGetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryGetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._DictionaryGetResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._DictionaryGetResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryGetResponse._DictionaryGetResponsePart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryGetResponse._DictionaryGetResponsePart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cacheBody: msg.getCacheBody_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryGetResponse._DictionaryGetResponsePart}
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryGetResponse._DictionaryGetResponsePart;
  return proto._DictionaryGetResponse._DictionaryGetResponsePart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryGetResponse._DictionaryGetResponsePart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryGetResponse._DictionaryGetResponsePart}
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ECacheResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCacheBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryGetResponse._DictionaryGetResponsePart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryGetResponse._DictionaryGetResponsePart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCacheBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional ECacheResult result = 1;
 * @return {!proto.ECacheResult}
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.prototype.getResult = function() {
  return /** @type {!proto.ECacheResult} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ECacheResult} value
 * @return {!proto._DictionaryGetResponse._DictionaryGetResponsePart} returns this
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bytes cache_body = 2;
 * @return {string}
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.prototype.getCacheBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes cache_body = 2;
 * This is a type-conversion wrapper around `getCacheBody()`
 * @return {string}
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.prototype.getCacheBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCacheBody()));
};


/**
 * optional bytes cache_body = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCacheBody()`
 * @return {!Uint8Array}
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.prototype.getCacheBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCacheBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryGetResponse._DictionaryGetResponsePart} returns this
 */
proto._DictionaryGetResponse._DictionaryGetResponsePart.prototype.setCacheBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._DictionaryGetResponse._Found.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryGetResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryGetResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryGetResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto._DictionaryGetResponse._DictionaryGetResponsePart.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryGetResponse._Found}
 */
proto._DictionaryGetResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryGetResponse._Found;
  return proto._DictionaryGetResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryGetResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryGetResponse._Found}
 */
proto._DictionaryGetResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._DictionaryGetResponse._DictionaryGetResponsePart;
      reader.readMessage(value,proto._DictionaryGetResponse._DictionaryGetResponsePart.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryGetResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryGetResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryGetResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto._DictionaryGetResponse._DictionaryGetResponsePart.serializeBinaryToWriter
    );
  }
};


/**
 * repeated _DictionaryGetResponsePart items = 1;
 * @return {!Array<!proto._DictionaryGetResponse._DictionaryGetResponsePart>}
 */
proto._DictionaryGetResponse._Found.prototype.getItemsList = function() {
  return /** @type{!Array<!proto._DictionaryGetResponse._DictionaryGetResponsePart>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto._DictionaryGetResponse._DictionaryGetResponsePart, 1));
};


/**
 * @param {!Array<!proto._DictionaryGetResponse._DictionaryGetResponsePart>} value
 * @return {!proto._DictionaryGetResponse._Found} returns this
*/
proto._DictionaryGetResponse._Found.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto._DictionaryGetResponse._DictionaryGetResponsePart=} opt_value
 * @param {number=} opt_index
 * @return {!proto._DictionaryGetResponse._DictionaryGetResponsePart}
 */
proto._DictionaryGetResponse._Found.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto._DictionaryGetResponse._DictionaryGetResponsePart, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._DictionaryGetResponse._Found} returns this
 */
proto._DictionaryGetResponse._Found.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryGetResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryGetResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryGetResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryGetResponse._Missing}
 */
proto._DictionaryGetResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryGetResponse._Missing;
  return proto._DictionaryGetResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryGetResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryGetResponse._Missing}
 */
proto._DictionaryGetResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryGetResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryGetResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryGetResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryGetResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._DictionaryGetResponse._Found}
 */
proto._DictionaryGetResponse.prototype.getFound = function() {
  return /** @type{?proto._DictionaryGetResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._DictionaryGetResponse._Found, 1));
};


/**
 * @param {?proto._DictionaryGetResponse._Found|undefined} value
 * @return {!proto._DictionaryGetResponse} returns this
*/
proto._DictionaryGetResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._DictionaryGetResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._DictionaryGetResponse} returns this
 */
proto._DictionaryGetResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._DictionaryGetResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._DictionaryGetResponse._Missing}
 */
proto._DictionaryGetResponse.prototype.getMissing = function() {
  return /** @type{?proto._DictionaryGetResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._DictionaryGetResponse._Missing, 2));
};


/**
 * @param {?proto._DictionaryGetResponse._Missing|undefined} value
 * @return {!proto._DictionaryGetResponse} returns this
*/
proto._DictionaryGetResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._DictionaryGetResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._DictionaryGetResponse} returns this
 */
proto._DictionaryGetResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._DictionaryGetResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryFetchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryFetchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryFetchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFetchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dictionaryName: msg.getDictionaryName_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryFetchRequest}
 */
proto._DictionaryFetchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryFetchRequest;
  return proto._DictionaryFetchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryFetchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryFetchRequest}
 */
proto._DictionaryFetchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDictionaryName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryFetchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryFetchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryFetchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFetchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDictionaryName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes dictionary_name = 1;
 * @return {string}
 */
proto._DictionaryFetchRequest.prototype.getDictionaryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes dictionary_name = 1;
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {string}
 */
proto._DictionaryFetchRequest.prototype.getDictionaryName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDictionaryName()));
};


/**
 * optional bytes dictionary_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {!Uint8Array}
 */
proto._DictionaryFetchRequest.prototype.getDictionaryName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDictionaryName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryFetchRequest} returns this
 */
proto._DictionaryFetchRequest.prototype.setDictionaryName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryFieldValuePair.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryFieldValuePair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryFieldValuePair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFieldValuePair.toObject = function(includeInstance, msg) {
  var f, obj = {
    field: msg.getField_asB64(),
    value: msg.getValue_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryFieldValuePair}
 */
proto._DictionaryFieldValuePair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryFieldValuePair;
  return proto._DictionaryFieldValuePair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryFieldValuePair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryFieldValuePair}
 */
proto._DictionaryFieldValuePair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setField(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryFieldValuePair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryFieldValuePair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryFieldValuePair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFieldValuePair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getValue_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional bytes field = 1;
 * @return {string}
 */
proto._DictionaryFieldValuePair.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes field = 1;
 * This is a type-conversion wrapper around `getField()`
 * @return {string}
 */
proto._DictionaryFieldValuePair.prototype.getField_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getField()));
};


/**
 * optional bytes field = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getField()`
 * @return {!Uint8Array}
 */
proto._DictionaryFieldValuePair.prototype.getField_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getField()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryFieldValuePair} returns this
 */
proto._DictionaryFieldValuePair.prototype.setField = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes value = 2;
 * @return {string}
 */
proto._DictionaryFieldValuePair.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes value = 2;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */
proto._DictionaryFieldValuePair.prototype.getValue_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getValue()));
};


/**
 * optional bytes value = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */
proto._DictionaryFieldValuePair.prototype.getValue_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getValue()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryFieldValuePair} returns this
 */
proto._DictionaryFieldValuePair.prototype.setValue = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._DictionaryFetchResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._DictionaryFetchResponse.DictionaryCase = {
  DICTIONARY_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._DictionaryFetchResponse.DictionaryCase}
 */
proto._DictionaryFetchResponse.prototype.getDictionaryCase = function() {
  return /** @type {proto._DictionaryFetchResponse.DictionaryCase} */(jspb.Message.computeOneofCase(this, proto._DictionaryFetchResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryFetchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryFetchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryFetchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFetchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._DictionaryFetchResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._DictionaryFetchResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryFetchResponse}
 */
proto._DictionaryFetchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryFetchResponse;
  return proto._DictionaryFetchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryFetchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryFetchResponse}
 */
proto._DictionaryFetchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._DictionaryFetchResponse._Found;
      reader.readMessage(value,proto._DictionaryFetchResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._DictionaryFetchResponse._Missing;
      reader.readMessage(value,proto._DictionaryFetchResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryFetchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryFetchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryFetchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFetchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._DictionaryFetchResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._DictionaryFetchResponse._Missing.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._DictionaryFetchResponse._Found.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryFetchResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryFetchResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryFetchResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFetchResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto._DictionaryFieldValuePair.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryFetchResponse._Found}
 */
proto._DictionaryFetchResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryFetchResponse._Found;
  return proto._DictionaryFetchResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryFetchResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryFetchResponse._Found}
 */
proto._DictionaryFetchResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._DictionaryFieldValuePair;
      reader.readMessage(value,proto._DictionaryFieldValuePair.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryFetchResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryFetchResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryFetchResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFetchResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto._DictionaryFieldValuePair.serializeBinaryToWriter
    );
  }
};


/**
 * repeated _DictionaryFieldValuePair items = 1;
 * @return {!Array<!proto._DictionaryFieldValuePair>}
 */
proto._DictionaryFetchResponse._Found.prototype.getItemsList = function() {
  return /** @type{!Array<!proto._DictionaryFieldValuePair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto._DictionaryFieldValuePair, 1));
};


/**
 * @param {!Array<!proto._DictionaryFieldValuePair>} value
 * @return {!proto._DictionaryFetchResponse._Found} returns this
*/
proto._DictionaryFetchResponse._Found.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto._DictionaryFieldValuePair=} opt_value
 * @param {number=} opt_index
 * @return {!proto._DictionaryFieldValuePair}
 */
proto._DictionaryFetchResponse._Found.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto._DictionaryFieldValuePair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._DictionaryFetchResponse._Found} returns this
 */
proto._DictionaryFetchResponse._Found.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryFetchResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryFetchResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryFetchResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFetchResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryFetchResponse._Missing}
 */
proto._DictionaryFetchResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryFetchResponse._Missing;
  return proto._DictionaryFetchResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryFetchResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryFetchResponse._Missing}
 */
proto._DictionaryFetchResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryFetchResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryFetchResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryFetchResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryFetchResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._DictionaryFetchResponse._Found}
 */
proto._DictionaryFetchResponse.prototype.getFound = function() {
  return /** @type{?proto._DictionaryFetchResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._DictionaryFetchResponse._Found, 1));
};


/**
 * @param {?proto._DictionaryFetchResponse._Found|undefined} value
 * @return {!proto._DictionaryFetchResponse} returns this
*/
proto._DictionaryFetchResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._DictionaryFetchResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._DictionaryFetchResponse} returns this
 */
proto._DictionaryFetchResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._DictionaryFetchResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._DictionaryFetchResponse._Missing}
 */
proto._DictionaryFetchResponse.prototype.getMissing = function() {
  return /** @type{?proto._DictionaryFetchResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._DictionaryFetchResponse._Missing, 2));
};


/**
 * @param {?proto._DictionaryFetchResponse._Missing|undefined} value
 * @return {!proto._DictionaryFetchResponse} returns this
*/
proto._DictionaryFetchResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._DictionaryFetchResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._DictionaryFetchResponse} returns this
 */
proto._DictionaryFetchResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._DictionaryFetchResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._DictionarySetRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionarySetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionarySetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionarySetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionarySetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dictionaryName: msg.getDictionaryName_asB64(),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto._DictionaryFieldValuePair.toObject, includeInstance),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionarySetRequest}
 */
proto._DictionarySetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionarySetRequest;
  return proto._DictionarySetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionarySetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionarySetRequest}
 */
proto._DictionarySetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDictionaryName(value);
      break;
    case 2:
      var value = new proto._DictionaryFieldValuePair;
      reader.readMessage(value,proto._DictionaryFieldValuePair.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionarySetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionarySetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionarySetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionarySetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDictionaryName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto._DictionaryFieldValuePair.serializeBinaryToWriter
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bytes dictionary_name = 1;
 * @return {string}
 */
proto._DictionarySetRequest.prototype.getDictionaryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes dictionary_name = 1;
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {string}
 */
proto._DictionarySetRequest.prototype.getDictionaryName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDictionaryName()));
};


/**
 * optional bytes dictionary_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {!Uint8Array}
 */
proto._DictionarySetRequest.prototype.getDictionaryName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDictionaryName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionarySetRequest} returns this
 */
proto._DictionarySetRequest.prototype.setDictionaryName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * repeated _DictionaryFieldValuePair items = 2;
 * @return {!Array<!proto._DictionaryFieldValuePair>}
 */
proto._DictionarySetRequest.prototype.getItemsList = function() {
  return /** @type{!Array<!proto._DictionaryFieldValuePair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto._DictionaryFieldValuePair, 2));
};


/**
 * @param {!Array<!proto._DictionaryFieldValuePair>} value
 * @return {!proto._DictionarySetRequest} returns this
*/
proto._DictionarySetRequest.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto._DictionaryFieldValuePair=} opt_value
 * @param {number=} opt_index
 * @return {!proto._DictionaryFieldValuePair}
 */
proto._DictionarySetRequest.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto._DictionaryFieldValuePair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._DictionarySetRequest} returns this
 */
proto._DictionarySetRequest.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._DictionarySetRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._DictionarySetRequest} returns this
 */
proto._DictionarySetRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool refresh_ttl = 4;
 * @return {boolean}
 */
proto._DictionarySetRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto._DictionarySetRequest} returns this
 */
proto._DictionarySetRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionarySetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionarySetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionarySetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionarySetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionarySetResponse}
 */
proto._DictionarySetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionarySetResponse;
  return proto._DictionarySetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionarySetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionarySetResponse}
 */
proto._DictionarySetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionarySetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionarySetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionarySetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionarySetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryIncrementRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryIncrementRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryIncrementRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryIncrementRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dictionaryName: msg.getDictionaryName_asB64(),
    field: msg.getField_asB64(),
    amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 4, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryIncrementRequest}
 */
proto._DictionaryIncrementRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryIncrementRequest;
  return proto._DictionaryIncrementRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryIncrementRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryIncrementRequest}
 */
proto._DictionaryIncrementRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDictionaryName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryIncrementRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryIncrementRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryIncrementRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryIncrementRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDictionaryName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getField_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional bytes dictionary_name = 1;
 * @return {string}
 */
proto._DictionaryIncrementRequest.prototype.getDictionaryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes dictionary_name = 1;
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {string}
 */
proto._DictionaryIncrementRequest.prototype.getDictionaryName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDictionaryName()));
};


/**
 * optional bytes dictionary_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {!Uint8Array}
 */
proto._DictionaryIncrementRequest.prototype.getDictionaryName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDictionaryName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryIncrementRequest} returns this
 */
proto._DictionaryIncrementRequest.prototype.setDictionaryName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes field = 2;
 * @return {string}
 */
proto._DictionaryIncrementRequest.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes field = 2;
 * This is a type-conversion wrapper around `getField()`
 * @return {string}
 */
proto._DictionaryIncrementRequest.prototype.getField_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getField()));
};


/**
 * optional bytes field = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getField()`
 * @return {!Uint8Array}
 */
proto._DictionaryIncrementRequest.prototype.getField_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getField()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryIncrementRequest} returns this
 */
proto._DictionaryIncrementRequest.prototype.setField = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional int64 amount = 3;
 * @return {number}
 */
proto._DictionaryIncrementRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._DictionaryIncrementRequest} returns this
 */
proto._DictionaryIncrementRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 ttl_milliseconds = 4;
 * @return {number}
 */
proto._DictionaryIncrementRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto._DictionaryIncrementRequest} returns this
 */
proto._DictionaryIncrementRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool refresh_ttl = 5;
 * @return {boolean}
 */
proto._DictionaryIncrementRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto._DictionaryIncrementRequest} returns this
 */
proto._DictionaryIncrementRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryIncrementResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryIncrementResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryIncrementResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryIncrementResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryIncrementResponse}
 */
proto._DictionaryIncrementResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryIncrementResponse;
  return proto._DictionaryIncrementResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryIncrementResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryIncrementResponse}
 */
proto._DictionaryIncrementResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryIncrementResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryIncrementResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryIncrementResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryIncrementResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto._DictionaryIncrementResponse.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._DictionaryIncrementResponse} returns this
 */
proto._DictionaryIncrementResponse.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._DictionaryDeleteRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto._DictionaryDeleteRequest.DeleteCase = {
  DELETE_NOT_SET: 0,
  SOME: 2,
  ALL: 3
};

/**
 * @return {proto._DictionaryDeleteRequest.DeleteCase}
 */
proto._DictionaryDeleteRequest.prototype.getDeleteCase = function() {
  return /** @type {proto._DictionaryDeleteRequest.DeleteCase} */(jspb.Message.computeOneofCase(this, proto._DictionaryDeleteRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryDeleteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryDeleteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryDeleteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryDeleteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dictionaryName: msg.getDictionaryName_asB64(),
    some: (f = msg.getSome()) && proto._DictionaryDeleteRequest.Some.toObject(includeInstance, f),
    all: (f = msg.getAll()) && proto._DictionaryDeleteRequest.All.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryDeleteRequest}
 */
proto._DictionaryDeleteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryDeleteRequest;
  return proto._DictionaryDeleteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryDeleteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryDeleteRequest}
 */
proto._DictionaryDeleteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDictionaryName(value);
      break;
    case 2:
      var value = new proto._DictionaryDeleteRequest.Some;
      reader.readMessage(value,proto._DictionaryDeleteRequest.Some.deserializeBinaryFromReader);
      msg.setSome(value);
      break;
    case 3:
      var value = new proto._DictionaryDeleteRequest.All;
      reader.readMessage(value,proto._DictionaryDeleteRequest.All.deserializeBinaryFromReader);
      msg.setAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryDeleteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryDeleteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryDeleteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryDeleteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDictionaryName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getSome();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._DictionaryDeleteRequest.Some.serializeBinaryToWriter
    );
  }
  f = message.getAll();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto._DictionaryDeleteRequest.All.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._DictionaryDeleteRequest.Some.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryDeleteRequest.Some.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryDeleteRequest.Some.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryDeleteRequest.Some} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryDeleteRequest.Some.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldsList: msg.getFieldsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryDeleteRequest.Some}
 */
proto._DictionaryDeleteRequest.Some.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryDeleteRequest.Some;
  return proto._DictionaryDeleteRequest.Some.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryDeleteRequest.Some} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryDeleteRequest.Some}
 */
proto._DictionaryDeleteRequest.Some.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryDeleteRequest.Some.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryDeleteRequest.Some.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryDeleteRequest.Some} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryDeleteRequest.Some.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes fields = 1;
 * @return {!Array<string>}
 */
proto._DictionaryDeleteRequest.Some.prototype.getFieldsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes fields = 1;
 * This is a type-conversion wrapper around `getFieldsList()`
 * @return {!Array<string>}
 */
proto._DictionaryDeleteRequest.Some.prototype.getFieldsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getFieldsList()));
};


/**
 * repeated bytes fields = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFieldsList()`
 * @return {!Array<!Uint8Array>}
 */
proto._DictionaryDeleteRequest.Some.prototype.getFieldsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getFieldsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._DictionaryDeleteRequest.Some} returns this
 */
proto._DictionaryDeleteRequest.Some.prototype.setFieldsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._DictionaryDeleteRequest.Some} returns this
 */
proto._DictionaryDeleteRequest.Some.prototype.addFields = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._DictionaryDeleteRequest.Some} returns this
 */
proto._DictionaryDeleteRequest.Some.prototype.clearFieldsList = function() {
  return this.setFieldsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryDeleteRequest.All.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryDeleteRequest.All.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryDeleteRequest.All} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryDeleteRequest.All.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryDeleteRequest.All}
 */
proto._DictionaryDeleteRequest.All.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryDeleteRequest.All;
  return proto._DictionaryDeleteRequest.All.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryDeleteRequest.All} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryDeleteRequest.All}
 */
proto._DictionaryDeleteRequest.All.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryDeleteRequest.All.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryDeleteRequest.All.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryDeleteRequest.All} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryDeleteRequest.All.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional bytes dictionary_name = 1;
 * @return {string}
 */
proto._DictionaryDeleteRequest.prototype.getDictionaryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes dictionary_name = 1;
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {string}
 */
proto._DictionaryDeleteRequest.prototype.getDictionaryName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDictionaryName()));
};


/**
 * optional bytes dictionary_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {!Uint8Array}
 */
proto._DictionaryDeleteRequest.prototype.getDictionaryName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDictionaryName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryDeleteRequest} returns this
 */
proto._DictionaryDeleteRequest.prototype.setDictionaryName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional Some some = 2;
 * @return {?proto._DictionaryDeleteRequest.Some}
 */
proto._DictionaryDeleteRequest.prototype.getSome = function() {
  return /** @type{?proto._DictionaryDeleteRequest.Some} */ (
    jspb.Message.getWrapperField(this, proto._DictionaryDeleteRequest.Some, 2));
};


/**
 * @param {?proto._DictionaryDeleteRequest.Some|undefined} value
 * @return {!proto._DictionaryDeleteRequest} returns this
*/
proto._DictionaryDeleteRequest.prototype.setSome = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._DictionaryDeleteRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._DictionaryDeleteRequest} returns this
 */
proto._DictionaryDeleteRequest.prototype.clearSome = function() {
  return this.setSome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._DictionaryDeleteRequest.prototype.hasSome = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional All all = 3;
 * @return {?proto._DictionaryDeleteRequest.All}
 */
proto._DictionaryDeleteRequest.prototype.getAll = function() {
  return /** @type{?proto._DictionaryDeleteRequest.All} */ (
    jspb.Message.getWrapperField(this, proto._DictionaryDeleteRequest.All, 3));
};


/**
 * @param {?proto._DictionaryDeleteRequest.All|undefined} value
 * @return {!proto._DictionaryDeleteRequest} returns this
*/
proto._DictionaryDeleteRequest.prototype.setAll = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto._DictionaryDeleteRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._DictionaryDeleteRequest} returns this
 */
proto._DictionaryDeleteRequest.prototype.clearAll = function() {
  return this.setAll(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._DictionaryDeleteRequest.prototype.hasAll = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryDeleteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryDeleteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryDeleteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryDeleteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryDeleteResponse}
 */
proto._DictionaryDeleteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryDeleteResponse;
  return proto._DictionaryDeleteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryDeleteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryDeleteResponse}
 */
proto._DictionaryDeleteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryDeleteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryDeleteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryDeleteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryDeleteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryLengthRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryLengthRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryLengthRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryLengthRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dictionaryName: msg.getDictionaryName_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryLengthRequest}
 */
proto._DictionaryLengthRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryLengthRequest;
  return proto._DictionaryLengthRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryLengthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryLengthRequest}
 */
proto._DictionaryLengthRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDictionaryName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryLengthRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryLengthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryLengthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryLengthRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDictionaryName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes dictionary_name = 1;
 * @return {string}
 */
proto._DictionaryLengthRequest.prototype.getDictionaryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes dictionary_name = 1;
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {string}
 */
proto._DictionaryLengthRequest.prototype.getDictionaryName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDictionaryName()));
};


/**
 * optional bytes dictionary_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDictionaryName()`
 * @return {!Uint8Array}
 */
proto._DictionaryLengthRequest.prototype.getDictionaryName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDictionaryName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._DictionaryLengthRequest} returns this
 */
proto._DictionaryLengthRequest.prototype.setDictionaryName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._DictionaryLengthResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._DictionaryLengthResponse.DictionaryCase = {
  DICTIONARY_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._DictionaryLengthResponse.DictionaryCase}
 */
proto._DictionaryLengthResponse.prototype.getDictionaryCase = function() {
  return /** @type {proto._DictionaryLengthResponse.DictionaryCase} */(jspb.Message.computeOneofCase(this, proto._DictionaryLengthResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryLengthResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryLengthResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryLengthResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryLengthResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._DictionaryLengthResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._DictionaryLengthResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryLengthResponse}
 */
proto._DictionaryLengthResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryLengthResponse;
  return proto._DictionaryLengthResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryLengthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryLengthResponse}
 */
proto._DictionaryLengthResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._DictionaryLengthResponse._Found;
      reader.readMessage(value,proto._DictionaryLengthResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._DictionaryLengthResponse._Missing;
      reader.readMessage(value,proto._DictionaryLengthResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryLengthResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryLengthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryLengthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryLengthResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._DictionaryLengthResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._DictionaryLengthResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryLengthResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryLengthResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryLengthResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryLengthResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    length: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryLengthResponse._Found}
 */
proto._DictionaryLengthResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryLengthResponse._Found;
  return proto._DictionaryLengthResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryLengthResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryLengthResponse._Found}
 */
proto._DictionaryLengthResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryLengthResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryLengthResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryLengthResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryLengthResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 length = 1;
 * @return {number}
 */
proto._DictionaryLengthResponse._Found.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._DictionaryLengthResponse._Found} returns this
 */
proto._DictionaryLengthResponse._Found.prototype.setLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._DictionaryLengthResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._DictionaryLengthResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._DictionaryLengthResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryLengthResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._DictionaryLengthResponse._Missing}
 */
proto._DictionaryLengthResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._DictionaryLengthResponse._Missing;
  return proto._DictionaryLengthResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._DictionaryLengthResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._DictionaryLengthResponse._Missing}
 */
proto._DictionaryLengthResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._DictionaryLengthResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._DictionaryLengthResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._DictionaryLengthResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._DictionaryLengthResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._DictionaryLengthResponse._Found}
 */
proto._DictionaryLengthResponse.prototype.getFound = function() {
  return /** @type{?proto._DictionaryLengthResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._DictionaryLengthResponse._Found, 1));
};


/**
 * @param {?proto._DictionaryLengthResponse._Found|undefined} value
 * @return {!proto._DictionaryLengthResponse} returns this
*/
proto._DictionaryLengthResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._DictionaryLengthResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._DictionaryLengthResponse} returns this
 */
proto._DictionaryLengthResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._DictionaryLengthResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._DictionaryLengthResponse._Missing}
 */
proto._DictionaryLengthResponse.prototype.getMissing = function() {
  return /** @type{?proto._DictionaryLengthResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._DictionaryLengthResponse._Missing, 2));
};


/**
 * @param {?proto._DictionaryLengthResponse._Missing|undefined} value
 * @return {!proto._DictionaryLengthResponse} returns this
*/
proto._DictionaryLengthResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._DictionaryLengthResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._DictionaryLengthResponse} returns this
 */
proto._DictionaryLengthResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._DictionaryLengthResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetFetchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SetFetchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetFetchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetFetchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetFetchRequest}
 */
proto._SetFetchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetFetchRequest;
  return proto._SetFetchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetFetchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetFetchRequest}
 */
proto._SetFetchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetFetchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetFetchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetFetchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetFetchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SetFetchRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SetFetchRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SetFetchRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetFetchRequest} returns this
 */
proto._SetFetchRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SetFetchResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SetFetchResponse.SetCase = {
  SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SetFetchResponse.SetCase}
 */
proto._SetFetchResponse.prototype.getSetCase = function() {
  return /** @type {proto._SetFetchResponse.SetCase} */(jspb.Message.computeOneofCase(this, proto._SetFetchResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetFetchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SetFetchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetFetchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetFetchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SetFetchResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SetFetchResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetFetchResponse}
 */
proto._SetFetchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetFetchResponse;
  return proto._SetFetchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetFetchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetFetchResponse}
 */
proto._SetFetchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SetFetchResponse._Found;
      reader.readMessage(value,proto._SetFetchResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SetFetchResponse._Missing;
      reader.readMessage(value,proto._SetFetchResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetFetchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetFetchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetFetchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetFetchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SetFetchResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SetFetchResponse._Missing.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SetFetchResponse._Found.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetFetchResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._SetFetchResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetFetchResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetFetchResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementsList: msg.getElementsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetFetchResponse._Found}
 */
proto._SetFetchResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetFetchResponse._Found;
  return proto._SetFetchResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetFetchResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetFetchResponse._Found}
 */
proto._SetFetchResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetFetchResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetFetchResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetFetchResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetFetchResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes elements = 1;
 * @return {!Array<string>}
 */
proto._SetFetchResponse._Found.prototype.getElementsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes elements = 1;
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<string>}
 */
proto._SetFetchResponse._Found.prototype.getElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getElementsList()));
};


/**
 * repeated bytes elements = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SetFetchResponse._Found.prototype.getElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SetFetchResponse._Found} returns this
 */
proto._SetFetchResponse._Found.prototype.setElementsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SetFetchResponse._Found} returns this
 */
proto._SetFetchResponse._Found.prototype.addElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SetFetchResponse._Found} returns this
 */
proto._SetFetchResponse._Found.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetFetchResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._SetFetchResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetFetchResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetFetchResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetFetchResponse._Missing}
 */
proto._SetFetchResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetFetchResponse._Missing;
  return proto._SetFetchResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetFetchResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetFetchResponse._Missing}
 */
proto._SetFetchResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetFetchResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetFetchResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetFetchResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetFetchResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._SetFetchResponse._Found}
 */
proto._SetFetchResponse.prototype.getFound = function() {
  return /** @type{?proto._SetFetchResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._SetFetchResponse._Found, 1));
};


/**
 * @param {?proto._SetFetchResponse._Found|undefined} value
 * @return {!proto._SetFetchResponse} returns this
*/
proto._SetFetchResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SetFetchResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetFetchResponse} returns this
 */
proto._SetFetchResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetFetchResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._SetFetchResponse._Missing}
 */
proto._SetFetchResponse.prototype.getMissing = function() {
  return /** @type{?proto._SetFetchResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._SetFetchResponse._Missing, 2));
};


/**
 * @param {?proto._SetFetchResponse._Missing|undefined} value
 * @return {!proto._SetFetchResponse} returns this
*/
proto._SetFetchResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SetFetchResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetFetchResponse} returns this
 */
proto._SetFetchResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetFetchResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SetUnionRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetUnionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SetUnionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetUnionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetUnionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    elementsList: msg.getElementsList_asB64(),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetUnionRequest}
 */
proto._SetUnionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetUnionRequest;
  return proto._SetUnionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetUnionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetUnionRequest}
 */
proto._SetUnionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addElements(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetUnionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetUnionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetUnionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetUnionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      2,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SetUnionRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SetUnionRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SetUnionRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetUnionRequest} returns this
 */
proto._SetUnionRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * repeated bytes elements = 2;
 * @return {!Array<string>}
 */
proto._SetUnionRequest.prototype.getElementsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * repeated bytes elements = 2;
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<string>}
 */
proto._SetUnionRequest.prototype.getElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getElementsList()));
};


/**
 * repeated bytes elements = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SetUnionRequest.prototype.getElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SetUnionRequest} returns this
 */
proto._SetUnionRequest.prototype.setElementsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SetUnionRequest} returns this
 */
proto._SetUnionRequest.prototype.addElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SetUnionRequest} returns this
 */
proto._SetUnionRequest.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._SetUnionRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._SetUnionRequest} returns this
 */
proto._SetUnionRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool refresh_ttl = 4;
 * @return {boolean}
 */
proto._SetUnionRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto._SetUnionRequest} returns this
 */
proto._SetUnionRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetUnionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SetUnionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetUnionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetUnionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetUnionResponse}
 */
proto._SetUnionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetUnionResponse;
  return proto._SetUnionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetUnionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetUnionResponse}
 */
proto._SetUnionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetUnionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetUnionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetUnionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetUnionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SetDifferenceRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto._SetDifferenceRequest.DifferenceCase = {
  DIFFERENCE_NOT_SET: 0,
  MINUEND: 2,
  SUBTRAHEND: 3
};

/**
 * @return {proto._SetDifferenceRequest.DifferenceCase}
 */
proto._SetDifferenceRequest.prototype.getDifferenceCase = function() {
  return /** @type {proto._SetDifferenceRequest.DifferenceCase} */(jspb.Message.computeOneofCase(this, proto._SetDifferenceRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetDifferenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SetDifferenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetDifferenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    minuend: (f = msg.getMinuend()) && proto._SetDifferenceRequest._Minuend.toObject(includeInstance, f),
    subtrahend: (f = msg.getSubtrahend()) && proto._SetDifferenceRequest._Subtrahend.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetDifferenceRequest}
 */
proto._SetDifferenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetDifferenceRequest;
  return proto._SetDifferenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetDifferenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetDifferenceRequest}
 */
proto._SetDifferenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = new proto._SetDifferenceRequest._Minuend;
      reader.readMessage(value,proto._SetDifferenceRequest._Minuend.deserializeBinaryFromReader);
      msg.setMinuend(value);
      break;
    case 3:
      var value = new proto._SetDifferenceRequest._Subtrahend;
      reader.readMessage(value,proto._SetDifferenceRequest._Subtrahend.deserializeBinaryFromReader);
      msg.setSubtrahend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetDifferenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetDifferenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetDifferenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getMinuend();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SetDifferenceRequest._Minuend.serializeBinaryToWriter
    );
  }
  f = message.getSubtrahend();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto._SetDifferenceRequest._Subtrahend.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SetDifferenceRequest._Minuend.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetDifferenceRequest._Minuend.prototype.toObject = function(opt_includeInstance) {
  return proto._SetDifferenceRequest._Minuend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetDifferenceRequest._Minuend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest._Minuend.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementsList: msg.getElementsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetDifferenceRequest._Minuend}
 */
proto._SetDifferenceRequest._Minuend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetDifferenceRequest._Minuend;
  return proto._SetDifferenceRequest._Minuend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetDifferenceRequest._Minuend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetDifferenceRequest._Minuend}
 */
proto._SetDifferenceRequest._Minuend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetDifferenceRequest._Minuend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetDifferenceRequest._Minuend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetDifferenceRequest._Minuend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest._Minuend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes elements = 1;
 * @return {!Array<string>}
 */
proto._SetDifferenceRequest._Minuend.prototype.getElementsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes elements = 1;
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<string>}
 */
proto._SetDifferenceRequest._Minuend.prototype.getElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getElementsList()));
};


/**
 * repeated bytes elements = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SetDifferenceRequest._Minuend.prototype.getElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SetDifferenceRequest._Minuend} returns this
 */
proto._SetDifferenceRequest._Minuend.prototype.setElementsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SetDifferenceRequest._Minuend} returns this
 */
proto._SetDifferenceRequest._Minuend.prototype.addElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SetDifferenceRequest._Minuend} returns this
 */
proto._SetDifferenceRequest._Minuend.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SetDifferenceRequest._Subtrahend.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SetDifferenceRequest._Subtrahend.SubtrahendSetCase = {
  SUBTRAHEND_SET_NOT_SET: 0,
  SET: 1,
  IDENTITY: 2
};

/**
 * @return {proto._SetDifferenceRequest._Subtrahend.SubtrahendSetCase}
 */
proto._SetDifferenceRequest._Subtrahend.prototype.getSubtrahendSetCase = function() {
  return /** @type {proto._SetDifferenceRequest._Subtrahend.SubtrahendSetCase} */(jspb.Message.computeOneofCase(this, proto._SetDifferenceRequest._Subtrahend.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetDifferenceRequest._Subtrahend.prototype.toObject = function(opt_includeInstance) {
  return proto._SetDifferenceRequest._Subtrahend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetDifferenceRequest._Subtrahend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest._Subtrahend.toObject = function(includeInstance, msg) {
  var f, obj = {
    set: (f = msg.getSet()) && proto._SetDifferenceRequest._Subtrahend._Set.toObject(includeInstance, f),
    identity: (f = msg.getIdentity()) && proto._SetDifferenceRequest._Subtrahend._Identity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetDifferenceRequest._Subtrahend}
 */
proto._SetDifferenceRequest._Subtrahend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetDifferenceRequest._Subtrahend;
  return proto._SetDifferenceRequest._Subtrahend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetDifferenceRequest._Subtrahend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetDifferenceRequest._Subtrahend}
 */
proto._SetDifferenceRequest._Subtrahend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SetDifferenceRequest._Subtrahend._Set;
      reader.readMessage(value,proto._SetDifferenceRequest._Subtrahend._Set.deserializeBinaryFromReader);
      msg.setSet(value);
      break;
    case 2:
      var value = new proto._SetDifferenceRequest._Subtrahend._Identity;
      reader.readMessage(value,proto._SetDifferenceRequest._Subtrahend._Identity.deserializeBinaryFromReader);
      msg.setIdentity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetDifferenceRequest._Subtrahend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetDifferenceRequest._Subtrahend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetDifferenceRequest._Subtrahend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest._Subtrahend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSet();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SetDifferenceRequest._Subtrahend._Set.serializeBinaryToWriter
    );
  }
  f = message.getIdentity();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SetDifferenceRequest._Subtrahend._Identity.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SetDifferenceRequest._Subtrahend._Set.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetDifferenceRequest._Subtrahend._Set.prototype.toObject = function(opt_includeInstance) {
  return proto._SetDifferenceRequest._Subtrahend._Set.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetDifferenceRequest._Subtrahend._Set} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest._Subtrahend._Set.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementsList: msg.getElementsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetDifferenceRequest._Subtrahend._Set}
 */
proto._SetDifferenceRequest._Subtrahend._Set.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetDifferenceRequest._Subtrahend._Set;
  return proto._SetDifferenceRequest._Subtrahend._Set.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetDifferenceRequest._Subtrahend._Set} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetDifferenceRequest._Subtrahend._Set}
 */
proto._SetDifferenceRequest._Subtrahend._Set.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetDifferenceRequest._Subtrahend._Set.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetDifferenceRequest._Subtrahend._Set.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetDifferenceRequest._Subtrahend._Set} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest._Subtrahend._Set.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes elements = 1;
 * @return {!Array<string>}
 */
proto._SetDifferenceRequest._Subtrahend._Set.prototype.getElementsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes elements = 1;
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<string>}
 */
proto._SetDifferenceRequest._Subtrahend._Set.prototype.getElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getElementsList()));
};


/**
 * repeated bytes elements = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SetDifferenceRequest._Subtrahend._Set.prototype.getElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SetDifferenceRequest._Subtrahend._Set} returns this
 */
proto._SetDifferenceRequest._Subtrahend._Set.prototype.setElementsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SetDifferenceRequest._Subtrahend._Set} returns this
 */
proto._SetDifferenceRequest._Subtrahend._Set.prototype.addElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SetDifferenceRequest._Subtrahend._Set} returns this
 */
proto._SetDifferenceRequest._Subtrahend._Set.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetDifferenceRequest._Subtrahend._Identity.prototype.toObject = function(opt_includeInstance) {
  return proto._SetDifferenceRequest._Subtrahend._Identity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetDifferenceRequest._Subtrahend._Identity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest._Subtrahend._Identity.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetDifferenceRequest._Subtrahend._Identity}
 */
proto._SetDifferenceRequest._Subtrahend._Identity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetDifferenceRequest._Subtrahend._Identity;
  return proto._SetDifferenceRequest._Subtrahend._Identity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetDifferenceRequest._Subtrahend._Identity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetDifferenceRequest._Subtrahend._Identity}
 */
proto._SetDifferenceRequest._Subtrahend._Identity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetDifferenceRequest._Subtrahend._Identity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetDifferenceRequest._Subtrahend._Identity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetDifferenceRequest._Subtrahend._Identity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceRequest._Subtrahend._Identity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Set set = 1;
 * @return {?proto._SetDifferenceRequest._Subtrahend._Set}
 */
proto._SetDifferenceRequest._Subtrahend.prototype.getSet = function() {
  return /** @type{?proto._SetDifferenceRequest._Subtrahend._Set} */ (
    jspb.Message.getWrapperField(this, proto._SetDifferenceRequest._Subtrahend._Set, 1));
};


/**
 * @param {?proto._SetDifferenceRequest._Subtrahend._Set|undefined} value
 * @return {!proto._SetDifferenceRequest._Subtrahend} returns this
*/
proto._SetDifferenceRequest._Subtrahend.prototype.setSet = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SetDifferenceRequest._Subtrahend.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetDifferenceRequest._Subtrahend} returns this
 */
proto._SetDifferenceRequest._Subtrahend.prototype.clearSet = function() {
  return this.setSet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetDifferenceRequest._Subtrahend.prototype.hasSet = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Identity identity = 2;
 * @return {?proto._SetDifferenceRequest._Subtrahend._Identity}
 */
proto._SetDifferenceRequest._Subtrahend.prototype.getIdentity = function() {
  return /** @type{?proto._SetDifferenceRequest._Subtrahend._Identity} */ (
    jspb.Message.getWrapperField(this, proto._SetDifferenceRequest._Subtrahend._Identity, 2));
};


/**
 * @param {?proto._SetDifferenceRequest._Subtrahend._Identity|undefined} value
 * @return {!proto._SetDifferenceRequest._Subtrahend} returns this
*/
proto._SetDifferenceRequest._Subtrahend.prototype.setIdentity = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SetDifferenceRequest._Subtrahend.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetDifferenceRequest._Subtrahend} returns this
 */
proto._SetDifferenceRequest._Subtrahend.prototype.clearIdentity = function() {
  return this.setIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetDifferenceRequest._Subtrahend.prototype.hasIdentity = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SetDifferenceRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SetDifferenceRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SetDifferenceRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetDifferenceRequest} returns this
 */
proto._SetDifferenceRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional _Minuend minuend = 2;
 * @return {?proto._SetDifferenceRequest._Minuend}
 */
proto._SetDifferenceRequest.prototype.getMinuend = function() {
  return /** @type{?proto._SetDifferenceRequest._Minuend} */ (
    jspb.Message.getWrapperField(this, proto._SetDifferenceRequest._Minuend, 2));
};


/**
 * @param {?proto._SetDifferenceRequest._Minuend|undefined} value
 * @return {!proto._SetDifferenceRequest} returns this
*/
proto._SetDifferenceRequest.prototype.setMinuend = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SetDifferenceRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetDifferenceRequest} returns this
 */
proto._SetDifferenceRequest.prototype.clearMinuend = function() {
  return this.setMinuend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetDifferenceRequest.prototype.hasMinuend = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional _Subtrahend subtrahend = 3;
 * @return {?proto._SetDifferenceRequest._Subtrahend}
 */
proto._SetDifferenceRequest.prototype.getSubtrahend = function() {
  return /** @type{?proto._SetDifferenceRequest._Subtrahend} */ (
    jspb.Message.getWrapperField(this, proto._SetDifferenceRequest._Subtrahend, 3));
};


/**
 * @param {?proto._SetDifferenceRequest._Subtrahend|undefined} value
 * @return {!proto._SetDifferenceRequest} returns this
*/
proto._SetDifferenceRequest.prototype.setSubtrahend = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto._SetDifferenceRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetDifferenceRequest} returns this
 */
proto._SetDifferenceRequest.prototype.clearSubtrahend = function() {
  return this.setSubtrahend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetDifferenceRequest.prototype.hasSubtrahend = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SetDifferenceResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SetDifferenceResponse.SetCase = {
  SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SetDifferenceResponse.SetCase}
 */
proto._SetDifferenceResponse.prototype.getSetCase = function() {
  return /** @type {proto._SetDifferenceResponse.SetCase} */(jspb.Message.computeOneofCase(this, proto._SetDifferenceResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetDifferenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SetDifferenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetDifferenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SetDifferenceResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SetDifferenceResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetDifferenceResponse}
 */
proto._SetDifferenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetDifferenceResponse;
  return proto._SetDifferenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetDifferenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetDifferenceResponse}
 */
proto._SetDifferenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SetDifferenceResponse._Found;
      reader.readMessage(value,proto._SetDifferenceResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SetDifferenceResponse._Missing;
      reader.readMessage(value,proto._SetDifferenceResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetDifferenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetDifferenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetDifferenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SetDifferenceResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SetDifferenceResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetDifferenceResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._SetDifferenceResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetDifferenceResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetDifferenceResponse._Found}
 */
proto._SetDifferenceResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetDifferenceResponse._Found;
  return proto._SetDifferenceResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetDifferenceResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetDifferenceResponse._Found}
 */
proto._SetDifferenceResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetDifferenceResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetDifferenceResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetDifferenceResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetDifferenceResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._SetDifferenceResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetDifferenceResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetDifferenceResponse._Missing}
 */
proto._SetDifferenceResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetDifferenceResponse._Missing;
  return proto._SetDifferenceResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetDifferenceResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetDifferenceResponse._Missing}
 */
proto._SetDifferenceResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetDifferenceResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetDifferenceResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetDifferenceResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetDifferenceResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._SetDifferenceResponse._Found}
 */
proto._SetDifferenceResponse.prototype.getFound = function() {
  return /** @type{?proto._SetDifferenceResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._SetDifferenceResponse._Found, 1));
};


/**
 * @param {?proto._SetDifferenceResponse._Found|undefined} value
 * @return {!proto._SetDifferenceResponse} returns this
*/
proto._SetDifferenceResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SetDifferenceResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetDifferenceResponse} returns this
 */
proto._SetDifferenceResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetDifferenceResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._SetDifferenceResponse._Missing}
 */
proto._SetDifferenceResponse.prototype.getMissing = function() {
  return /** @type{?proto._SetDifferenceResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._SetDifferenceResponse._Missing, 2));
};


/**
 * @param {?proto._SetDifferenceResponse._Missing|undefined} value
 * @return {!proto._SetDifferenceResponse} returns this
*/
proto._SetDifferenceResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SetDifferenceResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetDifferenceResponse} returns this
 */
proto._SetDifferenceResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetDifferenceResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SetContainsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetContainsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SetContainsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetContainsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetContainsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    elementsList: msg.getElementsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetContainsRequest}
 */
proto._SetContainsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetContainsRequest;
  return proto._SetContainsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetContainsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetContainsRequest}
 */
proto._SetContainsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetContainsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetContainsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetContainsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetContainsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      2,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SetContainsRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SetContainsRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SetContainsRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetContainsRequest} returns this
 */
proto._SetContainsRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * repeated bytes elements = 2;
 * @return {!Array<string>}
 */
proto._SetContainsRequest.prototype.getElementsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * repeated bytes elements = 2;
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<string>}
 */
proto._SetContainsRequest.prototype.getElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getElementsList()));
};


/**
 * repeated bytes elements = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SetContainsRequest.prototype.getElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SetContainsRequest} returns this
 */
proto._SetContainsRequest.prototype.setElementsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SetContainsRequest} returns this
 */
proto._SetContainsRequest.prototype.addElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SetContainsRequest} returns this
 */
proto._SetContainsRequest.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SetContainsResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SetContainsResponse.SetCase = {
  SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SetContainsResponse.SetCase}
 */
proto._SetContainsResponse.prototype.getSetCase = function() {
  return /** @type {proto._SetContainsResponse.SetCase} */(jspb.Message.computeOneofCase(this, proto._SetContainsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetContainsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SetContainsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetContainsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetContainsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SetContainsResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SetContainsResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetContainsResponse}
 */
proto._SetContainsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetContainsResponse;
  return proto._SetContainsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetContainsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetContainsResponse}
 */
proto._SetContainsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SetContainsResponse._Found;
      reader.readMessage(value,proto._SetContainsResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SetContainsResponse._Missing;
      reader.readMessage(value,proto._SetContainsResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetContainsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetContainsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetContainsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetContainsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SetContainsResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SetContainsResponse._Missing.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SetContainsResponse._Found.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetContainsResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._SetContainsResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetContainsResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetContainsResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    containsList: (f = jspb.Message.getRepeatedBooleanField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetContainsResponse._Found}
 */
proto._SetContainsResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetContainsResponse._Found;
  return proto._SetContainsResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetContainsResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetContainsResponse._Found}
 */
proto._SetContainsResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<boolean>} */ (reader.isDelimited() ? reader.readPackedBool() : [reader.readBool()]);
      for (var i = 0; i < values.length; i++) {
        msg.addContains(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetContainsResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetContainsResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetContainsResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetContainsResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContainsList();
  if (f.length > 0) {
    writer.writePackedBool(
      1,
      f
    );
  }
};


/**
 * repeated bool contains = 1;
 * @return {!Array<boolean>}
 */
proto._SetContainsResponse._Found.prototype.getContainsList = function() {
  return /** @type {!Array<boolean>} */ (jspb.Message.getRepeatedBooleanField(this, 1));
};


/**
 * @param {!Array<boolean>} value
 * @return {!proto._SetContainsResponse._Found} returns this
 */
proto._SetContainsResponse._Found.prototype.setContainsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {boolean} value
 * @param {number=} opt_index
 * @return {!proto._SetContainsResponse._Found} returns this
 */
proto._SetContainsResponse._Found.prototype.addContains = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SetContainsResponse._Found} returns this
 */
proto._SetContainsResponse._Found.prototype.clearContainsList = function() {
  return this.setContainsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetContainsResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._SetContainsResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetContainsResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetContainsResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetContainsResponse._Missing}
 */
proto._SetContainsResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetContainsResponse._Missing;
  return proto._SetContainsResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetContainsResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetContainsResponse._Missing}
 */
proto._SetContainsResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetContainsResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetContainsResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetContainsResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetContainsResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._SetContainsResponse._Found}
 */
proto._SetContainsResponse.prototype.getFound = function() {
  return /** @type{?proto._SetContainsResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._SetContainsResponse._Found, 1));
};


/**
 * @param {?proto._SetContainsResponse._Found|undefined} value
 * @return {!proto._SetContainsResponse} returns this
*/
proto._SetContainsResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SetContainsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetContainsResponse} returns this
 */
proto._SetContainsResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetContainsResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._SetContainsResponse._Missing}
 */
proto._SetContainsResponse.prototype.getMissing = function() {
  return /** @type{?proto._SetContainsResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._SetContainsResponse._Missing, 2));
};


/**
 * @param {?proto._SetContainsResponse._Missing|undefined} value
 * @return {!proto._SetContainsResponse} returns this
*/
proto._SetContainsResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SetContainsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetContainsResponse} returns this
 */
proto._SetContainsResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetContainsResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetLengthRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SetLengthRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetLengthRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetLengthRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetLengthRequest}
 */
proto._SetLengthRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetLengthRequest;
  return proto._SetLengthRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetLengthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetLengthRequest}
 */
proto._SetLengthRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetLengthRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetLengthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetLengthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetLengthRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SetLengthRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SetLengthRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SetLengthRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetLengthRequest} returns this
 */
proto._SetLengthRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SetLengthResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SetLengthResponse.SetCase = {
  SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SetLengthResponse.SetCase}
 */
proto._SetLengthResponse.prototype.getSetCase = function() {
  return /** @type {proto._SetLengthResponse.SetCase} */(jspb.Message.computeOneofCase(this, proto._SetLengthResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetLengthResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SetLengthResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetLengthResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetLengthResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SetLengthResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SetLengthResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetLengthResponse}
 */
proto._SetLengthResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetLengthResponse;
  return proto._SetLengthResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetLengthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetLengthResponse}
 */
proto._SetLengthResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SetLengthResponse._Found;
      reader.readMessage(value,proto._SetLengthResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SetLengthResponse._Missing;
      reader.readMessage(value,proto._SetLengthResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetLengthResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetLengthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetLengthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetLengthResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SetLengthResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SetLengthResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetLengthResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._SetLengthResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetLengthResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetLengthResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    length: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetLengthResponse._Found}
 */
proto._SetLengthResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetLengthResponse._Found;
  return proto._SetLengthResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetLengthResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetLengthResponse._Found}
 */
proto._SetLengthResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetLengthResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetLengthResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetLengthResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetLengthResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 length = 1;
 * @return {number}
 */
proto._SetLengthResponse._Found.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._SetLengthResponse._Found} returns this
 */
proto._SetLengthResponse._Found.prototype.setLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetLengthResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._SetLengthResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetLengthResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetLengthResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetLengthResponse._Missing}
 */
proto._SetLengthResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetLengthResponse._Missing;
  return proto._SetLengthResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetLengthResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetLengthResponse._Missing}
 */
proto._SetLengthResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetLengthResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetLengthResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetLengthResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetLengthResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._SetLengthResponse._Found}
 */
proto._SetLengthResponse.prototype.getFound = function() {
  return /** @type{?proto._SetLengthResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._SetLengthResponse._Found, 1));
};


/**
 * @param {?proto._SetLengthResponse._Found|undefined} value
 * @return {!proto._SetLengthResponse} returns this
*/
proto._SetLengthResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SetLengthResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetLengthResponse} returns this
 */
proto._SetLengthResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetLengthResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._SetLengthResponse._Missing}
 */
proto._SetLengthResponse.prototype.getMissing = function() {
  return /** @type{?proto._SetLengthResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._SetLengthResponse._Missing, 2));
};


/**
 * @param {?proto._SetLengthResponse._Missing|undefined} value
 * @return {!proto._SetLengthResponse} returns this
*/
proto._SetLengthResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SetLengthResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetLengthResponse} returns this
 */
proto._SetLengthResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetLengthResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetPopRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SetPopRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetPopRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetPopRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetPopRequest}
 */
proto._SetPopRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetPopRequest;
  return proto._SetPopRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetPopRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetPopRequest}
 */
proto._SetPopRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetPopRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetPopRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetPopRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetPopRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SetPopRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SetPopRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SetPopRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SetPopRequest} returns this
 */
proto._SetPopRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional uint32 count = 2;
 * @return {number}
 */
proto._SetPopRequest.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto._SetPopRequest} returns this
 */
proto._SetPopRequest.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SetPopResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SetPopResponse.SetCase = {
  SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SetPopResponse.SetCase}
 */
proto._SetPopResponse.prototype.getSetCase = function() {
  return /** @type {proto._SetPopResponse.SetCase} */(jspb.Message.computeOneofCase(this, proto._SetPopResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetPopResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SetPopResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetPopResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetPopResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SetPopResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SetPopResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetPopResponse}
 */
proto._SetPopResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetPopResponse;
  return proto._SetPopResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetPopResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetPopResponse}
 */
proto._SetPopResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SetPopResponse._Found;
      reader.readMessage(value,proto._SetPopResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SetPopResponse._Missing;
      reader.readMessage(value,proto._SetPopResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetPopResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetPopResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetPopResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetPopResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SetPopResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SetPopResponse._Missing.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SetPopResponse._Found.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetPopResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._SetPopResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetPopResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetPopResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementsList: msg.getElementsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetPopResponse._Found}
 */
proto._SetPopResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetPopResponse._Found;
  return proto._SetPopResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetPopResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetPopResponse._Found}
 */
proto._SetPopResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetPopResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetPopResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetPopResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetPopResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes elements = 1;
 * @return {!Array<string>}
 */
proto._SetPopResponse._Found.prototype.getElementsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes elements = 1;
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<string>}
 */
proto._SetPopResponse._Found.prototype.getElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getElementsList()));
};


/**
 * repeated bytes elements = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SetPopResponse._Found.prototype.getElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SetPopResponse._Found} returns this
 */
proto._SetPopResponse._Found.prototype.setElementsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SetPopResponse._Found} returns this
 */
proto._SetPopResponse._Found.prototype.addElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SetPopResponse._Found} returns this
 */
proto._SetPopResponse._Found.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SetPopResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._SetPopResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SetPopResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetPopResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SetPopResponse._Missing}
 */
proto._SetPopResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SetPopResponse._Missing;
  return proto._SetPopResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SetPopResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SetPopResponse._Missing}
 */
proto._SetPopResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SetPopResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SetPopResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SetPopResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SetPopResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._SetPopResponse._Found}
 */
proto._SetPopResponse.prototype.getFound = function() {
  return /** @type{?proto._SetPopResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._SetPopResponse._Found, 1));
};


/**
 * @param {?proto._SetPopResponse._Found|undefined} value
 * @return {!proto._SetPopResponse} returns this
*/
proto._SetPopResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SetPopResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetPopResponse} returns this
 */
proto._SetPopResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetPopResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._SetPopResponse._Missing}
 */
proto._SetPopResponse.prototype.getMissing = function() {
  return /** @type{?proto._SetPopResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._SetPopResponse._Missing, 2));
};


/**
 * @param {?proto._SetPopResponse._Missing|undefined} value
 * @return {!proto._SetPopResponse} returns this
*/
proto._SetPopResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SetPopResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SetPopResponse} returns this
 */
proto._SetPopResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SetPopResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._ListConcatenateFrontRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListConcatenateFrontRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListConcatenateFrontRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListConcatenateFrontRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListConcatenateFrontRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64(),
    valuesList: msg.getValuesList_asB64(),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    truncateBackToSize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListConcatenateFrontRequest}
 */
proto._ListConcatenateFrontRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListConcatenateFrontRequest;
  return proto._ListConcatenateFrontRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListConcatenateFrontRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListConcatenateFrontRequest}
 */
proto._ListConcatenateFrontRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addValues(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTruncateBackToSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListConcatenateFrontRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListConcatenateFrontRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListConcatenateFrontRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListConcatenateFrontRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getValuesList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      2,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTruncateBackToSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListConcatenateFrontRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListConcatenateFrontRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListConcatenateFrontRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListConcatenateFrontRequest} returns this
 */
proto._ListConcatenateFrontRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * repeated bytes values = 2;
 * @return {!Array<string>}
 */
proto._ListConcatenateFrontRequest.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * repeated bytes values = 2;
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<string>}
 */
proto._ListConcatenateFrontRequest.prototype.getValuesList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getValuesList()));
};


/**
 * repeated bytes values = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<!Uint8Array>}
 */
proto._ListConcatenateFrontRequest.prototype.getValuesList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getValuesList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._ListConcatenateFrontRequest} returns this
 */
proto._ListConcatenateFrontRequest.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._ListConcatenateFrontRequest} returns this
 */
proto._ListConcatenateFrontRequest.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._ListConcatenateFrontRequest} returns this
 */
proto._ListConcatenateFrontRequest.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._ListConcatenateFrontRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListConcatenateFrontRequest} returns this
 */
proto._ListConcatenateFrontRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool refresh_ttl = 4;
 * @return {boolean}
 */
proto._ListConcatenateFrontRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto._ListConcatenateFrontRequest} returns this
 */
proto._ListConcatenateFrontRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint32 truncate_back_to_size = 5;
 * @return {number}
 */
proto._ListConcatenateFrontRequest.prototype.getTruncateBackToSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListConcatenateFrontRequest} returns this
 */
proto._ListConcatenateFrontRequest.prototype.setTruncateBackToSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListConcatenateFrontResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListConcatenateFrontResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListConcatenateFrontResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListConcatenateFrontResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    listLength: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListConcatenateFrontResponse}
 */
proto._ListConcatenateFrontResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListConcatenateFrontResponse;
  return proto._ListConcatenateFrontResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListConcatenateFrontResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListConcatenateFrontResponse}
 */
proto._ListConcatenateFrontResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListConcatenateFrontResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListConcatenateFrontResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListConcatenateFrontResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListConcatenateFrontResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 list_length = 1;
 * @return {number}
 */
proto._ListConcatenateFrontResponse.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListConcatenateFrontResponse} returns this
 */
proto._ListConcatenateFrontResponse.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._ListConcatenateBackRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListConcatenateBackRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListConcatenateBackRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListConcatenateBackRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListConcatenateBackRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64(),
    valuesList: msg.getValuesList_asB64(),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    truncateFrontToSize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListConcatenateBackRequest}
 */
proto._ListConcatenateBackRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListConcatenateBackRequest;
  return proto._ListConcatenateBackRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListConcatenateBackRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListConcatenateBackRequest}
 */
proto._ListConcatenateBackRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addValues(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTruncateFrontToSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListConcatenateBackRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListConcatenateBackRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListConcatenateBackRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListConcatenateBackRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getValuesList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      2,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTruncateFrontToSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListConcatenateBackRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListConcatenateBackRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListConcatenateBackRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListConcatenateBackRequest} returns this
 */
proto._ListConcatenateBackRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * repeated bytes values = 2;
 * @return {!Array<string>}
 */
proto._ListConcatenateBackRequest.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * repeated bytes values = 2;
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<string>}
 */
proto._ListConcatenateBackRequest.prototype.getValuesList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getValuesList()));
};


/**
 * repeated bytes values = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<!Uint8Array>}
 */
proto._ListConcatenateBackRequest.prototype.getValuesList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getValuesList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._ListConcatenateBackRequest} returns this
 */
proto._ListConcatenateBackRequest.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._ListConcatenateBackRequest} returns this
 */
proto._ListConcatenateBackRequest.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._ListConcatenateBackRequest} returns this
 */
proto._ListConcatenateBackRequest.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._ListConcatenateBackRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListConcatenateBackRequest} returns this
 */
proto._ListConcatenateBackRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool refresh_ttl = 4;
 * @return {boolean}
 */
proto._ListConcatenateBackRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto._ListConcatenateBackRequest} returns this
 */
proto._ListConcatenateBackRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint32 truncate_front_to_size = 5;
 * @return {number}
 */
proto._ListConcatenateBackRequest.prototype.getTruncateFrontToSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListConcatenateBackRequest} returns this
 */
proto._ListConcatenateBackRequest.prototype.setTruncateFrontToSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListConcatenateBackResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListConcatenateBackResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListConcatenateBackResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListConcatenateBackResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    listLength: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListConcatenateBackResponse}
 */
proto._ListConcatenateBackResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListConcatenateBackResponse;
  return proto._ListConcatenateBackResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListConcatenateBackResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListConcatenateBackResponse}
 */
proto._ListConcatenateBackResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListConcatenateBackResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListConcatenateBackResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListConcatenateBackResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListConcatenateBackResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 list_length = 1;
 * @return {number}
 */
proto._ListConcatenateBackResponse.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListConcatenateBackResponse} returns this
 */
proto._ListConcatenateBackResponse.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPushFrontRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPushFrontRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPushFrontRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPushFrontRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64(),
    value: msg.getValue_asB64(),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    truncateBackToSize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPushFrontRequest}
 */
proto._ListPushFrontRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPushFrontRequest;
  return proto._ListPushFrontRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPushFrontRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPushFrontRequest}
 */
proto._ListPushFrontRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTruncateBackToSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPushFrontRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPushFrontRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPushFrontRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPushFrontRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getValue_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTruncateBackToSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListPushFrontRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListPushFrontRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListPushFrontRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListPushFrontRequest} returns this
 */
proto._ListPushFrontRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes value = 2;
 * @return {string}
 */
proto._ListPushFrontRequest.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes value = 2;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */
proto._ListPushFrontRequest.prototype.getValue_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getValue()));
};


/**
 * optional bytes value = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */
proto._ListPushFrontRequest.prototype.getValue_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getValue()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListPushFrontRequest} returns this
 */
proto._ListPushFrontRequest.prototype.setValue = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._ListPushFrontRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListPushFrontRequest} returns this
 */
proto._ListPushFrontRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool refresh_ttl = 4;
 * @return {boolean}
 */
proto._ListPushFrontRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto._ListPushFrontRequest} returns this
 */
proto._ListPushFrontRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint32 truncate_back_to_size = 5;
 * @return {number}
 */
proto._ListPushFrontRequest.prototype.getTruncateBackToSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListPushFrontRequest} returns this
 */
proto._ListPushFrontRequest.prototype.setTruncateBackToSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPushFrontResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPushFrontResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPushFrontResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPushFrontResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    listLength: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPushFrontResponse}
 */
proto._ListPushFrontResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPushFrontResponse;
  return proto._ListPushFrontResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPushFrontResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPushFrontResponse}
 */
proto._ListPushFrontResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPushFrontResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPushFrontResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPushFrontResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPushFrontResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 list_length = 1;
 * @return {number}
 */
proto._ListPushFrontResponse.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListPushFrontResponse} returns this
 */
proto._ListPushFrontResponse.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPushBackRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPushBackRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPushBackRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPushBackRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64(),
    value: msg.getValue_asB64(),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    truncateFrontToSize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPushBackRequest}
 */
proto._ListPushBackRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPushBackRequest;
  return proto._ListPushBackRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPushBackRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPushBackRequest}
 */
proto._ListPushBackRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTruncateFrontToSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPushBackRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPushBackRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPushBackRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPushBackRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getValue_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTruncateFrontToSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListPushBackRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListPushBackRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListPushBackRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListPushBackRequest} returns this
 */
proto._ListPushBackRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes value = 2;
 * @return {string}
 */
proto._ListPushBackRequest.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes value = 2;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */
proto._ListPushBackRequest.prototype.getValue_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getValue()));
};


/**
 * optional bytes value = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */
proto._ListPushBackRequest.prototype.getValue_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getValue()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListPushBackRequest} returns this
 */
proto._ListPushBackRequest.prototype.setValue = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._ListPushBackRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListPushBackRequest} returns this
 */
proto._ListPushBackRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool refresh_ttl = 4;
 * @return {boolean}
 */
proto._ListPushBackRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto._ListPushBackRequest} returns this
 */
proto._ListPushBackRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint32 truncate_front_to_size = 5;
 * @return {number}
 */
proto._ListPushBackRequest.prototype.getTruncateFrontToSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListPushBackRequest} returns this
 */
proto._ListPushBackRequest.prototype.setTruncateFrontToSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPushBackResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPushBackResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPushBackResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPushBackResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    listLength: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPushBackResponse}
 */
proto._ListPushBackResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPushBackResponse;
  return proto._ListPushBackResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPushBackResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPushBackResponse}
 */
proto._ListPushBackResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPushBackResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPushBackResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPushBackResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPushBackResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 list_length = 1;
 * @return {number}
 */
proto._ListPushBackResponse.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListPushBackResponse} returns this
 */
proto._ListPushBackResponse.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPopFrontRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPopFrontRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPopFrontRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopFrontRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPopFrontRequest}
 */
proto._ListPopFrontRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPopFrontRequest;
  return proto._ListPopFrontRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPopFrontRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPopFrontRequest}
 */
proto._ListPopFrontRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPopFrontRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPopFrontRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPopFrontRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopFrontRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListPopFrontRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListPopFrontRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListPopFrontRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListPopFrontRequest} returns this
 */
proto._ListPopFrontRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListPopFrontResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ListPopFrontResponse.ListCase = {
  LIST_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ListPopFrontResponse.ListCase}
 */
proto._ListPopFrontResponse.prototype.getListCase = function() {
  return /** @type {proto._ListPopFrontResponse.ListCase} */(jspb.Message.computeOneofCase(this, proto._ListPopFrontResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPopFrontResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPopFrontResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPopFrontResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopFrontResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ListPopFrontResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ListPopFrontResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPopFrontResponse}
 */
proto._ListPopFrontResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPopFrontResponse;
  return proto._ListPopFrontResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPopFrontResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPopFrontResponse}
 */
proto._ListPopFrontResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ListPopFrontResponse._Found;
      reader.readMessage(value,proto._ListPopFrontResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ListPopFrontResponse._Missing;
      reader.readMessage(value,proto._ListPopFrontResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPopFrontResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPopFrontResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPopFrontResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopFrontResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ListPopFrontResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ListPopFrontResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPopFrontResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPopFrontResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPopFrontResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopFrontResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    front: msg.getFront_asB64(),
    listLength: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPopFrontResponse._Found}
 */
proto._ListPopFrontResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPopFrontResponse._Found;
  return proto._ListPopFrontResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPopFrontResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPopFrontResponse._Found}
 */
proto._ListPopFrontResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFront(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPopFrontResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPopFrontResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPopFrontResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopFrontResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFront_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional bytes front = 1;
 * @return {string}
 */
proto._ListPopFrontResponse._Found.prototype.getFront = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes front = 1;
 * This is a type-conversion wrapper around `getFront()`
 * @return {string}
 */
proto._ListPopFrontResponse._Found.prototype.getFront_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFront()));
};


/**
 * optional bytes front = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFront()`
 * @return {!Uint8Array}
 */
proto._ListPopFrontResponse._Found.prototype.getFront_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFront()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListPopFrontResponse._Found} returns this
 */
proto._ListPopFrontResponse._Found.prototype.setFront = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional uint32 list_length = 2;
 * @return {number}
 */
proto._ListPopFrontResponse._Found.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListPopFrontResponse._Found} returns this
 */
proto._ListPopFrontResponse._Found.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPopFrontResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPopFrontResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPopFrontResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopFrontResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPopFrontResponse._Missing}
 */
proto._ListPopFrontResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPopFrontResponse._Missing;
  return proto._ListPopFrontResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPopFrontResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPopFrontResponse._Missing}
 */
proto._ListPopFrontResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPopFrontResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPopFrontResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPopFrontResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopFrontResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ListPopFrontResponse._Found}
 */
proto._ListPopFrontResponse.prototype.getFound = function() {
  return /** @type{?proto._ListPopFrontResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ListPopFrontResponse._Found, 1));
};


/**
 * @param {?proto._ListPopFrontResponse._Found|undefined} value
 * @return {!proto._ListPopFrontResponse} returns this
*/
proto._ListPopFrontResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ListPopFrontResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListPopFrontResponse} returns this
 */
proto._ListPopFrontResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListPopFrontResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ListPopFrontResponse._Missing}
 */
proto._ListPopFrontResponse.prototype.getMissing = function() {
  return /** @type{?proto._ListPopFrontResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ListPopFrontResponse._Missing, 2));
};


/**
 * @param {?proto._ListPopFrontResponse._Missing|undefined} value
 * @return {!proto._ListPopFrontResponse} returns this
*/
proto._ListPopFrontResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListPopFrontResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListPopFrontResponse} returns this
 */
proto._ListPopFrontResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListPopFrontResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPopBackRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPopBackRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPopBackRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopBackRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPopBackRequest}
 */
proto._ListPopBackRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPopBackRequest;
  return proto._ListPopBackRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPopBackRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPopBackRequest}
 */
proto._ListPopBackRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPopBackRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPopBackRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPopBackRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopBackRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListPopBackRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListPopBackRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListPopBackRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListPopBackRequest} returns this
 */
proto._ListPopBackRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListPopBackResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ListPopBackResponse.ListCase = {
  LIST_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ListPopBackResponse.ListCase}
 */
proto._ListPopBackResponse.prototype.getListCase = function() {
  return /** @type {proto._ListPopBackResponse.ListCase} */(jspb.Message.computeOneofCase(this, proto._ListPopBackResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPopBackResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPopBackResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPopBackResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopBackResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ListPopBackResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ListPopBackResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPopBackResponse}
 */
proto._ListPopBackResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPopBackResponse;
  return proto._ListPopBackResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPopBackResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPopBackResponse}
 */
proto._ListPopBackResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ListPopBackResponse._Found;
      reader.readMessage(value,proto._ListPopBackResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ListPopBackResponse._Missing;
      reader.readMessage(value,proto._ListPopBackResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPopBackResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPopBackResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPopBackResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopBackResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ListPopBackResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ListPopBackResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPopBackResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPopBackResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPopBackResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopBackResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    back: msg.getBack_asB64(),
    listLength: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPopBackResponse._Found}
 */
proto._ListPopBackResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPopBackResponse._Found;
  return proto._ListPopBackResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPopBackResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPopBackResponse._Found}
 */
proto._ListPopBackResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBack(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPopBackResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPopBackResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPopBackResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopBackResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBack_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional bytes back = 1;
 * @return {string}
 */
proto._ListPopBackResponse._Found.prototype.getBack = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes back = 1;
 * This is a type-conversion wrapper around `getBack()`
 * @return {string}
 */
proto._ListPopBackResponse._Found.prototype.getBack_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBack()));
};


/**
 * optional bytes back = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBack()`
 * @return {!Uint8Array}
 */
proto._ListPopBackResponse._Found.prototype.getBack_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBack()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListPopBackResponse._Found} returns this
 */
proto._ListPopBackResponse._Found.prototype.setBack = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional uint32 list_length = 2;
 * @return {number}
 */
proto._ListPopBackResponse._Found.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListPopBackResponse._Found} returns this
 */
proto._ListPopBackResponse._Found.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListPopBackResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ListPopBackResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListPopBackResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopBackResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListPopBackResponse._Missing}
 */
proto._ListPopBackResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListPopBackResponse._Missing;
  return proto._ListPopBackResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListPopBackResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListPopBackResponse._Missing}
 */
proto._ListPopBackResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListPopBackResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListPopBackResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListPopBackResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListPopBackResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ListPopBackResponse._Found}
 */
proto._ListPopBackResponse.prototype.getFound = function() {
  return /** @type{?proto._ListPopBackResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ListPopBackResponse._Found, 1));
};


/**
 * @param {?proto._ListPopBackResponse._Found|undefined} value
 * @return {!proto._ListPopBackResponse} returns this
*/
proto._ListPopBackResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ListPopBackResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListPopBackResponse} returns this
 */
proto._ListPopBackResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListPopBackResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ListPopBackResponse._Missing}
 */
proto._ListPopBackResponse.prototype.getMissing = function() {
  return /** @type{?proto._ListPopBackResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ListPopBackResponse._Missing, 2));
};


/**
 * @param {?proto._ListPopBackResponse._Missing|undefined} value
 * @return {!proto._ListPopBackResponse} returns this
*/
proto._ListPopBackResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListPopBackResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListPopBackResponse} returns this
 */
proto._ListPopBackResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListPopBackResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRange.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRange.toObject = function(includeInstance, msg) {
  var f, obj = {
    beginIndex: jspb.Message.getFieldWithDefault(msg, 1, 0),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRange}
 */
proto._ListRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRange;
  return proto._ListRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRange}
 */
proto._ListRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBeginIndex(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeginIndex();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional uint32 begin_index = 1;
 * @return {number}
 */
proto._ListRange.prototype.getBeginIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListRange} returns this
 */
proto._ListRange.prototype.setBeginIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 count = 2;
 * @return {number}
 */
proto._ListRange.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListRange} returns this
 */
proto._ListRange.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListEraseRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto._ListEraseRequest.EraseCase = {
  ERASE_NOT_SET: 0,
  SOME: 2,
  ALL: 3
};

/**
 * @return {proto._ListEraseRequest.EraseCase}
 */
proto._ListEraseRequest.prototype.getEraseCase = function() {
  return /** @type {proto._ListEraseRequest.EraseCase} */(jspb.Message.computeOneofCase(this, proto._ListEraseRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListEraseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListEraseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListEraseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64(),
    some: (f = msg.getSome()) && proto._ListEraseRequest._ListRanges.toObject(includeInstance, f),
    all: (f = msg.getAll()) && proto._ListEraseRequest._All.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListEraseRequest}
 */
proto._ListEraseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListEraseRequest;
  return proto._ListEraseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListEraseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListEraseRequest}
 */
proto._ListEraseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    case 2:
      var value = new proto._ListEraseRequest._ListRanges;
      reader.readMessage(value,proto._ListEraseRequest._ListRanges.deserializeBinaryFromReader);
      msg.setSome(value);
      break;
    case 3:
      var value = new proto._ListEraseRequest._All;
      reader.readMessage(value,proto._ListEraseRequest._All.deserializeBinaryFromReader);
      msg.setAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListEraseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListEraseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListEraseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getSome();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ListEraseRequest._ListRanges.serializeBinaryToWriter
    );
  }
  f = message.getAll();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto._ListEraseRequest._All.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListEraseRequest._All.prototype.toObject = function(opt_includeInstance) {
  return proto._ListEraseRequest._All.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListEraseRequest._All} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseRequest._All.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListEraseRequest._All}
 */
proto._ListEraseRequest._All.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListEraseRequest._All;
  return proto._ListEraseRequest._All.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListEraseRequest._All} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListEraseRequest._All}
 */
proto._ListEraseRequest._All.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListEraseRequest._All.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListEraseRequest._All.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListEraseRequest._All} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseRequest._All.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._ListEraseRequest._ListRanges.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListEraseRequest._ListRanges.prototype.toObject = function(opt_includeInstance) {
  return proto._ListEraseRequest._ListRanges.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListEraseRequest._ListRanges} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseRequest._ListRanges.toObject = function(includeInstance, msg) {
  var f, obj = {
    rangesList: jspb.Message.toObjectList(msg.getRangesList(),
    proto._ListRange.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListEraseRequest._ListRanges}
 */
proto._ListEraseRequest._ListRanges.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListEraseRequest._ListRanges;
  return proto._ListEraseRequest._ListRanges.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListEraseRequest._ListRanges} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListEraseRequest._ListRanges}
 */
proto._ListEraseRequest._ListRanges.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ListRange;
      reader.readMessage(value,proto._ListRange.deserializeBinaryFromReader);
      msg.addRanges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListEraseRequest._ListRanges.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListEraseRequest._ListRanges.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListEraseRequest._ListRanges} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseRequest._ListRanges.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRangesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto._ListRange.serializeBinaryToWriter
    );
  }
};


/**
 * repeated _ListRange ranges = 1;
 * @return {!Array<!proto._ListRange>}
 */
proto._ListEraseRequest._ListRanges.prototype.getRangesList = function() {
  return /** @type{!Array<!proto._ListRange>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto._ListRange, 1));
};


/**
 * @param {!Array<!proto._ListRange>} value
 * @return {!proto._ListEraseRequest._ListRanges} returns this
*/
proto._ListEraseRequest._ListRanges.prototype.setRangesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto._ListRange=} opt_value
 * @param {number=} opt_index
 * @return {!proto._ListRange}
 */
proto._ListEraseRequest._ListRanges.prototype.addRanges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto._ListRange, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._ListEraseRequest._ListRanges} returns this
 */
proto._ListEraseRequest._ListRanges.prototype.clearRangesList = function() {
  return this.setRangesList([]);
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListEraseRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListEraseRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListEraseRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListEraseRequest} returns this
 */
proto._ListEraseRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional _ListRanges some = 2;
 * @return {?proto._ListEraseRequest._ListRanges}
 */
proto._ListEraseRequest.prototype.getSome = function() {
  return /** @type{?proto._ListEraseRequest._ListRanges} */ (
    jspb.Message.getWrapperField(this, proto._ListEraseRequest._ListRanges, 2));
};


/**
 * @param {?proto._ListEraseRequest._ListRanges|undefined} value
 * @return {!proto._ListEraseRequest} returns this
*/
proto._ListEraseRequest.prototype.setSome = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListEraseRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListEraseRequest} returns this
 */
proto._ListEraseRequest.prototype.clearSome = function() {
  return this.setSome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListEraseRequest.prototype.hasSome = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional _All all = 3;
 * @return {?proto._ListEraseRequest._All}
 */
proto._ListEraseRequest.prototype.getAll = function() {
  return /** @type{?proto._ListEraseRequest._All} */ (
    jspb.Message.getWrapperField(this, proto._ListEraseRequest._All, 3));
};


/**
 * @param {?proto._ListEraseRequest._All|undefined} value
 * @return {!proto._ListEraseRequest} returns this
*/
proto._ListEraseRequest.prototype.setAll = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto._ListEraseRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListEraseRequest} returns this
 */
proto._ListEraseRequest.prototype.clearAll = function() {
  return this.setAll(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListEraseRequest.prototype.hasAll = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListEraseResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ListEraseResponse.ListCase = {
  LIST_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ListEraseResponse.ListCase}
 */
proto._ListEraseResponse.prototype.getListCase = function() {
  return /** @type {proto._ListEraseResponse.ListCase} */(jspb.Message.computeOneofCase(this, proto._ListEraseResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListEraseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListEraseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListEraseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ListEraseResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ListEraseResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListEraseResponse}
 */
proto._ListEraseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListEraseResponse;
  return proto._ListEraseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListEraseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListEraseResponse}
 */
proto._ListEraseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ListEraseResponse._Found;
      reader.readMessage(value,proto._ListEraseResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ListEraseResponse._Missing;
      reader.readMessage(value,proto._ListEraseResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListEraseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListEraseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListEraseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ListEraseResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ListEraseResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListEraseResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ListEraseResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListEraseResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    listLength: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListEraseResponse._Found}
 */
proto._ListEraseResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListEraseResponse._Found;
  return proto._ListEraseResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListEraseResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListEraseResponse._Found}
 */
proto._ListEraseResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListEraseResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListEraseResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListEraseResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 list_length = 1;
 * @return {number}
 */
proto._ListEraseResponse._Found.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListEraseResponse._Found} returns this
 */
proto._ListEraseResponse._Found.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListEraseResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ListEraseResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListEraseResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListEraseResponse._Missing}
 */
proto._ListEraseResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListEraseResponse._Missing;
  return proto._ListEraseResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListEraseResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListEraseResponse._Missing}
 */
proto._ListEraseResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListEraseResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListEraseResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListEraseResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListEraseResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ListEraseResponse._Found}
 */
proto._ListEraseResponse.prototype.getFound = function() {
  return /** @type{?proto._ListEraseResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ListEraseResponse._Found, 1));
};


/**
 * @param {?proto._ListEraseResponse._Found|undefined} value
 * @return {!proto._ListEraseResponse} returns this
*/
proto._ListEraseResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ListEraseResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListEraseResponse} returns this
 */
proto._ListEraseResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListEraseResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ListEraseResponse._Missing}
 */
proto._ListEraseResponse.prototype.getMissing = function() {
  return /** @type{?proto._ListEraseResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ListEraseResponse._Missing, 2));
};


/**
 * @param {?proto._ListEraseResponse._Missing|undefined} value
 * @return {!proto._ListEraseResponse} returns this
*/
proto._ListEraseResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListEraseResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListEraseResponse} returns this
 */
proto._ListEraseResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListEraseResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListRemoveRequest.oneofGroups_ = [[2]];

/**
 * @enum {number}
 */
proto._ListRemoveRequest.RemoveCase = {
  REMOVE_NOT_SET: 0,
  ALL_ELEMENTS_WITH_VALUE: 2
};

/**
 * @return {proto._ListRemoveRequest.RemoveCase}
 */
proto._ListRemoveRequest.prototype.getRemoveCase = function() {
  return /** @type {proto._ListRemoveRequest.RemoveCase} */(jspb.Message.computeOneofCase(this, proto._ListRemoveRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRemoveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRemoveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRemoveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRemoveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64(),
    allElementsWithValue: msg.getAllElementsWithValue_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRemoveRequest}
 */
proto._ListRemoveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRemoveRequest;
  return proto._ListRemoveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRemoveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRemoveRequest}
 */
proto._ListRemoveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setAllElementsWithValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRemoveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRemoveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRemoveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRemoveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListRemoveRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListRemoveRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListRemoveRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListRemoveRequest} returns this
 */
proto._ListRemoveRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes all_elements_with_value = 2;
 * @return {string}
 */
proto._ListRemoveRequest.prototype.getAllElementsWithValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes all_elements_with_value = 2;
 * This is a type-conversion wrapper around `getAllElementsWithValue()`
 * @return {string}
 */
proto._ListRemoveRequest.prototype.getAllElementsWithValue_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getAllElementsWithValue()));
};


/**
 * optional bytes all_elements_with_value = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAllElementsWithValue()`
 * @return {!Uint8Array}
 */
proto._ListRemoveRequest.prototype.getAllElementsWithValue_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getAllElementsWithValue()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListRemoveRequest} returns this
 */
proto._ListRemoveRequest.prototype.setAllElementsWithValue = function(value) {
  return jspb.Message.setOneofField(this, 2, proto._ListRemoveRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._ListRemoveRequest} returns this
 */
proto._ListRemoveRequest.prototype.clearAllElementsWithValue = function() {
  return jspb.Message.setOneofField(this, 2, proto._ListRemoveRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRemoveRequest.prototype.hasAllElementsWithValue = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListRemoveResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ListRemoveResponse.ListCase = {
  LIST_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ListRemoveResponse.ListCase}
 */
proto._ListRemoveResponse.prototype.getListCase = function() {
  return /** @type {proto._ListRemoveResponse.ListCase} */(jspb.Message.computeOneofCase(this, proto._ListRemoveResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRemoveResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRemoveResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRemoveResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRemoveResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ListRemoveResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ListRemoveResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRemoveResponse}
 */
proto._ListRemoveResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRemoveResponse;
  return proto._ListRemoveResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRemoveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRemoveResponse}
 */
proto._ListRemoveResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ListRemoveResponse._Found;
      reader.readMessage(value,proto._ListRemoveResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ListRemoveResponse._Missing;
      reader.readMessage(value,proto._ListRemoveResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRemoveResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRemoveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRemoveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRemoveResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ListRemoveResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ListRemoveResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRemoveResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRemoveResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRemoveResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRemoveResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    listLength: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRemoveResponse._Found}
 */
proto._ListRemoveResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRemoveResponse._Found;
  return proto._ListRemoveResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRemoveResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRemoveResponse._Found}
 */
proto._ListRemoveResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRemoveResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRemoveResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRemoveResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRemoveResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 list_length = 1;
 * @return {number}
 */
proto._ListRemoveResponse._Found.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListRemoveResponse._Found} returns this
 */
proto._ListRemoveResponse._Found.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRemoveResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRemoveResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRemoveResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRemoveResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRemoveResponse._Missing}
 */
proto._ListRemoveResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRemoveResponse._Missing;
  return proto._ListRemoveResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRemoveResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRemoveResponse._Missing}
 */
proto._ListRemoveResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRemoveResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRemoveResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRemoveResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRemoveResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ListRemoveResponse._Found}
 */
proto._ListRemoveResponse.prototype.getFound = function() {
  return /** @type{?proto._ListRemoveResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ListRemoveResponse._Found, 1));
};


/**
 * @param {?proto._ListRemoveResponse._Found|undefined} value
 * @return {!proto._ListRemoveResponse} returns this
*/
proto._ListRemoveResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ListRemoveResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListRemoveResponse} returns this
 */
proto._ListRemoveResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRemoveResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ListRemoveResponse._Missing}
 */
proto._ListRemoveResponse.prototype.getMissing = function() {
  return /** @type{?proto._ListRemoveResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ListRemoveResponse._Missing, 2));
};


/**
 * @param {?proto._ListRemoveResponse._Missing|undefined} value
 * @return {!proto._ListRemoveResponse} returns this
*/
proto._ListRemoveResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListRemoveResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListRemoveResponse} returns this
 */
proto._ListRemoveResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRemoveResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._Unbounded.prototype.toObject = function(opt_includeInstance) {
  return proto._Unbounded.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._Unbounded} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._Unbounded.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._Unbounded}
 */
proto._Unbounded.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._Unbounded;
  return proto._Unbounded.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._Unbounded} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._Unbounded}
 */
proto._Unbounded.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._Unbounded.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._Unbounded.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._Unbounded} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._Unbounded.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListFetchRequest.oneofGroups_ = [[2,3],[4,5]];

/**
 * @enum {number}
 */
proto._ListFetchRequest.StartIndexCase = {
  START_INDEX_NOT_SET: 0,
  UNBOUNDED_START: 2,
  INCLUSIVE_START: 3
};

/**
 * @return {proto._ListFetchRequest.StartIndexCase}
 */
proto._ListFetchRequest.prototype.getStartIndexCase = function() {
  return /** @type {proto._ListFetchRequest.StartIndexCase} */(jspb.Message.computeOneofCase(this, proto._ListFetchRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto._ListFetchRequest.EndIndexCase = {
  END_INDEX_NOT_SET: 0,
  UNBOUNDED_END: 4,
  EXCLUSIVE_END: 5
};

/**
 * @return {proto._ListFetchRequest.EndIndexCase}
 */
proto._ListFetchRequest.prototype.getEndIndexCase = function() {
  return /** @type {proto._ListFetchRequest.EndIndexCase} */(jspb.Message.computeOneofCase(this, proto._ListFetchRequest.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListFetchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListFetchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListFetchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListFetchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64(),
    unboundedStart: (f = msg.getUnboundedStart()) && proto._Unbounded.toObject(includeInstance, f),
    inclusiveStart: jspb.Message.getFieldWithDefault(msg, 3, 0),
    unboundedEnd: (f = msg.getUnboundedEnd()) && proto._Unbounded.toObject(includeInstance, f),
    exclusiveEnd: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListFetchRequest}
 */
proto._ListFetchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListFetchRequest;
  return proto._ListFetchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListFetchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListFetchRequest}
 */
proto._ListFetchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    case 2:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedStart(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setInclusiveStart(value);
      break;
    case 4:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedEnd(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setExclusiveEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListFetchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListFetchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListFetchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListFetchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getUnboundedStart();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeSint32(
      3,
      f
    );
  }
  f = message.getUnboundedEnd();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeSint32(
      5,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListFetchRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListFetchRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListFetchRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListFetchRequest} returns this
 */
proto._ListFetchRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional _Unbounded unbounded_start = 2;
 * @return {?proto._Unbounded}
 */
proto._ListFetchRequest.prototype.getUnboundedStart = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 2));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._ListFetchRequest} returns this
*/
proto._ListFetchRequest.prototype.setUnboundedStart = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListFetchRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListFetchRequest} returns this
 */
proto._ListFetchRequest.prototype.clearUnboundedStart = function() {
  return this.setUnboundedStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListFetchRequest.prototype.hasUnboundedStart = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional sint32 inclusive_start = 3;
 * @return {number}
 */
proto._ListFetchRequest.prototype.getInclusiveStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListFetchRequest} returns this
 */
proto._ListFetchRequest.prototype.setInclusiveStart = function(value) {
  return jspb.Message.setOneofField(this, 3, proto._ListFetchRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._ListFetchRequest} returns this
 */
proto._ListFetchRequest.prototype.clearInclusiveStart = function() {
  return jspb.Message.setOneofField(this, 3, proto._ListFetchRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListFetchRequest.prototype.hasInclusiveStart = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional _Unbounded unbounded_end = 4;
 * @return {?proto._Unbounded}
 */
proto._ListFetchRequest.prototype.getUnboundedEnd = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 4));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._ListFetchRequest} returns this
*/
proto._ListFetchRequest.prototype.setUnboundedEnd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto._ListFetchRequest.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListFetchRequest} returns this
 */
proto._ListFetchRequest.prototype.clearUnboundedEnd = function() {
  return this.setUnboundedEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListFetchRequest.prototype.hasUnboundedEnd = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional sint32 exclusive_end = 5;
 * @return {number}
 */
proto._ListFetchRequest.prototype.getExclusiveEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListFetchRequest} returns this
 */
proto._ListFetchRequest.prototype.setExclusiveEnd = function(value) {
  return jspb.Message.setOneofField(this, 5, proto._ListFetchRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._ListFetchRequest} returns this
 */
proto._ListFetchRequest.prototype.clearExclusiveEnd = function() {
  return jspb.Message.setOneofField(this, 5, proto._ListFetchRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListFetchRequest.prototype.hasExclusiveEnd = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListRetainRequest.oneofGroups_ = [[2,3],[4,5]];

/**
 * @enum {number}
 */
proto._ListRetainRequest.StartIndexCase = {
  START_INDEX_NOT_SET: 0,
  UNBOUNDED_START: 2,
  INCLUSIVE_START: 3
};

/**
 * @return {proto._ListRetainRequest.StartIndexCase}
 */
proto._ListRetainRequest.prototype.getStartIndexCase = function() {
  return /** @type {proto._ListRetainRequest.StartIndexCase} */(jspb.Message.computeOneofCase(this, proto._ListRetainRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto._ListRetainRequest.EndIndexCase = {
  END_INDEX_NOT_SET: 0,
  UNBOUNDED_END: 4,
  EXCLUSIVE_END: 5
};

/**
 * @return {proto._ListRetainRequest.EndIndexCase}
 */
proto._ListRetainRequest.prototype.getEndIndexCase = function() {
  return /** @type {proto._ListRetainRequest.EndIndexCase} */(jspb.Message.computeOneofCase(this, proto._ListRetainRequest.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRetainRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRetainRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRetainRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRetainRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64(),
    unboundedStart: (f = msg.getUnboundedStart()) && proto._Unbounded.toObject(includeInstance, f),
    inclusiveStart: jspb.Message.getFieldWithDefault(msg, 3, 0),
    unboundedEnd: (f = msg.getUnboundedEnd()) && proto._Unbounded.toObject(includeInstance, f),
    exclusiveEnd: jspb.Message.getFieldWithDefault(msg, 5, 0),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 6, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRetainRequest}
 */
proto._ListRetainRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRetainRequest;
  return proto._ListRetainRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRetainRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRetainRequest}
 */
proto._ListRetainRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    case 2:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedStart(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setInclusiveStart(value);
      break;
    case 4:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedEnd(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setExclusiveEnd(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRetainRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRetainRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRetainRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRetainRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getUnboundedStart();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeSint32(
      3,
      f
    );
  }
  f = message.getUnboundedEnd();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeSint32(
      5,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListRetainRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListRetainRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListRetainRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional _Unbounded unbounded_start = 2;
 * @return {?proto._Unbounded}
 */
proto._ListRetainRequest.prototype.getUnboundedStart = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 2));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._ListRetainRequest} returns this
*/
proto._ListRetainRequest.prototype.setUnboundedStart = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListRetainRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.clearUnboundedStart = function() {
  return this.setUnboundedStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRetainRequest.prototype.hasUnboundedStart = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional sint32 inclusive_start = 3;
 * @return {number}
 */
proto._ListRetainRequest.prototype.getInclusiveStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.setInclusiveStart = function(value) {
  return jspb.Message.setOneofField(this, 3, proto._ListRetainRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.clearInclusiveStart = function() {
  return jspb.Message.setOneofField(this, 3, proto._ListRetainRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRetainRequest.prototype.hasInclusiveStart = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional _Unbounded unbounded_end = 4;
 * @return {?proto._Unbounded}
 */
proto._ListRetainRequest.prototype.getUnboundedEnd = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 4));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._ListRetainRequest} returns this
*/
proto._ListRetainRequest.prototype.setUnboundedEnd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto._ListRetainRequest.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.clearUnboundedEnd = function() {
  return this.setUnboundedEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRetainRequest.prototype.hasUnboundedEnd = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional sint32 exclusive_end = 5;
 * @return {number}
 */
proto._ListRetainRequest.prototype.getExclusiveEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.setExclusiveEnd = function(value) {
  return jspb.Message.setOneofField(this, 5, proto._ListRetainRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.clearExclusiveEnd = function() {
  return jspb.Message.setOneofField(this, 5, proto._ListRetainRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRetainRequest.prototype.hasExclusiveEnd = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint64 ttl_milliseconds = 6;
 * @return {number}
 */
proto._ListRetainRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool refresh_ttl = 7;
 * @return {boolean}
 */
proto._ListRetainRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto._ListRetainRequest} returns this
 */
proto._ListRetainRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListRetainResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ListRetainResponse.ListCase = {
  LIST_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ListRetainResponse.ListCase}
 */
proto._ListRetainResponse.prototype.getListCase = function() {
  return /** @type {proto._ListRetainResponse.ListCase} */(jspb.Message.computeOneofCase(this, proto._ListRetainResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRetainResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRetainResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRetainResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRetainResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ListRetainResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ListRetainResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRetainResponse}
 */
proto._ListRetainResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRetainResponse;
  return proto._ListRetainResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRetainResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRetainResponse}
 */
proto._ListRetainResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ListRetainResponse._Found;
      reader.readMessage(value,proto._ListRetainResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ListRetainResponse._Missing;
      reader.readMessage(value,proto._ListRetainResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRetainResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRetainResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRetainResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRetainResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ListRetainResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ListRetainResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRetainResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRetainResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRetainResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRetainResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    listLength: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRetainResponse._Found}
 */
proto._ListRetainResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRetainResponse._Found;
  return proto._ListRetainResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRetainResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRetainResponse._Found}
 */
proto._ListRetainResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setListLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRetainResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRetainResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRetainResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRetainResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 list_length = 1;
 * @return {number}
 */
proto._ListRetainResponse._Found.prototype.getListLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListRetainResponse._Found} returns this
 */
proto._ListRetainResponse._Found.prototype.setListLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListRetainResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ListRetainResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListRetainResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRetainResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListRetainResponse._Missing}
 */
proto._ListRetainResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListRetainResponse._Missing;
  return proto._ListRetainResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListRetainResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListRetainResponse._Missing}
 */
proto._ListRetainResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListRetainResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListRetainResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListRetainResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListRetainResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ListRetainResponse._Found}
 */
proto._ListRetainResponse.prototype.getFound = function() {
  return /** @type{?proto._ListRetainResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ListRetainResponse._Found, 1));
};


/**
 * @param {?proto._ListRetainResponse._Found|undefined} value
 * @return {!proto._ListRetainResponse} returns this
*/
proto._ListRetainResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ListRetainResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListRetainResponse} returns this
 */
proto._ListRetainResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRetainResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ListRetainResponse._Missing}
 */
proto._ListRetainResponse.prototype.getMissing = function() {
  return /** @type{?proto._ListRetainResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ListRetainResponse._Missing, 2));
};


/**
 * @param {?proto._ListRetainResponse._Missing|undefined} value
 * @return {!proto._ListRetainResponse} returns this
*/
proto._ListRetainResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListRetainResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListRetainResponse} returns this
 */
proto._ListRetainResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListRetainResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListFetchResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ListFetchResponse.ListCase = {
  LIST_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ListFetchResponse.ListCase}
 */
proto._ListFetchResponse.prototype.getListCase = function() {
  return /** @type {proto._ListFetchResponse.ListCase} */(jspb.Message.computeOneofCase(this, proto._ListFetchResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListFetchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListFetchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListFetchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListFetchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ListFetchResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ListFetchResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListFetchResponse}
 */
proto._ListFetchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListFetchResponse;
  return proto._ListFetchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListFetchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListFetchResponse}
 */
proto._ListFetchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ListFetchResponse._Found;
      reader.readMessage(value,proto._ListFetchResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ListFetchResponse._Missing;
      reader.readMessage(value,proto._ListFetchResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListFetchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListFetchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListFetchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListFetchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ListFetchResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ListFetchResponse._Missing.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._ListFetchResponse._Found.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListFetchResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ListFetchResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListFetchResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListFetchResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: msg.getValuesList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListFetchResponse._Found}
 */
proto._ListFetchResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListFetchResponse._Found;
  return proto._ListFetchResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListFetchResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListFetchResponse._Found}
 */
proto._ListFetchResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListFetchResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListFetchResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListFetchResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListFetchResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes values = 1;
 * @return {!Array<string>}
 */
proto._ListFetchResponse._Found.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes values = 1;
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<string>}
 */
proto._ListFetchResponse._Found.prototype.getValuesList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getValuesList()));
};


/**
 * repeated bytes values = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<!Uint8Array>}
 */
proto._ListFetchResponse._Found.prototype.getValuesList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getValuesList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._ListFetchResponse._Found} returns this
 */
proto._ListFetchResponse._Found.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._ListFetchResponse._Found} returns this
 */
proto._ListFetchResponse._Found.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._ListFetchResponse._Found} returns this
 */
proto._ListFetchResponse._Found.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListFetchResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ListFetchResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListFetchResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListFetchResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListFetchResponse._Missing}
 */
proto._ListFetchResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListFetchResponse._Missing;
  return proto._ListFetchResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListFetchResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListFetchResponse._Missing}
 */
proto._ListFetchResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListFetchResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListFetchResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListFetchResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListFetchResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ListFetchResponse._Found}
 */
proto._ListFetchResponse.prototype.getFound = function() {
  return /** @type{?proto._ListFetchResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ListFetchResponse._Found, 1));
};


/**
 * @param {?proto._ListFetchResponse._Found|undefined} value
 * @return {!proto._ListFetchResponse} returns this
*/
proto._ListFetchResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ListFetchResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListFetchResponse} returns this
 */
proto._ListFetchResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListFetchResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ListFetchResponse._Missing}
 */
proto._ListFetchResponse.prototype.getMissing = function() {
  return /** @type{?proto._ListFetchResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ListFetchResponse._Missing, 2));
};


/**
 * @param {?proto._ListFetchResponse._Missing|undefined} value
 * @return {!proto._ListFetchResponse} returns this
*/
proto._ListFetchResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListFetchResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListFetchResponse} returns this
 */
proto._ListFetchResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListFetchResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListLengthRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._ListLengthRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListLengthRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListLengthRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    listName: msg.getListName_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListLengthRequest}
 */
proto._ListLengthRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListLengthRequest;
  return proto._ListLengthRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListLengthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListLengthRequest}
 */
proto._ListLengthRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setListName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListLengthRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListLengthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListLengthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListLengthRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes list_name = 1;
 * @return {string}
 */
proto._ListLengthRequest.prototype.getListName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes list_name = 1;
 * This is a type-conversion wrapper around `getListName()`
 * @return {string}
 */
proto._ListLengthRequest.prototype.getListName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getListName()));
};


/**
 * optional bytes list_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getListName()`
 * @return {!Uint8Array}
 */
proto._ListLengthRequest.prototype.getListName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getListName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._ListLengthRequest} returns this
 */
proto._ListLengthRequest.prototype.setListName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._ListLengthResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._ListLengthResponse.ListCase = {
  LIST_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._ListLengthResponse.ListCase}
 */
proto._ListLengthResponse.prototype.getListCase = function() {
  return /** @type {proto._ListLengthResponse.ListCase} */(jspb.Message.computeOneofCase(this, proto._ListLengthResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListLengthResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._ListLengthResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListLengthResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListLengthResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._ListLengthResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._ListLengthResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListLengthResponse}
 */
proto._ListLengthResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListLengthResponse;
  return proto._ListLengthResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListLengthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListLengthResponse}
 */
proto._ListLengthResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._ListLengthResponse._Found;
      reader.readMessage(value,proto._ListLengthResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._ListLengthResponse._Missing;
      reader.readMessage(value,proto._ListLengthResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListLengthResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListLengthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListLengthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListLengthResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._ListLengthResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._ListLengthResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListLengthResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._ListLengthResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListLengthResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListLengthResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    length: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListLengthResponse._Found}
 */
proto._ListLengthResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListLengthResponse._Found;
  return proto._ListLengthResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListLengthResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListLengthResponse._Found}
 */
proto._ListLengthResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListLengthResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListLengthResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListLengthResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListLengthResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 length = 1;
 * @return {number}
 */
proto._ListLengthResponse._Found.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._ListLengthResponse._Found} returns this
 */
proto._ListLengthResponse._Found.prototype.setLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._ListLengthResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._ListLengthResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._ListLengthResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListLengthResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._ListLengthResponse._Missing}
 */
proto._ListLengthResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._ListLengthResponse._Missing;
  return proto._ListLengthResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._ListLengthResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._ListLengthResponse._Missing}
 */
proto._ListLengthResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._ListLengthResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._ListLengthResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._ListLengthResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._ListLengthResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._ListLengthResponse._Found}
 */
proto._ListLengthResponse.prototype.getFound = function() {
  return /** @type{?proto._ListLengthResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._ListLengthResponse._Found, 1));
};


/**
 * @param {?proto._ListLengthResponse._Found|undefined} value
 * @return {!proto._ListLengthResponse} returns this
*/
proto._ListLengthResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._ListLengthResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListLengthResponse} returns this
 */
proto._ListLengthResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListLengthResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._ListLengthResponse._Missing}
 */
proto._ListLengthResponse.prototype.getMissing = function() {
  return /** @type{?proto._ListLengthResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._ListLengthResponse._Missing, 2));
};


/**
 * @param {?proto._ListLengthResponse._Missing|undefined} value
 * @return {!proto._ListLengthResponse} returns this
*/
proto._ListLengthResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._ListLengthResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._ListLengthResponse} returns this
 */
proto._ListLengthResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._ListLengthResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetElement.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetElement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetElement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetElement.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: msg.getValue_asB64(),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetElement}
 */
proto._SortedSetElement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetElement;
  return proto._SortedSetElement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetElement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetElement}
 */
proto._SortedSetElement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetElement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetElement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetElement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetElement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional bytes value = 1;
 * @return {string}
 */
proto._SortedSetElement.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes value = 1;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */
proto._SortedSetElement.prototype.getValue_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getValue()));
};


/**
 * optional bytes value = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */
proto._SortedSetElement.prototype.getValue_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getValue()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetElement} returns this
 */
proto._SortedSetElement.prototype.setValue = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional double score = 2;
 * @return {number}
 */
proto._SortedSetElement.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetElement} returns this
 */
proto._SortedSetElement.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SortedSetPutRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetPutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetPutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetPutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetPutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    elementsList: jspb.Message.toObjectList(msg.getElementsList(),
    proto._SortedSetElement.toObject, includeInstance),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetPutRequest}
 */
proto._SortedSetPutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetPutRequest;
  return proto._SortedSetPutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetPutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetPutRequest}
 */
proto._SortedSetPutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = new proto._SortedSetElement;
      reader.readMessage(value,proto._SortedSetElement.deserializeBinaryFromReader);
      msg.addElements(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetPutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetPutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetPutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetPutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getElementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto._SortedSetElement.serializeBinaryToWriter
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SortedSetPutRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SortedSetPutRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SortedSetPutRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetPutRequest} returns this
 */
proto._SortedSetPutRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * repeated _SortedSetElement elements = 2;
 * @return {!Array<!proto._SortedSetElement>}
 */
proto._SortedSetPutRequest.prototype.getElementsList = function() {
  return /** @type{!Array<!proto._SortedSetElement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto._SortedSetElement, 2));
};


/**
 * @param {!Array<!proto._SortedSetElement>} value
 * @return {!proto._SortedSetPutRequest} returns this
*/
proto._SortedSetPutRequest.prototype.setElementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto._SortedSetElement=} opt_value
 * @param {number=} opt_index
 * @return {!proto._SortedSetElement}
 */
proto._SortedSetPutRequest.prototype.addElements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto._SortedSetElement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SortedSetPutRequest} returns this
 */
proto._SortedSetPutRequest.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};


/**
 * optional uint64 ttl_milliseconds = 3;
 * @return {number}
 */
proto._SortedSetPutRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetPutRequest} returns this
 */
proto._SortedSetPutRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool refresh_ttl = 4;
 * @return {boolean}
 */
proto._SortedSetPutRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto._SortedSetPutRequest} returns this
 */
proto._SortedSetPutRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetPutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetPutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetPutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetPutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetPutResponse}
 */
proto._SortedSetPutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetPutResponse;
  return proto._SortedSetPutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetPutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetPutResponse}
 */
proto._SortedSetPutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetPutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetPutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetPutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetPutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetFetchRequest.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto._SortedSetFetchRequest.RangeCase = {
  RANGE_NOT_SET: 0,
  BY_INDEX: 4,
  BY_SCORE: 5
};

/**
 * @return {proto._SortedSetFetchRequest.RangeCase}
 */
proto._SortedSetFetchRequest.prototype.getRangeCase = function() {
  return /** @type {proto._SortedSetFetchRequest.RangeCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetFetchRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    order: jspb.Message.getFieldWithDefault(msg, 2, 0),
    withScores: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    byIndex: (f = msg.getByIndex()) && proto._SortedSetFetchRequest._ByIndex.toObject(includeInstance, f),
    byScore: (f = msg.getByScore()) && proto._SortedSetFetchRequest._ByScore.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchRequest}
 */
proto._SortedSetFetchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchRequest;
  return proto._SortedSetFetchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchRequest}
 */
proto._SortedSetFetchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = /** @type {!proto._SortedSetFetchRequest.Order} */ (reader.readEnum());
      msg.setOrder(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithScores(value);
      break;
    case 4:
      var value = new proto._SortedSetFetchRequest._ByIndex;
      reader.readMessage(value,proto._SortedSetFetchRequest._ByIndex.deserializeBinaryFromReader);
      msg.setByIndex(value);
      break;
    case 5:
      var value = new proto._SortedSetFetchRequest._ByScore;
      reader.readMessage(value,proto._SortedSetFetchRequest._ByScore.deserializeBinaryFromReader);
      msg.setByScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getWithScores();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getByIndex();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto._SortedSetFetchRequest._ByIndex.serializeBinaryToWriter
    );
  }
  f = message.getByScore();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto._SortedSetFetchRequest._ByScore.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto._SortedSetFetchRequest.Order = {
  ASCENDING: 0,
  DESCENDING: 1
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetFetchRequest._ByIndex.oneofGroups_ = [[1,2],[3,4]];

/**
 * @enum {number}
 */
proto._SortedSetFetchRequest._ByIndex.StartCase = {
  START_NOT_SET: 0,
  UNBOUNDED_START: 1,
  INCLUSIVE_START_INDEX: 2
};

/**
 * @return {proto._SortedSetFetchRequest._ByIndex.StartCase}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.getStartCase = function() {
  return /** @type {proto._SortedSetFetchRequest._ByIndex.StartCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetFetchRequest._ByIndex.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto._SortedSetFetchRequest._ByIndex.EndCase = {
  END_NOT_SET: 0,
  UNBOUNDED_END: 3,
  EXCLUSIVE_END_INDEX: 4
};

/**
 * @return {proto._SortedSetFetchRequest._ByIndex.EndCase}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.getEndCase = function() {
  return /** @type {proto._SortedSetFetchRequest._ByIndex.EndCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetFetchRequest._ByIndex.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchRequest._ByIndex.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchRequest._ByIndex} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchRequest._ByIndex.toObject = function(includeInstance, msg) {
  var f, obj = {
    unboundedStart: (f = msg.getUnboundedStart()) && proto._Unbounded.toObject(includeInstance, f),
    inclusiveStartIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
    unboundedEnd: (f = msg.getUnboundedEnd()) && proto._Unbounded.toObject(includeInstance, f),
    exclusiveEndIndex: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchRequest._ByIndex}
 */
proto._SortedSetFetchRequest._ByIndex.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchRequest._ByIndex;
  return proto._SortedSetFetchRequest._ByIndex.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchRequest._ByIndex} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchRequest._ByIndex}
 */
proto._SortedSetFetchRequest._ByIndex.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setInclusiveStartIndex(value);
      break;
    case 3:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedEnd(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setExclusiveEndIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchRequest._ByIndex.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchRequest._ByIndex} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchRequest._ByIndex.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnboundedStart();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeSint32(
      2,
      f
    );
  }
  f = message.getUnboundedEnd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeSint32(
      4,
      f
    );
  }
};


/**
 * optional _Unbounded unbounded_start = 1;
 * @return {?proto._Unbounded}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.getUnboundedStart = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 1));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._SortedSetFetchRequest._ByIndex} returns this
*/
proto._SortedSetFetchRequest._ByIndex.prototype.setUnboundedStart = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SortedSetFetchRequest._ByIndex.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchRequest._ByIndex} returns this
 */
proto._SortedSetFetchRequest._ByIndex.prototype.clearUnboundedStart = function() {
  return this.setUnboundedStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.hasUnboundedStart = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional sint32 inclusive_start_index = 2;
 * @return {number}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.getInclusiveStartIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetFetchRequest._ByIndex} returns this
 */
proto._SortedSetFetchRequest._ByIndex.prototype.setInclusiveStartIndex = function(value) {
  return jspb.Message.setOneofField(this, 2, proto._SortedSetFetchRequest._ByIndex.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._SortedSetFetchRequest._ByIndex} returns this
 */
proto._SortedSetFetchRequest._ByIndex.prototype.clearInclusiveStartIndex = function() {
  return jspb.Message.setOneofField(this, 2, proto._SortedSetFetchRequest._ByIndex.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.hasInclusiveStartIndex = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional _Unbounded unbounded_end = 3;
 * @return {?proto._Unbounded}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.getUnboundedEnd = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 3));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._SortedSetFetchRequest._ByIndex} returns this
*/
proto._SortedSetFetchRequest._ByIndex.prototype.setUnboundedEnd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto._SortedSetFetchRequest._ByIndex.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchRequest._ByIndex} returns this
 */
proto._SortedSetFetchRequest._ByIndex.prototype.clearUnboundedEnd = function() {
  return this.setUnboundedEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.hasUnboundedEnd = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional sint32 exclusive_end_index = 4;
 * @return {number}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.getExclusiveEndIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetFetchRequest._ByIndex} returns this
 */
proto._SortedSetFetchRequest._ByIndex.prototype.setExclusiveEndIndex = function(value) {
  return jspb.Message.setOneofField(this, 4, proto._SortedSetFetchRequest._ByIndex.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._SortedSetFetchRequest._ByIndex} returns this
 */
proto._SortedSetFetchRequest._ByIndex.prototype.clearExclusiveEndIndex = function() {
  return jspb.Message.setOneofField(this, 4, proto._SortedSetFetchRequest._ByIndex.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByIndex.prototype.hasExclusiveEndIndex = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetFetchRequest._ByScore.oneofGroups_ = [[1,2],[3,4]];

/**
 * @enum {number}
 */
proto._SortedSetFetchRequest._ByScore.MinCase = {
  MIN_NOT_SET: 0,
  UNBOUNDED_MIN: 1,
  MIN_SCORE: 2
};

/**
 * @return {proto._SortedSetFetchRequest._ByScore.MinCase}
 */
proto._SortedSetFetchRequest._ByScore.prototype.getMinCase = function() {
  return /** @type {proto._SortedSetFetchRequest._ByScore.MinCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetFetchRequest._ByScore.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto._SortedSetFetchRequest._ByScore.MaxCase = {
  MAX_NOT_SET: 0,
  UNBOUNDED_MAX: 3,
  MAX_SCORE: 4
};

/**
 * @return {proto._SortedSetFetchRequest._ByScore.MaxCase}
 */
proto._SortedSetFetchRequest._ByScore.prototype.getMaxCase = function() {
  return /** @type {proto._SortedSetFetchRequest._ByScore.MaxCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetFetchRequest._ByScore.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchRequest._ByScore.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchRequest._ByScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchRequest._ByScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchRequest._ByScore.toObject = function(includeInstance, msg) {
  var f, obj = {
    unboundedMin: (f = msg.getUnboundedMin()) && proto._Unbounded.toObject(includeInstance, f),
    minScore: (f = msg.getMinScore()) && proto._SortedSetFetchRequest._ByScore._Score.toObject(includeInstance, f),
    unboundedMax: (f = msg.getUnboundedMax()) && proto._Unbounded.toObject(includeInstance, f),
    maxScore: (f = msg.getMaxScore()) && proto._SortedSetFetchRequest._ByScore._Score.toObject(includeInstance, f),
    offset: jspb.Message.getFieldWithDefault(msg, 5, 0),
    count: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchRequest._ByScore}
 */
proto._SortedSetFetchRequest._ByScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchRequest._ByScore;
  return proto._SortedSetFetchRequest._ByScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchRequest._ByScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchRequest._ByScore}
 */
proto._SortedSetFetchRequest._ByScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedMin(value);
      break;
    case 2:
      var value = new proto._SortedSetFetchRequest._ByScore._Score;
      reader.readMessage(value,proto._SortedSetFetchRequest._ByScore._Score.deserializeBinaryFromReader);
      msg.setMinScore(value);
      break;
    case 3:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedMax(value);
      break;
    case 4:
      var value = new proto._SortedSetFetchRequest._ByScore._Score;
      reader.readMessage(value,proto._SortedSetFetchRequest._ByScore._Score.deserializeBinaryFromReader);
      msg.setMaxScore(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchRequest._ByScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchRequest._ByScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchRequest._ByScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchRequest._ByScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnboundedMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = message.getMinScore();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SortedSetFetchRequest._ByScore._Score.serializeBinaryToWriter
    );
  }
  f = message.getUnboundedMax();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = message.getMaxScore();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto._SortedSetFetchRequest._ByScore._Score.serializeBinaryToWriter
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeSint32(
      6,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchRequest._ByScore._Score.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchRequest._ByScore._Score.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchRequest._ByScore._Score} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchRequest._ByScore._Score.toObject = function(includeInstance, msg) {
  var f, obj = {
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    exclusive: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchRequest._ByScore._Score}
 */
proto._SortedSetFetchRequest._ByScore._Score.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchRequest._ByScore._Score;
  return proto._SortedSetFetchRequest._ByScore._Score.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchRequest._ByScore._Score} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchRequest._ByScore._Score}
 */
proto._SortedSetFetchRequest._ByScore._Score.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExclusive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchRequest._ByScore._Score.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchRequest._ByScore._Score.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchRequest._ByScore._Score} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchRequest._ByScore._Score.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getExclusive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional double score = 1;
 * @return {number}
 */
proto._SortedSetFetchRequest._ByScore._Score.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetFetchRequest._ByScore._Score} returns this
 */
proto._SortedSetFetchRequest._ByScore._Score.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional bool exclusive = 2;
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByScore._Score.prototype.getExclusive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto._SortedSetFetchRequest._ByScore._Score} returns this
 */
proto._SortedSetFetchRequest._ByScore._Score.prototype.setExclusive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional _Unbounded unbounded_min = 1;
 * @return {?proto._Unbounded}
 */
proto._SortedSetFetchRequest._ByScore.prototype.getUnboundedMin = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 1));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
*/
proto._SortedSetFetchRequest._ByScore.prototype.setUnboundedMin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SortedSetFetchRequest._ByScore.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
 */
proto._SortedSetFetchRequest._ByScore.prototype.clearUnboundedMin = function() {
  return this.setUnboundedMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByScore.prototype.hasUnboundedMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Score min_score = 2;
 * @return {?proto._SortedSetFetchRequest._ByScore._Score}
 */
proto._SortedSetFetchRequest._ByScore.prototype.getMinScore = function() {
  return /** @type{?proto._SortedSetFetchRequest._ByScore._Score} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetFetchRequest._ByScore._Score, 2));
};


/**
 * @param {?proto._SortedSetFetchRequest._ByScore._Score|undefined} value
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
*/
proto._SortedSetFetchRequest._ByScore.prototype.setMinScore = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SortedSetFetchRequest._ByScore.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
 */
proto._SortedSetFetchRequest._ByScore.prototype.clearMinScore = function() {
  return this.setMinScore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByScore.prototype.hasMinScore = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional _Unbounded unbounded_max = 3;
 * @return {?proto._Unbounded}
 */
proto._SortedSetFetchRequest._ByScore.prototype.getUnboundedMax = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 3));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
*/
proto._SortedSetFetchRequest._ByScore.prototype.setUnboundedMax = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto._SortedSetFetchRequest._ByScore.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
 */
proto._SortedSetFetchRequest._ByScore.prototype.clearUnboundedMax = function() {
  return this.setUnboundedMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByScore.prototype.hasUnboundedMax = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional _Score max_score = 4;
 * @return {?proto._SortedSetFetchRequest._ByScore._Score}
 */
proto._SortedSetFetchRequest._ByScore.prototype.getMaxScore = function() {
  return /** @type{?proto._SortedSetFetchRequest._ByScore._Score} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetFetchRequest._ByScore._Score, 4));
};


/**
 * @param {?proto._SortedSetFetchRequest._ByScore._Score|undefined} value
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
*/
proto._SortedSetFetchRequest._ByScore.prototype.setMaxScore = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto._SortedSetFetchRequest._ByScore.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
 */
proto._SortedSetFetchRequest._ByScore.prototype.clearMaxScore = function() {
  return this.setMaxScore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest._ByScore.prototype.hasMaxScore = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint32 offset = 5;
 * @return {number}
 */
proto._SortedSetFetchRequest._ByScore.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
 */
proto._SortedSetFetchRequest._ByScore.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional sint32 count = 6;
 * @return {number}
 */
proto._SortedSetFetchRequest._ByScore.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetFetchRequest._ByScore} returns this
 */
proto._SortedSetFetchRequest._ByScore.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SortedSetFetchRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SortedSetFetchRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SortedSetFetchRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetFetchRequest} returns this
 */
proto._SortedSetFetchRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional Order order = 2;
 * @return {!proto._SortedSetFetchRequest.Order}
 */
proto._SortedSetFetchRequest.prototype.getOrder = function() {
  return /** @type {!proto._SortedSetFetchRequest.Order} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto._SortedSetFetchRequest.Order} value
 * @return {!proto._SortedSetFetchRequest} returns this
 */
proto._SortedSetFetchRequest.prototype.setOrder = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool with_scores = 3;
 * @return {boolean}
 */
proto._SortedSetFetchRequest.prototype.getWithScores = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto._SortedSetFetchRequest} returns this
 */
proto._SortedSetFetchRequest.prototype.setWithScores = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional _ByIndex by_index = 4;
 * @return {?proto._SortedSetFetchRequest._ByIndex}
 */
proto._SortedSetFetchRequest.prototype.getByIndex = function() {
  return /** @type{?proto._SortedSetFetchRequest._ByIndex} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetFetchRequest._ByIndex, 4));
};


/**
 * @param {?proto._SortedSetFetchRequest._ByIndex|undefined} value
 * @return {!proto._SortedSetFetchRequest} returns this
*/
proto._SortedSetFetchRequest.prototype.setByIndex = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto._SortedSetFetchRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchRequest} returns this
 */
proto._SortedSetFetchRequest.prototype.clearByIndex = function() {
  return this.setByIndex(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest.prototype.hasByIndex = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional _ByScore by_score = 5;
 * @return {?proto._SortedSetFetchRequest._ByScore}
 */
proto._SortedSetFetchRequest.prototype.getByScore = function() {
  return /** @type{?proto._SortedSetFetchRequest._ByScore} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetFetchRequest._ByScore, 5));
};


/**
 * @param {?proto._SortedSetFetchRequest._ByScore|undefined} value
 * @return {!proto._SortedSetFetchRequest} returns this
*/
proto._SortedSetFetchRequest.prototype.setByScore = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto._SortedSetFetchRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchRequest} returns this
 */
proto._SortedSetFetchRequest.prototype.clearByScore = function() {
  return this.setByScore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchRequest.prototype.hasByScore = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetFetchResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SortedSetFetchResponse.SortedSetCase = {
  SORTED_SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SortedSetFetchResponse.SortedSetCase}
 */
proto._SortedSetFetchResponse.prototype.getSortedSetCase = function() {
  return /** @type {proto._SortedSetFetchResponse.SortedSetCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetFetchResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SortedSetFetchResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SortedSetFetchResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchResponse}
 */
proto._SortedSetFetchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchResponse;
  return proto._SortedSetFetchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchResponse}
 */
proto._SortedSetFetchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SortedSetFetchResponse._Found;
      reader.readMessage(value,proto._SortedSetFetchResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SortedSetFetchResponse._Missing;
      reader.readMessage(value,proto._SortedSetFetchResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SortedSetFetchResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SortedSetFetchResponse._Missing.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetFetchResponse._Found.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SortedSetFetchResponse._Found.ElementsCase = {
  ELEMENTS_NOT_SET: 0,
  VALUES_WITH_SCORES: 1,
  VALUES: 2
};

/**
 * @return {proto._SortedSetFetchResponse._Found.ElementsCase}
 */
proto._SortedSetFetchResponse._Found.prototype.getElementsCase = function() {
  return /** @type {proto._SortedSetFetchResponse._Found.ElementsCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetFetchResponse._Found.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesWithScores: (f = msg.getValuesWithScores()) && proto._SortedSetFetchResponse._Found._ValuesWithScores.toObject(includeInstance, f),
    values: (f = msg.getValues()) && proto._SortedSetFetchResponse._Found._Values.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchResponse._Found}
 */
proto._SortedSetFetchResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchResponse._Found;
  return proto._SortedSetFetchResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchResponse._Found}
 */
proto._SortedSetFetchResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SortedSetFetchResponse._Found._ValuesWithScores;
      reader.readMessage(value,proto._SortedSetFetchResponse._Found._ValuesWithScores.deserializeBinaryFromReader);
      msg.setValuesWithScores(value);
      break;
    case 2:
      var value = new proto._SortedSetFetchResponse._Found._Values;
      reader.readMessage(value,proto._SortedSetFetchResponse._Found._Values.deserializeBinaryFromReader);
      msg.setValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesWithScores();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SortedSetFetchResponse._Found._ValuesWithScores.serializeBinaryToWriter
    );
  }
  f = message.getValues();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SortedSetFetchResponse._Found._Values.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchResponse._Found._ValuesWithScores.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchResponse._Found._ValuesWithScores} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementsList: jspb.Message.toObjectList(msg.getElementsList(),
    proto._SortedSetElement.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchResponse._Found._ValuesWithScores}
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchResponse._Found._ValuesWithScores;
  return proto._SortedSetFetchResponse._Found._ValuesWithScores.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchResponse._Found._ValuesWithScores} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchResponse._Found._ValuesWithScores}
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SortedSetElement;
      reader.readMessage(value,proto._SortedSetElement.deserializeBinaryFromReader);
      msg.addElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchResponse._Found._ValuesWithScores.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchResponse._Found._ValuesWithScores} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto._SortedSetElement.serializeBinaryToWriter
    );
  }
};


/**
 * repeated _SortedSetElement elements = 1;
 * @return {!Array<!proto._SortedSetElement>}
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.prototype.getElementsList = function() {
  return /** @type{!Array<!proto._SortedSetElement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto._SortedSetElement, 1));
};


/**
 * @param {!Array<!proto._SortedSetElement>} value
 * @return {!proto._SortedSetFetchResponse._Found._ValuesWithScores} returns this
*/
proto._SortedSetFetchResponse._Found._ValuesWithScores.prototype.setElementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto._SortedSetElement=} opt_value
 * @param {number=} opt_index
 * @return {!proto._SortedSetElement}
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.prototype.addElements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto._SortedSetElement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SortedSetFetchResponse._Found._ValuesWithScores} returns this
 */
proto._SortedSetFetchResponse._Found._ValuesWithScores.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SortedSetFetchResponse._Found._Values.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchResponse._Found._Values.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchResponse._Found._Values.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchResponse._Found._Values} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse._Found._Values.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: msg.getValuesList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchResponse._Found._Values}
 */
proto._SortedSetFetchResponse._Found._Values.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchResponse._Found._Values;
  return proto._SortedSetFetchResponse._Found._Values.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchResponse._Found._Values} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchResponse._Found._Values}
 */
proto._SortedSetFetchResponse._Found._Values.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchResponse._Found._Values.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchResponse._Found._Values.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchResponse._Found._Values} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse._Found._Values.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes values = 1;
 * @return {!Array<string>}
 */
proto._SortedSetFetchResponse._Found._Values.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes values = 1;
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<string>}
 */
proto._SortedSetFetchResponse._Found._Values.prototype.getValuesList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getValuesList()));
};


/**
 * repeated bytes values = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SortedSetFetchResponse._Found._Values.prototype.getValuesList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getValuesList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SortedSetFetchResponse._Found._Values} returns this
 */
proto._SortedSetFetchResponse._Found._Values.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SortedSetFetchResponse._Found._Values} returns this
 */
proto._SortedSetFetchResponse._Found._Values.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SortedSetFetchResponse._Found._Values} returns this
 */
proto._SortedSetFetchResponse._Found._Values.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional _ValuesWithScores values_with_scores = 1;
 * @return {?proto._SortedSetFetchResponse._Found._ValuesWithScores}
 */
proto._SortedSetFetchResponse._Found.prototype.getValuesWithScores = function() {
  return /** @type{?proto._SortedSetFetchResponse._Found._ValuesWithScores} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetFetchResponse._Found._ValuesWithScores, 1));
};


/**
 * @param {?proto._SortedSetFetchResponse._Found._ValuesWithScores|undefined} value
 * @return {!proto._SortedSetFetchResponse._Found} returns this
*/
proto._SortedSetFetchResponse._Found.prototype.setValuesWithScores = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SortedSetFetchResponse._Found.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchResponse._Found} returns this
 */
proto._SortedSetFetchResponse._Found.prototype.clearValuesWithScores = function() {
  return this.setValuesWithScores(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchResponse._Found.prototype.hasValuesWithScores = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Values values = 2;
 * @return {?proto._SortedSetFetchResponse._Found._Values}
 */
proto._SortedSetFetchResponse._Found.prototype.getValues = function() {
  return /** @type{?proto._SortedSetFetchResponse._Found._Values} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetFetchResponse._Found._Values, 2));
};


/**
 * @param {?proto._SortedSetFetchResponse._Found._Values|undefined} value
 * @return {!proto._SortedSetFetchResponse._Found} returns this
*/
proto._SortedSetFetchResponse._Found.prototype.setValues = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SortedSetFetchResponse._Found.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchResponse._Found} returns this
 */
proto._SortedSetFetchResponse._Found.prototype.clearValues = function() {
  return this.setValues(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchResponse._Found.prototype.hasValues = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetFetchResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetFetchResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetFetchResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetFetchResponse._Missing}
 */
proto._SortedSetFetchResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetFetchResponse._Missing;
  return proto._SortedSetFetchResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetFetchResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetFetchResponse._Missing}
 */
proto._SortedSetFetchResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetFetchResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetFetchResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetFetchResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetFetchResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._SortedSetFetchResponse._Found}
 */
proto._SortedSetFetchResponse.prototype.getFound = function() {
  return /** @type{?proto._SortedSetFetchResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetFetchResponse._Found, 1));
};


/**
 * @param {?proto._SortedSetFetchResponse._Found|undefined} value
 * @return {!proto._SortedSetFetchResponse} returns this
*/
proto._SortedSetFetchResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SortedSetFetchResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchResponse} returns this
 */
proto._SortedSetFetchResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._SortedSetFetchResponse._Missing}
 */
proto._SortedSetFetchResponse.prototype.getMissing = function() {
  return /** @type{?proto._SortedSetFetchResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetFetchResponse._Missing, 2));
};


/**
 * @param {?proto._SortedSetFetchResponse._Missing|undefined} value
 * @return {!proto._SortedSetFetchResponse} returns this
*/
proto._SortedSetFetchResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SortedSetFetchResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetFetchResponse} returns this
 */
proto._SortedSetFetchResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetFetchResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SortedSetGetScoreRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetScoreRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetScoreRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetScoreRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    valuesList: msg.getValuesList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetScoreRequest}
 */
proto._SortedSetGetScoreRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetScoreRequest;
  return proto._SortedSetGetScoreRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetScoreRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetScoreRequest}
 */
proto._SortedSetGetScoreRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetScoreRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetScoreRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetScoreRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getValuesList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      2,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SortedSetGetScoreRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SortedSetGetScoreRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SortedSetGetScoreRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetGetScoreRequest} returns this
 */
proto._SortedSetGetScoreRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * repeated bytes values = 2;
 * @return {!Array<string>}
 */
proto._SortedSetGetScoreRequest.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * repeated bytes values = 2;
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<string>}
 */
proto._SortedSetGetScoreRequest.prototype.getValuesList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getValuesList()));
};


/**
 * repeated bytes values = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SortedSetGetScoreRequest.prototype.getValuesList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getValuesList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SortedSetGetScoreRequest} returns this
 */
proto._SortedSetGetScoreRequest.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SortedSetGetScoreRequest} returns this
 */
proto._SortedSetGetScoreRequest.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SortedSetGetScoreRequest} returns this
 */
proto._SortedSetGetScoreRequest.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetGetScoreResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SortedSetGetScoreResponse.SortedSetCase = {
  SORTED_SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SortedSetGetScoreResponse.SortedSetCase}
 */
proto._SortedSetGetScoreResponse.prototype.getSortedSetCase = function() {
  return /** @type {proto._SortedSetGetScoreResponse.SortedSetCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetGetScoreResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetScoreResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetScoreResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetScoreResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SortedSetGetScoreResponse._SortedSetFound.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SortedSetGetScoreResponse._SortedSetMissing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetScoreResponse}
 */
proto._SortedSetGetScoreResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetScoreResponse;
  return proto._SortedSetGetScoreResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetScoreResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetScoreResponse}
 */
proto._SortedSetGetScoreResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SortedSetGetScoreResponse._SortedSetFound;
      reader.readMessage(value,proto._SortedSetGetScoreResponse._SortedSetFound.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SortedSetGetScoreResponse._SortedSetMissing;
      reader.readMessage(value,proto._SortedSetGetScoreResponse._SortedSetMissing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetScoreResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetScoreResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetScoreResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SortedSetGetScoreResponse._SortedSetFound.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SortedSetGetScoreResponse._SortedSetMissing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart}
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart;
  return proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart}
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ECacheResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional ECacheResult result = 1;
 * @return {!proto.ECacheResult}
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.getResult = function() {
  return /** @type {!proto.ECacheResult} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ECacheResult} value
 * @return {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart} returns this
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double score = 2;
 * @return {number}
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart} returns this
 */
proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SortedSetGetScoreResponse._SortedSetFound.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetScoreResponse._SortedSetFound.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetScoreResponse._SortedSetFound.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetScoreResponse._SortedSetFound} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreResponse._SortedSetFound.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementsList: jspb.Message.toObjectList(msg.getElementsList(),
    proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetScoreResponse._SortedSetFound}
 */
proto._SortedSetGetScoreResponse._SortedSetFound.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetScoreResponse._SortedSetFound;
  return proto._SortedSetGetScoreResponse._SortedSetFound.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetScoreResponse._SortedSetFound} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetScoreResponse._SortedSetFound}
 */
proto._SortedSetGetScoreResponse._SortedSetFound.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart;
      reader.readMessage(value,proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.deserializeBinaryFromReader);
      msg.addElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetScoreResponse._SortedSetFound.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetScoreResponse._SortedSetFound.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetScoreResponse._SortedSetFound} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreResponse._SortedSetFound.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.serializeBinaryToWriter
    );
  }
};


/**
 * repeated _SortedSetGetScoreResponsePart elements = 1;
 * @return {!Array<!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart>}
 */
proto._SortedSetGetScoreResponse._SortedSetFound.prototype.getElementsList = function() {
  return /** @type{!Array<!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart, 1));
};


/**
 * @param {!Array<!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart>} value
 * @return {!proto._SortedSetGetScoreResponse._SortedSetFound} returns this
*/
proto._SortedSetGetScoreResponse._SortedSetFound.prototype.setElementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart=} opt_value
 * @param {number=} opt_index
 * @return {!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart}
 */
proto._SortedSetGetScoreResponse._SortedSetFound.prototype.addElements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SortedSetGetScoreResponse._SortedSetFound} returns this
 */
proto._SortedSetGetScoreResponse._SortedSetFound.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetScoreResponse._SortedSetMissing.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetScoreResponse._SortedSetMissing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetScoreResponse._SortedSetMissing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreResponse._SortedSetMissing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetScoreResponse._SortedSetMissing}
 */
proto._SortedSetGetScoreResponse._SortedSetMissing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetScoreResponse._SortedSetMissing;
  return proto._SortedSetGetScoreResponse._SortedSetMissing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetScoreResponse._SortedSetMissing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetScoreResponse._SortedSetMissing}
 */
proto._SortedSetGetScoreResponse._SortedSetMissing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetScoreResponse._SortedSetMissing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetScoreResponse._SortedSetMissing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetScoreResponse._SortedSetMissing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetScoreResponse._SortedSetMissing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _SortedSetFound found = 1;
 * @return {?proto._SortedSetGetScoreResponse._SortedSetFound}
 */
proto._SortedSetGetScoreResponse.prototype.getFound = function() {
  return /** @type{?proto._SortedSetGetScoreResponse._SortedSetFound} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetGetScoreResponse._SortedSetFound, 1));
};


/**
 * @param {?proto._SortedSetGetScoreResponse._SortedSetFound|undefined} value
 * @return {!proto._SortedSetGetScoreResponse} returns this
*/
proto._SortedSetGetScoreResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SortedSetGetScoreResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetGetScoreResponse} returns this
 */
proto._SortedSetGetScoreResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetGetScoreResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _SortedSetMissing missing = 2;
 * @return {?proto._SortedSetGetScoreResponse._SortedSetMissing}
 */
proto._SortedSetGetScoreResponse.prototype.getMissing = function() {
  return /** @type{?proto._SortedSetGetScoreResponse._SortedSetMissing} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetGetScoreResponse._SortedSetMissing, 2));
};


/**
 * @param {?proto._SortedSetGetScoreResponse._SortedSetMissing|undefined} value
 * @return {!proto._SortedSetGetScoreResponse} returns this
*/
proto._SortedSetGetScoreResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SortedSetGetScoreResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetGetScoreResponse} returns this
 */
proto._SortedSetGetScoreResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetGetScoreResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetRemoveRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto._SortedSetRemoveRequest.RemoveElementsCase = {
  REMOVE_ELEMENTS_NOT_SET: 0,
  ALL: 2,
  SOME: 3
};

/**
 * @return {proto._SortedSetRemoveRequest.RemoveElementsCase}
 */
proto._SortedSetRemoveRequest.prototype.getRemoveElementsCase = function() {
  return /** @type {proto._SortedSetRemoveRequest.RemoveElementsCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetRemoveRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetRemoveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetRemoveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetRemoveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetRemoveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    all: (f = msg.getAll()) && proto._SortedSetRemoveRequest._All.toObject(includeInstance, f),
    some: (f = msg.getSome()) && proto._SortedSetRemoveRequest._Some.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetRemoveRequest}
 */
proto._SortedSetRemoveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetRemoveRequest;
  return proto._SortedSetRemoveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetRemoveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetRemoveRequest}
 */
proto._SortedSetRemoveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = new proto._SortedSetRemoveRequest._All;
      reader.readMessage(value,proto._SortedSetRemoveRequest._All.deserializeBinaryFromReader);
      msg.setAll(value);
      break;
    case 3:
      var value = new proto._SortedSetRemoveRequest._Some;
      reader.readMessage(value,proto._SortedSetRemoveRequest._Some.deserializeBinaryFromReader);
      msg.setSome(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetRemoveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetRemoveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetRemoveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetRemoveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getAll();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SortedSetRemoveRequest._All.serializeBinaryToWriter
    );
  }
  f = message.getSome();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto._SortedSetRemoveRequest._Some.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetRemoveRequest._All.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetRemoveRequest._All.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetRemoveRequest._All} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetRemoveRequest._All.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetRemoveRequest._All}
 */
proto._SortedSetRemoveRequest._All.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetRemoveRequest._All;
  return proto._SortedSetRemoveRequest._All.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetRemoveRequest._All} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetRemoveRequest._All}
 */
proto._SortedSetRemoveRequest._All.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetRemoveRequest._All.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetRemoveRequest._All.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetRemoveRequest._All} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetRemoveRequest._All.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto._SortedSetRemoveRequest._Some.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetRemoveRequest._Some.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetRemoveRequest._Some.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetRemoveRequest._Some} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetRemoveRequest._Some.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: msg.getValuesList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetRemoveRequest._Some}
 */
proto._SortedSetRemoveRequest._Some.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetRemoveRequest._Some;
  return proto._SortedSetRemoveRequest._Some.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetRemoveRequest._Some} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetRemoveRequest._Some}
 */
proto._SortedSetRemoveRequest._Some.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetRemoveRequest._Some.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetRemoveRequest._Some.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetRemoveRequest._Some} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetRemoveRequest._Some.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes values = 1;
 * @return {!Array<string>}
 */
proto._SortedSetRemoveRequest._Some.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes values = 1;
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<string>}
 */
proto._SortedSetRemoveRequest._Some.prototype.getValuesList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getValuesList()));
};


/**
 * repeated bytes values = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<!Uint8Array>}
 */
proto._SortedSetRemoveRequest._Some.prototype.getValuesList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getValuesList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto._SortedSetRemoveRequest._Some} returns this
 */
proto._SortedSetRemoveRequest._Some.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto._SortedSetRemoveRequest._Some} returns this
 */
proto._SortedSetRemoveRequest._Some.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto._SortedSetRemoveRequest._Some} returns this
 */
proto._SortedSetRemoveRequest._Some.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SortedSetRemoveRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SortedSetRemoveRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SortedSetRemoveRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetRemoveRequest} returns this
 */
proto._SortedSetRemoveRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional _All all = 2;
 * @return {?proto._SortedSetRemoveRequest._All}
 */
proto._SortedSetRemoveRequest.prototype.getAll = function() {
  return /** @type{?proto._SortedSetRemoveRequest._All} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetRemoveRequest._All, 2));
};


/**
 * @param {?proto._SortedSetRemoveRequest._All|undefined} value
 * @return {!proto._SortedSetRemoveRequest} returns this
*/
proto._SortedSetRemoveRequest.prototype.setAll = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SortedSetRemoveRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetRemoveRequest} returns this
 */
proto._SortedSetRemoveRequest.prototype.clearAll = function() {
  return this.setAll(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetRemoveRequest.prototype.hasAll = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional _Some some = 3;
 * @return {?proto._SortedSetRemoveRequest._Some}
 */
proto._SortedSetRemoveRequest.prototype.getSome = function() {
  return /** @type{?proto._SortedSetRemoveRequest._Some} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetRemoveRequest._Some, 3));
};


/**
 * @param {?proto._SortedSetRemoveRequest._Some|undefined} value
 * @return {!proto._SortedSetRemoveRequest} returns this
*/
proto._SortedSetRemoveRequest.prototype.setSome = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto._SortedSetRemoveRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetRemoveRequest} returns this
 */
proto._SortedSetRemoveRequest.prototype.clearSome = function() {
  return this.setSome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetRemoveRequest.prototype.hasSome = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetRemoveResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetRemoveResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetRemoveResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetRemoveResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetRemoveResponse}
 */
proto._SortedSetRemoveResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetRemoveResponse;
  return proto._SortedSetRemoveResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetRemoveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetRemoveResponse}
 */
proto._SortedSetRemoveResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetRemoveResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetRemoveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetRemoveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetRemoveResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetIncrementRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetIncrementRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetIncrementRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetIncrementRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    value: msg.getValue_asB64(),
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    ttlMilliseconds: jspb.Message.getFieldWithDefault(msg, 4, 0),
    refreshTtl: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetIncrementRequest}
 */
proto._SortedSetIncrementRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetIncrementRequest;
  return proto._SortedSetIncrementRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetIncrementRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetIncrementRequest}
 */
proto._SortedSetIncrementRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTtlMilliseconds(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshTtl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetIncrementRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetIncrementRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetIncrementRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetIncrementRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getValue_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTtlMilliseconds();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getRefreshTtl();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SortedSetIncrementRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SortedSetIncrementRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SortedSetIncrementRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetIncrementRequest} returns this
 */
proto._SortedSetIncrementRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes value = 2;
 * @return {string}
 */
proto._SortedSetIncrementRequest.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes value = 2;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */
proto._SortedSetIncrementRequest.prototype.getValue_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getValue()));
};


/**
 * optional bytes value = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */
proto._SortedSetIncrementRequest.prototype.getValue_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getValue()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetIncrementRequest} returns this
 */
proto._SortedSetIncrementRequest.prototype.setValue = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional double amount = 3;
 * @return {number}
 */
proto._SortedSetIncrementRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetIncrementRequest} returns this
 */
proto._SortedSetIncrementRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional uint64 ttl_milliseconds = 4;
 * @return {number}
 */
proto._SortedSetIncrementRequest.prototype.getTtlMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetIncrementRequest} returns this
 */
proto._SortedSetIncrementRequest.prototype.setTtlMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool refresh_ttl = 5;
 * @return {boolean}
 */
proto._SortedSetIncrementRequest.prototype.getRefreshTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto._SortedSetIncrementRequest} returns this
 */
proto._SortedSetIncrementRequest.prototype.setRefreshTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetIncrementResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetIncrementResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetIncrementResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetIncrementResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetIncrementResponse}
 */
proto._SortedSetIncrementResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetIncrementResponse;
  return proto._SortedSetIncrementResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetIncrementResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetIncrementResponse}
 */
proto._SortedSetIncrementResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetIncrementResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetIncrementResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetIncrementResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetIncrementResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double score = 1;
 * @return {number}
 */
proto._SortedSetIncrementResponse.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetIncrementResponse} returns this
 */
proto._SortedSetIncrementResponse.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetRankRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetRankRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetRankRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetRankRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    value: msg.getValue_asB64(),
    order: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetRankRequest}
 */
proto._SortedSetGetRankRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetRankRequest;
  return proto._SortedSetGetRankRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetRankRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetRankRequest}
 */
proto._SortedSetGetRankRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {!proto._SortedSetGetRankRequest.Order} */ (reader.readEnum());
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetRankRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetRankRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetRankRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetRankRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getValue_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto._SortedSetGetRankRequest.Order = {
  ASCENDING: 0,
  DESCENDING: 1
};

/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SortedSetGetRankRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SortedSetGetRankRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SortedSetGetRankRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetGetRankRequest} returns this
 */
proto._SortedSetGetRankRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes value = 2;
 * @return {string}
 */
proto._SortedSetGetRankRequest.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes value = 2;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */
proto._SortedSetGetRankRequest.prototype.getValue_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getValue()));
};


/**
 * optional bytes value = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */
proto._SortedSetGetRankRequest.prototype.getValue_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getValue()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetGetRankRequest} returns this
 */
proto._SortedSetGetRankRequest.prototype.setValue = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional Order order = 3;
 * @return {!proto._SortedSetGetRankRequest.Order}
 */
proto._SortedSetGetRankRequest.prototype.getOrder = function() {
  return /** @type {!proto._SortedSetGetRankRequest.Order} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto._SortedSetGetRankRequest.Order} value
 * @return {!proto._SortedSetGetRankRequest} returns this
 */
proto._SortedSetGetRankRequest.prototype.setOrder = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetGetRankResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SortedSetGetRankResponse.RankCase = {
  RANK_NOT_SET: 0,
  ELEMENT_RANK: 1,
  MISSING: 2
};

/**
 * @return {proto._SortedSetGetRankResponse.RankCase}
 */
proto._SortedSetGetRankResponse.prototype.getRankCase = function() {
  return /** @type {proto._SortedSetGetRankResponse.RankCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetGetRankResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetRankResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetRankResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetRankResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetRankResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementRank: (f = msg.getElementRank()) && proto._SortedSetGetRankResponse._RankResponsePart.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SortedSetGetRankResponse._SortedSetMissing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetRankResponse}
 */
proto._SortedSetGetRankResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetRankResponse;
  return proto._SortedSetGetRankResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetRankResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetRankResponse}
 */
proto._SortedSetGetRankResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SortedSetGetRankResponse._RankResponsePart;
      reader.readMessage(value,proto._SortedSetGetRankResponse._RankResponsePart.deserializeBinaryFromReader);
      msg.setElementRank(value);
      break;
    case 2:
      var value = new proto._SortedSetGetRankResponse._SortedSetMissing;
      reader.readMessage(value,proto._SortedSetGetRankResponse._SortedSetMissing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetRankResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetRankResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetRankResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetRankResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementRank();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SortedSetGetRankResponse._RankResponsePart.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SortedSetGetRankResponse._SortedSetMissing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetRankResponse._RankResponsePart.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetRankResponse._RankResponsePart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetRankResponse._RankResponsePart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetRankResponse._RankResponsePart.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetRankResponse._RankResponsePart}
 */
proto._SortedSetGetRankResponse._RankResponsePart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetRankResponse._RankResponsePart;
  return proto._SortedSetGetRankResponse._RankResponsePart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetRankResponse._RankResponsePart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetRankResponse._RankResponsePart}
 */
proto._SortedSetGetRankResponse._RankResponsePart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ECacheResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetRankResponse._RankResponsePart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetRankResponse._RankResponsePart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetRankResponse._RankResponsePart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetRankResponse._RankResponsePart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional ECacheResult result = 1;
 * @return {!proto.ECacheResult}
 */
proto._SortedSetGetRankResponse._RankResponsePart.prototype.getResult = function() {
  return /** @type {!proto.ECacheResult} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ECacheResult} value
 * @return {!proto._SortedSetGetRankResponse._RankResponsePart} returns this
 */
proto._SortedSetGetRankResponse._RankResponsePart.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint64 rank = 2;
 * @return {number}
 */
proto._SortedSetGetRankResponse._RankResponsePart.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetGetRankResponse._RankResponsePart} returns this
 */
proto._SortedSetGetRankResponse._RankResponsePart.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetGetRankResponse._SortedSetMissing.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetGetRankResponse._SortedSetMissing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetGetRankResponse._SortedSetMissing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetRankResponse._SortedSetMissing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetGetRankResponse._SortedSetMissing}
 */
proto._SortedSetGetRankResponse._SortedSetMissing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetGetRankResponse._SortedSetMissing;
  return proto._SortedSetGetRankResponse._SortedSetMissing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetGetRankResponse._SortedSetMissing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetGetRankResponse._SortedSetMissing}
 */
proto._SortedSetGetRankResponse._SortedSetMissing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetGetRankResponse._SortedSetMissing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetGetRankResponse._SortedSetMissing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetGetRankResponse._SortedSetMissing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetGetRankResponse._SortedSetMissing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _RankResponsePart element_rank = 1;
 * @return {?proto._SortedSetGetRankResponse._RankResponsePart}
 */
proto._SortedSetGetRankResponse.prototype.getElementRank = function() {
  return /** @type{?proto._SortedSetGetRankResponse._RankResponsePart} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetGetRankResponse._RankResponsePart, 1));
};


/**
 * @param {?proto._SortedSetGetRankResponse._RankResponsePart|undefined} value
 * @return {!proto._SortedSetGetRankResponse} returns this
*/
proto._SortedSetGetRankResponse.prototype.setElementRank = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SortedSetGetRankResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetGetRankResponse} returns this
 */
proto._SortedSetGetRankResponse.prototype.clearElementRank = function() {
  return this.setElementRank(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetGetRankResponse.prototype.hasElementRank = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _SortedSetMissing missing = 2;
 * @return {?proto._SortedSetGetRankResponse._SortedSetMissing}
 */
proto._SortedSetGetRankResponse.prototype.getMissing = function() {
  return /** @type{?proto._SortedSetGetRankResponse._SortedSetMissing} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetGetRankResponse._SortedSetMissing, 2));
};


/**
 * @param {?proto._SortedSetGetRankResponse._SortedSetMissing|undefined} value
 * @return {!proto._SortedSetGetRankResponse} returns this
*/
proto._SortedSetGetRankResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SortedSetGetRankResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetGetRankResponse} returns this
 */
proto._SortedSetGetRankResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetGetRankResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetLengthRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetLengthRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetLengthRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetLengthRequest}
 */
proto._SortedSetLengthRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetLengthRequest;
  return proto._SortedSetLengthRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetLengthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetLengthRequest}
 */
proto._SortedSetLengthRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetLengthRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetLengthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetLengthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SortedSetLengthRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SortedSetLengthRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SortedSetLengthRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetLengthRequest} returns this
 */
proto._SortedSetLengthRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetLengthResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SortedSetLengthResponse.SortedSetCase = {
  SORTED_SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SortedSetLengthResponse.SortedSetCase}
 */
proto._SortedSetLengthResponse.prototype.getSortedSetCase = function() {
  return /** @type {proto._SortedSetLengthResponse.SortedSetCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetLengthResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetLengthResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetLengthResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetLengthResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SortedSetLengthResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SortedSetLengthResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetLengthResponse}
 */
proto._SortedSetLengthResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetLengthResponse;
  return proto._SortedSetLengthResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetLengthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetLengthResponse}
 */
proto._SortedSetLengthResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SortedSetLengthResponse._Found;
      reader.readMessage(value,proto._SortedSetLengthResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SortedSetLengthResponse._Missing;
      reader.readMessage(value,proto._SortedSetLengthResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetLengthResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetLengthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetLengthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SortedSetLengthResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SortedSetLengthResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetLengthResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetLengthResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetLengthResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    length: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetLengthResponse._Found}
 */
proto._SortedSetLengthResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetLengthResponse._Found;
  return proto._SortedSetLengthResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetLengthResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetLengthResponse._Found}
 */
proto._SortedSetLengthResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetLengthResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetLengthResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetLengthResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 length = 1;
 * @return {number}
 */
proto._SortedSetLengthResponse._Found.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetLengthResponse._Found} returns this
 */
proto._SortedSetLengthResponse._Found.prototype.setLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetLengthResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetLengthResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetLengthResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetLengthResponse._Missing}
 */
proto._SortedSetLengthResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetLengthResponse._Missing;
  return proto._SortedSetLengthResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetLengthResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetLengthResponse._Missing}
 */
proto._SortedSetLengthResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetLengthResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetLengthResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetLengthResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._SortedSetLengthResponse._Found}
 */
proto._SortedSetLengthResponse.prototype.getFound = function() {
  return /** @type{?proto._SortedSetLengthResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetLengthResponse._Found, 1));
};


/**
 * @param {?proto._SortedSetLengthResponse._Found|undefined} value
 * @return {!proto._SortedSetLengthResponse} returns this
*/
proto._SortedSetLengthResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SortedSetLengthResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetLengthResponse} returns this
 */
proto._SortedSetLengthResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._SortedSetLengthResponse._Missing}
 */
proto._SortedSetLengthResponse.prototype.getMissing = function() {
  return /** @type{?proto._SortedSetLengthResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetLengthResponse._Missing, 2));
};


/**
 * @param {?proto._SortedSetLengthResponse._Missing|undefined} value
 * @return {!proto._SortedSetLengthResponse} returns this
*/
proto._SortedSetLengthResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SortedSetLengthResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetLengthResponse} returns this
 */
proto._SortedSetLengthResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetLengthByScoreRequest.oneofGroups_ = [[2,3,4],[5,6,7]];

/**
 * @enum {number}
 */
proto._SortedSetLengthByScoreRequest.MinCase = {
  MIN_NOT_SET: 0,
  INCLUSIVE_MIN: 2,
  EXCLUSIVE_MIN: 3,
  UNBOUNDED_MIN: 4
};

/**
 * @return {proto._SortedSetLengthByScoreRequest.MinCase}
 */
proto._SortedSetLengthByScoreRequest.prototype.getMinCase = function() {
  return /** @type {proto._SortedSetLengthByScoreRequest.MinCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetLengthByScoreRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto._SortedSetLengthByScoreRequest.MaxCase = {
  MAX_NOT_SET: 0,
  INCLUSIVE_MAX: 5,
  EXCLUSIVE_MAX: 6,
  UNBOUNDED_MAX: 7
};

/**
 * @return {proto._SortedSetLengthByScoreRequest.MaxCase}
 */
proto._SortedSetLengthByScoreRequest.prototype.getMaxCase = function() {
  return /** @type {proto._SortedSetLengthByScoreRequest.MaxCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetLengthByScoreRequest.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetLengthByScoreRequest.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetLengthByScoreRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetLengthByScoreRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthByScoreRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: msg.getSetName_asB64(),
    inclusiveMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    exclusiveMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    unboundedMin: (f = msg.getUnboundedMin()) && proto._Unbounded.toObject(includeInstance, f),
    inclusiveMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    exclusiveMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    unboundedMax: (f = msg.getUnboundedMax()) && proto._Unbounded.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetLengthByScoreRequest}
 */
proto._SortedSetLengthByScoreRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetLengthByScoreRequest;
  return proto._SortedSetLengthByScoreRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetLengthByScoreRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetLengthByScoreRequest}
 */
proto._SortedSetLengthByScoreRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInclusiveMin(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExclusiveMin(value);
      break;
    case 4:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedMin(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInclusiveMax(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExclusiveMax(value);
      break;
    case 7:
      var value = new proto._Unbounded;
      reader.readMessage(value,proto._Unbounded.deserializeBinaryFromReader);
      msg.setUnboundedMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetLengthByScoreRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetLengthByScoreRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetLengthByScoreRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthByScoreRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getUnboundedMin();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getUnboundedMax();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto._Unbounded.serializeBinaryToWriter
    );
  }
};


/**
 * optional bytes set_name = 1;
 * @return {string}
 */
proto._SortedSetLengthByScoreRequest.prototype.getSetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes set_name = 1;
 * This is a type-conversion wrapper around `getSetName()`
 * @return {string}
 */
proto._SortedSetLengthByScoreRequest.prototype.getSetName_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetName()));
};


/**
 * optional bytes set_name = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetName()`
 * @return {!Uint8Array}
 */
proto._SortedSetLengthByScoreRequest.prototype.getSetName_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetName()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.setSetName = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional double inclusive_min = 2;
 * @return {number}
 */
proto._SortedSetLengthByScoreRequest.prototype.getInclusiveMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.setInclusiveMin = function(value) {
  return jspb.Message.setOneofField(this, 2, proto._SortedSetLengthByScoreRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.clearInclusiveMin = function() {
  return jspb.Message.setOneofField(this, 2, proto._SortedSetLengthByScoreRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthByScoreRequest.prototype.hasInclusiveMin = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double exclusive_min = 3;
 * @return {number}
 */
proto._SortedSetLengthByScoreRequest.prototype.getExclusiveMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.setExclusiveMin = function(value) {
  return jspb.Message.setOneofField(this, 3, proto._SortedSetLengthByScoreRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.clearExclusiveMin = function() {
  return jspb.Message.setOneofField(this, 3, proto._SortedSetLengthByScoreRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthByScoreRequest.prototype.hasExclusiveMin = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional _Unbounded unbounded_min = 4;
 * @return {?proto._Unbounded}
 */
proto._SortedSetLengthByScoreRequest.prototype.getUnboundedMin = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 4));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
*/
proto._SortedSetLengthByScoreRequest.prototype.setUnboundedMin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto._SortedSetLengthByScoreRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.clearUnboundedMin = function() {
  return this.setUnboundedMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthByScoreRequest.prototype.hasUnboundedMin = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional double inclusive_max = 5;
 * @return {number}
 */
proto._SortedSetLengthByScoreRequest.prototype.getInclusiveMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.setInclusiveMax = function(value) {
  return jspb.Message.setOneofField(this, 5, proto._SortedSetLengthByScoreRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.clearInclusiveMax = function() {
  return jspb.Message.setOneofField(this, 5, proto._SortedSetLengthByScoreRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthByScoreRequest.prototype.hasInclusiveMax = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional double exclusive_max = 6;
 * @return {number}
 */
proto._SortedSetLengthByScoreRequest.prototype.getExclusiveMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.setExclusiveMax = function(value) {
  return jspb.Message.setOneofField(this, 6, proto._SortedSetLengthByScoreRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.clearExclusiveMax = function() {
  return jspb.Message.setOneofField(this, 6, proto._SortedSetLengthByScoreRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthByScoreRequest.prototype.hasExclusiveMax = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional _Unbounded unbounded_max = 7;
 * @return {?proto._Unbounded}
 */
proto._SortedSetLengthByScoreRequest.prototype.getUnboundedMax = function() {
  return /** @type{?proto._Unbounded} */ (
    jspb.Message.getWrapperField(this, proto._Unbounded, 7));
};


/**
 * @param {?proto._Unbounded|undefined} value
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
*/
proto._SortedSetLengthByScoreRequest.prototype.setUnboundedMax = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto._SortedSetLengthByScoreRequest.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetLengthByScoreRequest} returns this
 */
proto._SortedSetLengthByScoreRequest.prototype.clearUnboundedMax = function() {
  return this.setUnboundedMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthByScoreRequest.prototype.hasUnboundedMax = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto._SortedSetLengthByScoreResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto._SortedSetLengthByScoreResponse.SortedSetCase = {
  SORTED_SET_NOT_SET: 0,
  FOUND: 1,
  MISSING: 2
};

/**
 * @return {proto._SortedSetLengthByScoreResponse.SortedSetCase}
 */
proto._SortedSetLengthByScoreResponse.prototype.getSortedSetCase = function() {
  return /** @type {proto._SortedSetLengthByScoreResponse.SortedSetCase} */(jspb.Message.computeOneofCase(this, proto._SortedSetLengthByScoreResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetLengthByScoreResponse.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetLengthByScoreResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetLengthByScoreResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthByScoreResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: (f = msg.getFound()) && proto._SortedSetLengthByScoreResponse._Found.toObject(includeInstance, f),
    missing: (f = msg.getMissing()) && proto._SortedSetLengthByScoreResponse._Missing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetLengthByScoreResponse}
 */
proto._SortedSetLengthByScoreResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetLengthByScoreResponse;
  return proto._SortedSetLengthByScoreResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetLengthByScoreResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetLengthByScoreResponse}
 */
proto._SortedSetLengthByScoreResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto._SortedSetLengthByScoreResponse._Found;
      reader.readMessage(value,proto._SortedSetLengthByScoreResponse._Found.deserializeBinaryFromReader);
      msg.setFound(value);
      break;
    case 2:
      var value = new proto._SortedSetLengthByScoreResponse._Missing;
      reader.readMessage(value,proto._SortedSetLengthByScoreResponse._Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetLengthByScoreResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetLengthByScoreResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetLengthByScoreResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthByScoreResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto._SortedSetLengthByScoreResponse._Found.serializeBinaryToWriter
    );
  }
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto._SortedSetLengthByScoreResponse._Missing.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetLengthByScoreResponse._Found.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetLengthByScoreResponse._Found.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetLengthByScoreResponse._Found} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthByScoreResponse._Found.toObject = function(includeInstance, msg) {
  var f, obj = {
    length: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetLengthByScoreResponse._Found}
 */
proto._SortedSetLengthByScoreResponse._Found.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetLengthByScoreResponse._Found;
  return proto._SortedSetLengthByScoreResponse._Found.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetLengthByScoreResponse._Found} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetLengthByScoreResponse._Found}
 */
proto._SortedSetLengthByScoreResponse._Found.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetLengthByScoreResponse._Found.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetLengthByScoreResponse._Found.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetLengthByScoreResponse._Found} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthByScoreResponse._Found.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLength();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 length = 1;
 * @return {number}
 */
proto._SortedSetLengthByScoreResponse._Found.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto._SortedSetLengthByScoreResponse._Found} returns this
 */
proto._SortedSetLengthByScoreResponse._Found.prototype.setLength = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto._SortedSetLengthByScoreResponse._Missing.prototype.toObject = function(opt_includeInstance) {
  return proto._SortedSetLengthByScoreResponse._Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto._SortedSetLengthByScoreResponse._Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthByScoreResponse._Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto._SortedSetLengthByScoreResponse._Missing}
 */
proto._SortedSetLengthByScoreResponse._Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto._SortedSetLengthByScoreResponse._Missing;
  return proto._SortedSetLengthByScoreResponse._Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto._SortedSetLengthByScoreResponse._Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto._SortedSetLengthByScoreResponse._Missing}
 */
proto._SortedSetLengthByScoreResponse._Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto._SortedSetLengthByScoreResponse._Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto._SortedSetLengthByScoreResponse._Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto._SortedSetLengthByScoreResponse._Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto._SortedSetLengthByScoreResponse._Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional _Found found = 1;
 * @return {?proto._SortedSetLengthByScoreResponse._Found}
 */
proto._SortedSetLengthByScoreResponse.prototype.getFound = function() {
  return /** @type{?proto._SortedSetLengthByScoreResponse._Found} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetLengthByScoreResponse._Found, 1));
};


/**
 * @param {?proto._SortedSetLengthByScoreResponse._Found|undefined} value
 * @return {!proto._SortedSetLengthByScoreResponse} returns this
*/
proto._SortedSetLengthByScoreResponse.prototype.setFound = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto._SortedSetLengthByScoreResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetLengthByScoreResponse} returns this
 */
proto._SortedSetLengthByScoreResponse.prototype.clearFound = function() {
  return this.setFound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthByScoreResponse.prototype.hasFound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional _Missing missing = 2;
 * @return {?proto._SortedSetLengthByScoreResponse._Missing}
 */
proto._SortedSetLengthByScoreResponse.prototype.getMissing = function() {
  return /** @type{?proto._SortedSetLengthByScoreResponse._Missing} */ (
    jspb.Message.getWrapperField(this, proto._SortedSetLengthByScoreResponse._Missing, 2));
};


/**
 * @param {?proto._SortedSetLengthByScoreResponse._Missing|undefined} value
 * @return {!proto._SortedSetLengthByScoreResponse} returns this
*/
proto._SortedSetLengthByScoreResponse.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto._SortedSetLengthByScoreResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto._SortedSetLengthByScoreResponse} returns this
 */
proto._SortedSetLengthByScoreResponse.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto._SortedSetLengthByScoreResponse.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.ECacheResult = {
  INVALID: 0,
  OK: 1,
  HIT: 2,
  MISS: 3
};

goog.object.extend(exports, proto);
